// Walleva custom scripts
// Rule: add new features here, never inline in theme.liquid or page content.

// ── SKU guide popups ─────────────────────────────────────────────────────────
// Creates a full-screen modal for each product's "Find your SKU" link.
// Triggered via event delegation on document — works regardless of tab state.
(function () {
  var MODALS = [
    {
      id:   'we008-3985-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar EV Path model codes (115)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar EV Path</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9208-G238, OO9208-6638, 1-872, OO9208-6038, OO9208-F438, OO9208-E138, OO9208-E238, OO9208-C738, 1-882, OO9208-14, OO9208-A238, OO9208CP, OO9208-8238, OO9208-41, OO9208-5938, OO9208-D338, OO9208-C538, OO9208-A038, OO9208-01, OO9208-12, OO9208-11, OO9208-5138, OO9208-28, OO9208-5538, OO9208-F038, OO9208-30, OO9208-E038, OO9208-4638, OO9208-E338, OO9208-9638, OO9208-9738, OO9208-9538, OO9208-29, OO9208-C038, OO9208-A438, OO9208-C638, OO9208-B938, OO9208-G138, OO9208-E438, OO9208-F638, OO9208-F838, OO9208-F738, OO9208-F338, OO9208-C338, OO9208-F138, OO9208-D238, OO9208-10, OO9208-E738, OO9208-09, OO9208-E538, OO9208-5038, OO9208-7638, OO9208-A338, OO9208-C238, OO9208-06, OO9208-5438, OO9208-F938, OO9208-A638, OO9208-A738, OO9208-A838, OO9208-A938, OO9208-B038, OO9208-B138, OO9208-B238, OO9208-B338, OO9208-B438, OO9208-B538, OO9208-B638, OO9208-F538, OO9208-21, OO9208-07, OO9208-19, OO9208-15, OO9208-C938, OO9208-5238, OO9208-44, OO9208-5838, OO9208-04, OO9208-20, OO9208-18, OO9208-16, OO9208-4838, OO9208-9438, OO9208-7138, OO9208-6538, OO9208-05, OO9208-7238, OO9208-7338, OO9208-5738, OO9208-4738, OO9208-17, OO9208-C138, OO9208-D138, OO9208-08, OO9208-4938, OO9208-D538, OO9208-E638, OO9208-C838, OO9208-02, OO9208-31, OO9208-03, OO9208-D838, OO9208-D938, OO9208-D738, OO9208-7538, OO9208-7838, OO9208-13, OO9208-A138, OO9208-E838, OO9208-42, OO9208-43, OO9208-D038, OO9208-9138, OO9208-5338, OO9208-6938</p>'
    },

    {
      id:   'we007-2626-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Range model codes (12)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Range</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">09-665, 09-668, 09-688, 09-664, 11-471, 53-096, 53-097, 09-669, 09-666, 09-697, 09-667, OO9051-1433</p>'
    },
    {
      id:   'we007-2628-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Pitch model codes (36)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Pitch</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">42-557, OO9052-04, 24-154, 09-724, 09-680, 09-719, 09-676, 09-681, 09-727, 26-217, 09-679, 42-559, 09-677, 09-678, 09-728, 09-764, 09-784, 24-241, OO9052-02, 09-723, 26-216, 24-098, 09-732, 09-726, 12-779, 09-763, 24-135, 24-139, 24-136, 24-138, 24-137, 09-725, 42-307, OO9052-03, 09-783, 24-155</p>'
    },

    {
      id:  'wl367-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl367-fit-photo-guide.jpg?v=1789488512',
      alt: 'How to find the SKU on your Smith Optics Lowdown XL 2 frame'
    },

    {
      id:  'wl347-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl347-fit-photo-guide.jpg?v=1789488514',
      alt: 'How to find the SKU on your Ray-Ban RB1971 Square (54mm) frame'
    },

    {
      id:  'wl134-sku-modal',
      src: '',
      alt: 'How to find the SKU on your Oakley Jawbreaker frame'
    },
    {
      id:   'wl134-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9290 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Jawbreaker OO9290 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    
    
    {
      id:  'wl012-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl012.jpg?v=1783257777',
      alt: 'How to find the SKU on your Oakley Gascan (vented) frame'
    },

    {
      id:  'wl366-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl366-fit-photo-guide.jpg?v=1789488517',
      alt: 'How to find the SKU on your Smith Optics Lowdown 2 frame'
    },

    {
      id:  'wl364-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl364-fit-photo-guide.jpg?v=1789488520',
      alt: 'How to find the SKU on your Oakley Sutro Lite frame'
    },
    {
      id:   'wl364-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9463 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Sutro Lite OO9463 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl363-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl363-fit-photo-guide.jpg?v=1789488523',
      alt: 'How to find the SKU on your Oakley Sutro Low Bridge Fit frame'
    },
    {
      id:   'wl363-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9406A model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Sutro Low Bridge Fit OO9406A uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl362-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl362-fit-photo-guide.jpg?v=1789488526',
      alt: 'How to find the SKU on your Oakley Sutro S frame'
    },
    {
      id:   'wl362-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9462 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Sutro S OO9462 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl361-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl361-fit-photo-guide.jpg?v=1789488529',
      alt: 'How to find the SKU on your Oakley Castel frame'
    },
    {
      id:   'wl361-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9147 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Castel OO9147 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl330-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl330-fit-photo-guide.jpg?v=1789488531',
      alt: 'How to find the SKU on your Costa Del Mar Reefton frame'
    },

    {
      id:  'wl329-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl329-fit-photo-guide.jpg?v=1789488535',
      alt: 'How to find the SKU on your Costa Del Mar South Point frame'
    },

    {
      id:  'wl328-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl328-fit-photo-guide.jpg?v=1789488538',
      alt: 'How to find the SKU on your Costa Del Mar Rincon frame'
    },

    {
      id:  'wl327-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl327-fit-photo-guide.jpg?v=1789488541',
      alt: 'How to find the SKU on your Costa Del Mar Cat Cay frame'
    },

    {
      id:  'wl326-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl326-fit-photo-guide.jpg?v=1789488543',
      alt: 'How to find the SKU on your Costa Del Mar Ballast frame'
    },

    {
      id:  'wl325-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl325-fit-photo-guide.jpg?v=1789488546',
      alt: 'How to find the SKU on your Costa Del Mar Tuna Alley frame'
    },

    {
      id:  'wl324-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl324-fit-photo-guide.jpg?v=1789488549',
      alt: 'How to find the SKU on your Costa Del Mar Saltbreak frame'
    },

    {
      id:  'wl350-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl350-fit-photo-guide.jpg?v=1789488552',
      alt: 'How to find the SKU on your Costa Del Mar Rinconcito frame'
    },

    {
      id:  'wl323-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl323-fit-photo-guide.jpg?v=1789488555',
      alt: 'How to find the SKU on your Costa Del Mar Loreto frame'
    },

    {
      id:  'wl360-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl360-fit-photo-guide.jpg?v=1789488558',
      alt: 'How to find the SKU on your Oakley Turbine Rotor frame'
    },
    {
      id:   'wl360-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9307 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Turbine Rotor OO9307 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl349-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl349-fit-photo-guide.jpg?v=1789488560',
      alt: 'How to find the SKU on your Ray-Ban RB4165 Justin (51mm) frame'
    },

    {
      id:  'wl356-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl356-fit-photo-guide.jpg?v=1789488563',
      alt: 'How to find the SKU on your Oakley Holbrook Mix frame'
    },
    {
      id:   'wl356-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9384 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Holbrook Mix OO9384 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl353-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl353-fit-photo-guide.jpg?v=1789488566',
      alt: 'How to find the SKU on your Costa Del Mar Waterwoman frame'
    },

    {
      id:  'wl322-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl322-fit-photo-guide.jpg?v=1789488569',
      alt: 'How to find the SKU on your Costa Del Mar Caballito frame'
    },

    {
      id:  'wl359-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl359-fit-photo-guide.jpg?v=1789488572',
      alt: 'How to find the SKU on your Oakley Mainlink XL frame'
    },
    {
      id:   'wl359-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9264 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Mainlink XL OO9264 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl355-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl355-fit-photo-guide.jpg?v=1789488575',
      alt: 'How to find the SKU on your Costa Del Mar Jose frame'
    },

    {
      id:  'wl352-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl352-fit-photo-guide.jpg?v=1789488579',
      alt: 'How to find the SKU on your Costa Del Mar Gannet frame'
    },

    {
      id:  'wl321-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl321-fit-photo-guide.jpg?v=1789488584',
      alt: 'How to find the SKU on your Costa Del Mar Anaa frame'
    },

    {
      id:  'wl358-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl358-fit-photo-guide.jpg?v=1789488587',
      alt: 'How to find the SKU on your Oakley Gibston frame'
    },
    {
      id:   'wl358-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9449 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Gibston OO9449 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl340-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl340-fit-photo-guide.jpg?v=1789488590',
      alt: 'How to find the SKU on your Oakley Sylas (60mm) frame'
    },

    {
      id:  'wl354-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl354-fit-photo-guide.jpg?v=1789488592',
      alt: 'How to find the SKU on your Costa Del Mar Blackfin frame'
    },

    {
      id:  'wl351-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl351-fit-photo-guide.jpg?v=1789488595',
      alt: 'How to find the SKU on your Costa Del Mar Inlet frame'
    },

    {
      id:  'wl345-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl345-fit-photo-guide.jpg?v=1789488598',
      alt: 'How to find the SKU on your Ray-Ban RB3548N (54mm) frame'
    },

    {
      id:  'wl339-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl339-fit-photo-guide.jpg?v=1789488601',
      alt: 'How to find the SKU on your Oakley Sylas (57mm) frame'
    },

    {
      id:  'wl344-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl344-fit-photo-guide.jpg?v=1789488603',
      alt: 'How to find the SKU on your Ray-Ban RB3548N (51mm) frame'
    },

    {
      id:  'wl338-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL338.jpg?v=1783380220',
      alt: 'How to find the SKU on your Smith Optics Parallel 2 frame'
    },

    {
      id:  'wl337-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL337.jpg?v=1783380108',
      alt: 'How to find the SKU on your Smith Optics Parallel Max 2 frame'
    },

    {
      id:  'wl343-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl343-fit-photo-guide.jpg?v=1789488606',
      alt: 'How to find the SKU on your Ray-Ban RB3548N (48mm) frame'
    },

    
    {
      id:  'wl342-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl342-fit-photo-guide.jpg?v=1789488609',
      alt: 'How to find the SKU on your Oakley Clifden frame'
    },
    {
      id:   'wl342-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9440 model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley Clifden OO9440 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9440-0156, OO9440-0256, OO9440-0356, OO9440-0456, OO9440-0556, OO9440-0656, OO9440-0756, OO9440-0956, OO9440-1056, OO9440-1156, OO9440-1256, OO9440-1356, OO9440-1456, OO9440-1556, OO9440-1656, OO9440-1756, OO9440-1856, OO9440-1956, OO9440-2056, OO9440-2156, OO9440-2356, OO9440-2456, OO9440-2556, OO9440-2656</p>'
    },

    {
      id:  'wl335-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl335-fit-photo-guide.jpg?v=1789488612',
      alt: 'How to find the SKU on your Ray-Ban Stories Wayfarer RW4004 (53mm) frame'
    },

    {
      id:  'wl341-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl341-fit-photo-guide.jpg?v=1789488615',
      alt: 'How to find the SKU on your Oakley Portal X frame'
    },
    {
      id:   'wl341-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9460 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Portal X OO9460 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9460-0159, OO9460-0259, OO9460-0359, OO9460-0459, OO9460-0559, OO9460-0659, OO9460-1159, OO9460-1459, OO9460-1559, OO9460-1959, OO9460-2059</p>'
    },

    {
      id:  'wl334-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl334-fit-photo-guide.jpg?v=1789488653',
      alt: 'How to find the SKU on your Ray-Ban Stories Wayfarer RW4002 (50mm) frame'
    },

    {
      id:  'wl333-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl333-fit-photo-guide.jpg?v=1789488654',
      alt: 'How to find the SKU on your Costa Del Mar Gulf Shore frame'
    },

    {
      id:  'wl332-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl332-fit-photo-guide.jpg?v=1789488654',
      alt: 'How to find the SKU on your Costa Del Mar Cut frame'
    },

    {
      id:  'wl331-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl331-fit-photo-guide.jpg?v=1789488655',
      alt: 'How to find the SKU on your Costa Del Mar Permit frame'
    },

    {
      id:  'wl320-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl320-fit-photo-guide.jpg?v=1789488657',
      alt: 'How to find the SKU on your Oakley Split Shot frame'
    },
    {
      id:   'wl320-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9416 model codes (31)</h3><p style="margin:0 0 14px;">Every Oakley Split Shot OO9416 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9416-0164, OO9416-0264, OO9416-0364, OO9416-0464, OO9416-0564, OO9416-0664, OO9416-0764, OO9416-0864, OO9416-0964, OO9416-1064, OO9416-1164, OO9416-1264, OO9416-1364, OO9416-1464, OO9416-1564, OO9416-1664, OO9416-1764, OO9416-1864, OO9416-1964, OO9416-2064, OO9416-2464, OO9416-2964, OO9416-3064, OO9416-3164, OO9416-3264, OO9416-3364, OO9416-3464, OO9416-3564, OO9416-3764, OO9416-3864, OO9416-3964</p>'
    },

    {
      id:  'wl313-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl313-fit-photo-guide.jpg?v=1789488657',
      alt: 'How to find the SKU on your Maui Jim Makoa frame'
    },

    {
      id:  'wl317-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl317-fit-photo-guide.jpg?v=1789488658',
      alt: 'How to find the SKU on your Donahugh Designer frame'
    },

    {
      id:  'wl319-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl319-fit-photo-guide.jpg?v=1789488657',
      alt: 'How to find the SKU on your Oakley Radar EV Path frame'
    },
    {
      id:   'wl319-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9208 model codes (113)</h3><p style="margin:0 0 14px;">Every Oakley Radar EV Path OO9208 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9208-01, OO9208-02, OO9208-03, OO9208-04, OO9208-05, OO9208-06, OO9208-07, OO9208-08, OO9208-09, OO9208-10, OO9208-11, OO9208-12, OO9208-13, OO9208-14, OO9208-15, OO9208-16, OO9208-17, OO9208-18, OO9208-19, OO9208-20, OO9208-21, OO9208-28, OO9208-29, OO9208-30, OO9208-31, OO9208-41, OO9208-42, OO9208-43, OO9208-44, OO9208-4638, OO9208-4738, OO9208-4838, OO9208-4938, OO9208-5038, OO9208-5138, OO9208-5238, OO9208-5338, OO9208-5438, OO9208-5538, OO9208-5738, OO9208-5838, OO9208-5938, OO9208-6038, OO9208-6538, OO9208-6638, OO9208-6938, OO9208-7138, OO9208-7238, OO9208-7338, OO9208-7538, OO9208-7638, OO9208-7838, OO9208-8238, OO9208-9138, OO9208-9438, OO9208-9538, OO9208-9638, OO9208-9738, OO9208-A038, OO9208-A138, OO9208-A238, OO9208-A338, OO9208-A438, OO9208-A638, OO9208-A738, OO9208-A838, OO9208-A938, OO9208-B038, OO9208-B138, OO9208-B238, OO9208-B338, OO9208-B438, OO9208-B538, OO9208-B638, OO9208-B938, OO9208-C038, OO9208-C138, OO9208-C238, OO9208-C338, OO9208-C538, OO9208-C638, OO9208-C738, OO9208-C838, OO9208-C938, OO9208-D038, OO9208-D138, OO9208-D238, OO9208-D338, OO9208-D538, OO9208-D738, OO9208-D838, OO9208-D938, OO9208-E038, OO9208-E138, OO9208-E238, OO9208-E338, OO9208-E438, OO9208-E538, OO9208-E638, OO9208-E738, OO9208-E838, OO9208-F038, OO9208-F138, OO9208-F338, OO9208-F438, OO9208-F538, OO9208-F638, OO9208-F738, OO9208-F838, OO9208-F938, OO9208-G138, OO9208-G238, OO9208CP</p>'
    },

    {
      id:  'wl312-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl312-fit-photo-guide.jpg?v=1789488657',
      alt: 'How to find the SKU on your Maui Jim Red Sands frame'
    },

    {
      id:  'wl311-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl311-fit-photo-guide.jpg?v=1789488658',
      alt: 'How to find the SKU on your Maui Jim Baby Beach frame'
    },

    {
      id:  'wl315-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl315-fit-photo-guide.jpg?v=1789488659',
      alt: 'How to find the SKU on your Prada Linea Rossa SPS01X frame'
    },

    {
      id:  'wl310-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl310-fit-photo-guide.jpg?v=1789488659',
      alt: 'How to find the SKU on your Maui Jim Local Kine frame'
    },

    {
      id:  'wl309-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl309-fit-photo-guide.jpg?v=1789488660',
      alt: 'How to find the SKU on your Maui Jim Akau frame'
    },

    {
      id:  'wl300-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl300-fit-photo-guide.jpg?v=1789488660',
      alt: 'How to find the SKU on your Ray-Ban RB2447 (52mm) frame'
    },

    {
      id:  'wl299-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl299-fit-photo-guide.jpg?v=1789488662',
      alt: 'How to find the SKU on your Ray-Ban RB2447 (49mm) frame'
    },

    {
      id:  'wl307-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl307-fit-photo-guide.jpg?v=1789488662',
      alt: 'How to find the SKU on your Maui Jim Cruzem frame'
    },

    {
      id:  'wl298-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl298-fit-photo-guide.jpg?v=1789488662',
      alt: 'How to find the SKU on your Ray-Ban RB4264 Chromance (58mm) frame'
    },

    {
      id:  'wl297-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl297-fit-photo-guide.jpg?v=1789488664',
      alt: 'How to find the SKU on your Ray-Ban RB4101 Jackie Ohh (58mm) frame'
    },

    {
      id:  'wl289-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl289-fit-photo-guide.jpg?v=1789488663',
      alt: 'How to find the SKU on your Ray-Ban RB3364 (62mm) frame'
    },

    {
      id:  'wl288-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl288-fit-photo-guide.jpg?v=1789488664',
      alt: 'How to find the SKU on your Ray-Ban RB4033 (60mm) frame'
    },

    {
      id:  'wl287-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl287-fit-photo-guide.jpg?v=1789488666',
      alt: 'How to find the SKU on your Ray-Ban RB4165 Justin (54mm) frame'
    },

    {
      id:  'wl274-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl274-fit-photo-guide.jpg?v=1789488665',
      alt: 'How to find the SKU on your Maui Jim Bamboo Forest frame'
    },

    {
      id:  'wl296-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl296-fit-photo-guide.jpg?v=1789488665',
      alt: 'How to find the SKU on your Ray-Ban RB2180 (51mm) frame'
    },

    {
      id:  'wl278-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl278-fit-photo-guide.jpg?v=1789488666',
      alt: 'How to find the SKU on your Maui Jim Swinging Bridges frame'
    },

    {
      id:  'wl305-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl305-fit-photo-guide.jpg?v=1789488668',
      alt: 'How to find the SKU on your Ray-Ban RB3362 Cockpit (59mm) frame'
    },

    {
      id:  'wl286-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl286-fit-photo-guide.jpg?v=1789488667',
      alt: 'How to find the SKU on your Ray-Ban RB3029 Outdoorsman II frame'
    },

    {
      id:  'wl285-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl285-fit-photo-guide.jpg?v=1789488668',
      alt: 'How to find the SKU on your Ray-Ban RB4173 (62mm) frame'
    },

    {
      id:  'wl273-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl273-fit-photo-guide.jpg?v=1789488669',
      alt: 'How to find the SKU on your Maui Jim Kanaio Coast frame'
    },

    {
      id:  'wl277-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl277-fit-photo-guide.jpg?v=1789488669',
      alt: 'How to find the SKU on your Maui Jim Castles frame'
    },

    {
      id:  'wl295-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl295-fit-photo-guide.jpg?v=1789488669',
      alt: 'How to find the SKU on your Ray-Ban RB2180 (49mm) frame'
    },

    {
      id:  'wl304-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl304-fit-photo-guide.jpg?v=1789488670',
      alt: 'How to find the SKU on your Ray-Ban RB3362 Cockpit (56mm) frame'
    },

    {
      id:  'wl284-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl284-fit-photo-guide.jpg?v=1789488670',
      alt: 'How to find the SKU on your Ray-Ban RB2016 Daddy-O (59mm) frame'
    },

    {
      id:  'wl280-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl280-fit-photo-guide.jpg?v=1789488671',
      alt: 'How to find the SKU on your Maui Jim Ocean frame'
    },

    {
      id:  'wl272-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl272-fit-photo-guide.jpg?v=1789488671',
      alt: 'How to find the SKU on your Oakley SI Ballistic M Frame 3.0 frame'
    },
    {
      id:   'wl272-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9146 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley SI Ballistic M Frame 3.0 OO9146 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9146-01, OO9146-02, OO9146-05, OO9146-06, OO9146-09, OO9146-19, OO9146-20, OO9146-23, OO9146-25, OO9146-2132, OO9146-3332, OO9146-3432, OO9146-5032, OO9146-5132, OO9146-5432</p>'
    },

    {
      id:  'wl294-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl294-fit-photo-guide.jpg?v=1789488671',
      alt: 'How to find the SKU on your Ray-Ban RB4068 (60mm) frame'
    },

    {
      id:  'wl303-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl303-fit-photo-guide.jpg?v=1789488672',
      alt: 'How to find the SKU on your Ray-Ban RB3498 (61mm) frame'
    },

    {
      id:  'wl275-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl275-fit-photo-guide.jpg?v=1789488673',
      alt: 'How to find the SKU on your Maui Jim Kumu frame'
    },

    {
      id:  'wl271-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl271-fit-photo-guide.jpg?v=1789488673',
      alt: 'How to find the SKU on your Oakley SI Industrial M Frame 2.0 Strike frame'
    },
    {
      id:   'wl271-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9213 model codes (4)</h3><p style="margin:0 0 14px;">Every Oakley SI Industrial M Frame 2.0 Strike OO9213 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9213-03, OO9213-04, OO9213-0732, OO9213-1232</p>'
    },

    {
      id:  'wl279-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl279-fit-photo-guide.jpg?v=1789488674',
      alt: 'How to find the SKU on your Maui Jim Starfish frame'
    },

    {
      id:  'wl293-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl293-fit-photo-guide.jpg?v=1789488674',
      alt: 'How to find the SKU on your Ray-Ban RB3136 Caravan (58mm) frame'
    },

    {
      id:  'wl302-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl302-fit-photo-guide.jpg?v=1789488675',
      alt: 'How to find the SKU on your Ray-Ban RB3498 (64mm) frame'
    },

    {
      id:  'wl282-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl282-fit-photo-guide.jpg?v=1789488675',
      alt: 'How to find the SKU on your Ray-Ban RB4089 Balorama (62mm) frame'
    },

    {
      id:  'wl292-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl292-fit-photo-guide.jpg?v=1789488675',
      alt: 'How to find the SKU on your Ray-Ban RB3136 Caravan (55mm) frame'
    },

    {
      id:  'wl301-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl301-fit-photo-guide.jpg?v=1789488676',
      alt: 'How to find the SKU on your Ray-Ban RB3478 (60mm) frame'
    },

    {
      id:  'wl281-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl281-fit-photo-guide.jpg?v=1789488676',
      alt: 'How to find the SKU on your Maui Jim Big Wave frame'
    },

    {
      id:  'wl291-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl291-fit-photo-guide.jpg?v=1789488677',
      alt: 'How to find the SKU on your Ray-Ban RB3647-N (51mm) frame'
    },

    {
      id:  'wl270-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl270-fit-photo-guide.jpg?v=1789488678',
      alt: 'How to find the SKU on your Maui Jim Hema frame'
    },

    {
      id:  'wl269-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl269-fit-photo-guide.jpg?v=1789488678',
      alt: 'How to find the SKU on your Maui Jim Pokowai Arch frame'
    },

    {
      id:  'wl268-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl268-fit-photo-guide.jpg?v=1789488678',
      alt: 'How to find the SKU on your Maui Jim Kuiaha Bay frame'
    },

    {
      id:  'wl250-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl250-fit-photo-guide.jpg?v=1789488678',
      alt: 'How to find the SKU on your Smith Optics Lowdown XL frame'
    },

    {
      id:  'wl267-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl267-fit-photo-guide.jpg?v=1789488679',
      alt: 'How to find the SKU on your Maui Jim Twin Falls frame'
    },

    {
      id:  'wl249-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl249-fit-photo-guide.jpg?v=1789488679',
      alt: 'How to find the SKU on your Smith Optics Outlier frame'
    },

    {
      id:  'wl266-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl266-fit-photo-guide.jpg?v=1789488680',
      alt: 'How to find the SKU on your Maui Jim Kipahulu frame'
    },

    {
      id:  'wl265-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl265-fit-photo-guide.jpg?v=1789488681',
      alt: 'How to find the SKU on your Maui Jim Black Coral frame'
    },

    {
      id:  'wl260-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl260-fit-photo-guide.jpg?v=1789488681',
      alt: 'How to find the SKU on your Maui Jim Nalani frame'
    },

    {
      id:  'wl264-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl264-fit-photo-guide.jpg?v=1789488681',
      alt: 'How to find the SKU on your Maui Jim Sugar Beach frame'
    },

    {
      id:  'wl259-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl259-fit-photo-guide.jpg?v=1789488682',
      alt: 'How to find the SKU on your Maui Jim Peahi frame'
    },

    {
      id:  'wl248-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl248-fit-photo-guide.jpg?v=1789488683',
      alt: 'How to find the SKU on your Smith Optics Parallel frame'
    },

    {
      id:  'wl258-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl258-fit-photo-guide.jpg?v=1789488683',
      alt: 'How to find the SKU on your Maui Jim Punchbowl frame'
    },

    {
      id:  'wl247-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl247-fit-photo-guide.jpg?v=1789488683',
      alt: 'How to find the SKU on your Smith Optics Outlier XL frame'
    },

    {
      id:  'wl257-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl257-fit-photo-guide.jpg?v=1789488683',
      alt: 'How to find the SKU on your Maui Jim Lighthouse frame'
    },

    {
      id:  'wl246-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl246-fit-photo-guide.jpg?v=1789488684',
      alt: 'How to find the SKU on your Smith Optics Purist frame'
    },

    {
      id:  'wl256-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl256-fit-photo-guide.jpg?v=1789488684',
      alt: 'How to find the SKU on your Maui Jim Cloud Break frame'
    },

    {
      id:  'wl263-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl263-fit-photo-guide.jpg?v=1789488686',
      alt: 'How to find the SKU on your Maui Jim Guardrails frame'
    },

    {
      id:  'wl262-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl262-fit-photo-guide.jpg?v=1789488687',
      alt: 'How to find the SKU on your Maui Jim Kawika frame'
    },

    {
      id:  'wl245-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl245-fit-photo-guide.jpg?v=1789488686',
      alt: 'How to find the SKU on your Smith Optics Nomad frame'
    },

    {
      id:  'wl255-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl255-fit-photo-guide.jpg?v=1789488686',
      alt: 'How to find the SKU on your Maui Jim Wiki Wiki frame'
    },

    {
      id:  'wl240-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl240-fit-photo-guide.jpg?v=1789488687',
      alt: 'How to find the SKU on your Spy Optic Helm frame'
    },

    {
      id:  'wl261-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl261-fit-photo-guide.jpg?v=1789488687',
      alt: 'How to find the SKU on your Maui Jim Breakwall frame'
    },

    {
      id:  'wl244-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl244-fit-photo-guide.jpg?v=1789488688',
      alt: 'How to find the SKU on your Smith Optics Guide\'s Choice frame'
    },

    {
      id:  'wl254-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl254-fit-photo-guide.jpg?v=1789488689',
      alt: 'How to find the SKU on your Smith Optics Approach frame'
    },

    {
      id:  'wl239-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl239-fit-photo-guide.jpg?v=1789488689',
      alt: 'How to find the SKU on your Spy Optic Konvoy frame'
    },

    {
      id:  'wl253-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl253-fit-photo-guide.jpg?v=1789488690',
      alt: 'How to find the SKU on your Smith Optics Prospect frame'
    },

    {
      id:  'wl252-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl252-fit-photo-guide.jpg?v=1789488690',
      alt: 'How to find the SKU on your Smith Optics Sidney frame'
    },

    {
      id:  'wl237-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl237-fit-photo-guide.jpg?v=1789488690',
      alt: 'How to find the SKU on your Spy Optic Colt frame'
    },

    {
      id:  'wl251-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl251-fit-photo-guide.jpg?v=1789488691',
      alt: 'How to find the SKU on your Smith Optics Cheetah frame'
    },

    {
      id:  'wl242-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl242-fit-photo-guide.jpg?v=1789488692',
      alt: 'How to find the SKU on your Smith Optics Parallel D-Max frame'
    },

    {
      id:  'wl236-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl236-fit-photo-guide.jpg?v=1789488692',
      alt: 'How to find the SKU on your Spy Optic Whistler frame'
    },

    {
      id:  'wl241-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl241-fit-photo-guide.jpg?v=1789488693',
      alt: 'How to find the SKU on your Under Armour Battlewrap frame'
    },

    {
      id:  'wl235-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl235-fit-photo-guide.jpg?v=1789488761',
      alt: 'How to find the SKU on your Oakley Conductor 8 frame'
    },
    {
      id:   'wl235-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4107 model codes (5)</h3><p style="margin:0 0 14px;">Every Oakley Conductor 8 OO4107 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4107-01, OO4107-02, OO4107-03, OO4107-04, OO4107-05</p>'
    },

    {
      id:  'wl234-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl234-fit-photo-guide.jpg?v=1789488763',
      alt: 'How to find the SKU on your Oakley Tailhook frame'
    },
    {
      id:   'wl234-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4087 model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley Tailhook OO4087 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4087-01, OO4087-02, OO4087-03, OO4087-04, OO4087-05, OO4087-06, OO4087-07, OO4087-08</p>'
    },

    {
      id:  'wl229-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl229-fit-photo-guide.jpg?v=1789488767',
      alt: 'How to find the SKU on your Oakley Sliver R frame'
    },
    {
      id:   'wl229-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9342 model codes (13)</h3><p style="margin:0 0 14px;">Every Oakley Sliver R OO9342 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9342-01, OO9342-02, OO9342-03, OO9342-04, OO9342-05, OO9342-06, OO9342-07, OO9342-08, OO9342-09, OO9342-10, OO9342-11, OO9342-12, OO9342-1557</p>'
    },

    {
      id:  'wl219-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl219-fit-photo-guide.jpg?v=1789488762',
      alt: 'How to find the SKU on your Oakley Siphon frame'
    },
    {
      id:   'wl219-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9429 model codes (4)</h3><p style="margin:0 0 14px;">Every Oakley Siphon OO9429 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9429-0164, OO9429-0264, OO9429-0364, OO9429-0464</p>'
    },

    {
      id:  'wl228-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl228-fit-photo-guide.jpg?v=1789488762',
      alt: 'How to find the SKU on your Oakley Hold Out frame'
    },
    {
      id:   'wl228-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9357 model codes (7)</h3><p style="margin:0 0 14px;">Every Oakley Hold Out OO9357 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9357-0155, OO9357-0255, OO9357-0355, OO9357-0455, OO9357-0555, OO9357-0655, OO9357-0755</p>'
    },

    {
      id:  'wl233-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl233-fit-photo-guide.jpg?v=1789488762',
      alt: 'How to find the SKU on your Oakley Gauge 8 M frame'
    },

    {
      id:  'wl218-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl218-fit-photo-guide.jpg?v=1789488763',
      alt: 'How to find the SKU on your Oakley Straightlink frame'
    },
    {
      id:   'wl218-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9331 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley Straightlink OO9331 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9331-01, OO9331-02, OO9331-03, OO9331-04, OO9331-05, OO9331-06, OO9331-07, OO9331-08, OO9331-09, OO9331-10, OO9331-1358, OO9331-1458, OO9331-1558, OO9331-1658, OO9331-2158</p>'
    },

    {
      id:  'wl231-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl231-fit-photo-guide.jpg?v=1789488765',
      alt: 'How to find the SKU on your Oakley Given frame'
    },
    {
      id:   'wl231-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4068 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Given OO4068 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4068-01, OO4068-02, OO4068-03, OO4068-04, OO4068-05, OO4068-06, OO4068-07, OO4068-08, OO4068-09, OO4068-10, OO4068-13</p>'
    },

    {
      id:  'wl227-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl227-fit-photo-guide.jpg?v=1789488765',
      alt: 'How to find the SKU on your Oakley Tailpin frame'
    },
    {
      id:   'wl227-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4086 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Tailpin OO4086 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4086-01, OO4086-02, OO4086-03, OO4086-04, OO4086-05, OO4086-06, OO4086-07, OO4086-08, OO4086-09, OO4086-11, OO4086-12</p>'
    },

    {
      id:  'wl216-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl216-fit-photo-guide.jpg?v=1789488765',
      alt: 'How to find the SKU on your Oakley Holston frame'
    },
    {
      id:   'wl216-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9334 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Holston OO9334 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9334-0858, OO9334-0958, OO9334-1058, OO9334-1158, OO9334-1258, OO9334-1358, OO9334-1458, OO9334-1558, OO9334-1658, OO9334-2158, OO9334-2258</p>'
    },

    {
      id:  'wl215-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl215-fit-photo-guide.jpg?v=1789488766',
      alt: 'How to find the SKU on your Oakley Split Time frame'
    },
    {
      id:   'wl215-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4129 model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley Split Time OO4129 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4129-0158, OO4129-0258, OO4129-0358, OO4129-0458, OO4129-0558, OO4129-0658, OO4129-0758, OO4129-0858, OO4129-0958, OO4129-1058, OO4129-1158, OO4129-1258, OO4129-1458, OO4129-1758, OO4129-1858, OO4129-2258, OO4129-2358, OO4129-2458, OO4129-2558, OO4129-2658, OO4129-2758, OO4129-2858, OO4129-2958, OO4129-3058</p>'
    },

    {
      id:  'wl226-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl226-fit-photo-guide.jpg?v=1789488767',
      alt: 'How to find the SKU on your Oakley Elmont M frame'
    },

    {
      id:  'wl197-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl197-fit-photo-guide.jpg?v=1789488768',
      alt: 'How to find the SKU on your Oakley TwoFace XL frame'
    },
    {
      id:   'wl197-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9350 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley TwoFace XL OO9350 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9350-01, OO9350-02, OO9350-03, OO9350-04, OO9350-05, OO9350-06, OO9350-07, OO9350-08, OO9350-0959, OO9350-1059</p>'
    },

    {
      id:  'wl214-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl214-fit-photo-guide.jpg?v=1789488767',
      alt: 'How to find the SKU on your Oakley Sliver Edge frame'
    },
    {
      id:   'wl214-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9413 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley Sliver Edge OO9413 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9413-0165, OO9413-0265, OO9413-0365, OO9413-0465, OO9413-0565, OO9413-0665, OO9413-1165, OO9413-1265, OO9413-1365, OO9413-1465</p>'
    },

    {
      id:  'wl225-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl225-fit-photo-guide.jpg?v=1789488768',
      alt: 'How to find the SKU on your Oakley Elmont L frame'
    },

    {
      id:  'wl213-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl213-fit-photo-guide.jpg?v=1789488769',
      alt: 'How to find the SKU on your Oakley Flight Jacket frame'
    },
    {
      id:   'wl213-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9401 model codes (20)</h3><p style="margin:0 0 14px;">Every Oakley Flight Jacket OO9401 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9401-0137, OO9401-0237, OO9401-0337, OO9401-0437, OO9401-0537, OO9401-0637, OO9401-0737, OO9401-0837, OO9401-0937, OO9401-1037, OO9401-1337, OO9401-1537, OO9401-1637, OO9401-1737, OO9401-1837, OO9401-1937, OO9401-2037, OO9401-2137, OO9401-2237, OO9401-2337</p>'
    },

    {
      id:  'wl212-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl212-fit-photo-guide.jpg?v=1789488770',
      alt: 'How to find the SKU on your Oakley Tie Breaker frame'
    },
    {
      id:   'wl212-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4108 model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Tie Breaker OO4108 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4108-01, OO4108-02, OO4108-03, OO4108-04, OO4108-05, OO4108-06, OO4108-07, OO4108-08, OO4108-10, OO4108-11, OO4108-12, OO4108-13, OO4108-14, OO4108-15, OO4108-16, OO4108-1756, OO4108-1856</p>'
    },

    {
      id:  'wl195-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl195-fit-photo-guide.jpg?v=1789488697',
      alt: 'How to find the SKU on your Oakley Holbrook XL frame'
    },
    {
      id:   'wl195-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9417 model codes (47)</h3><p style="margin:0 0 14px;">Every Oakley Holbrook XL OO9417 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9417-0159, OO9417-0259, OO9417-0359, OO9417-0459, OO9417-0559, OO9417-0659, OO9417-0759, OO9417-0859, OO9417-0959, OO9417-1059, OO9417-1159, OO9417-1259, OO9417-1359, OO9417-1459, OO9417-1559, OO9417-1659, OO9417-1759, OO9417-1859, OO9417-1959, OO9417-2059, OO9417-2159, OO9417-2259, OO9417-2359, OO9417-2559, OO9417-2659, OO9417-2759, OO9417-2859, OO9417-2959, OO9417-3059, OO9417-3159, OO9417-3259, OO9417-3359, OO9417-3459, OO9417-3559, OO9417-3659, OO9417-3759, OO9417-3859, OO9417-3959, OO9417-4259, OO9417-4359, OO9417-4459, OO9417-4559, OO9417-4759, OO9417-4859, OO9417-4959, OO9417-5059, OO9417-5159</p>'
    },

    {
      id:  'wl224-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl224-fit-photo-guide.jpg?v=1789488770',
      alt: 'How to find the SKU on your Oakley Targetline frame'
    },
    {
      id:   'wl224-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9397 model codes (18)</h3><p style="margin:0 0 14px;">Every Oakley Targetline OO9397 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9397-0158, OO9397-0258, OO9397-0358, OO9397-0458, OO9397-0558, OO9397-0658, OO9397-0758, OO9397-0858, OO9397-0958, OO9397-1058, OO9397-1358, OO9397-1458, OO9397-1558, OO9397-1658, OO9397-1758, OO9397-1858, OO9397-2258, OO9397-2358</p>'
    },

    {
      id:  'wl211-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl211-fit-photo-guide.jpg?v=1789488772',
      alt: 'How to find the SKU on your Oakley Crosslink 55 frame'
    },
    {
      id:   'wl211-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OX8030 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Crosslink 55 OX8030 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl200-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl200-fit-photo-guide.jpg?v=1789488771',
      alt: 'How to find the SKU on your Oakley Catalyst frame'
    },
    {
      id:   'wl200-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9272 model codes (22)</h3><p style="margin:0 0 14px;">Every Oakley Catalyst OO9272 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9272-01, OO9272-02, OO9272-03, OO9272-04, OO9272-05, OO9272-06, OO9272-07, OO9272-08, OO9272-09, OO9272-14, OO9272-16, OO9272-17, OO9272-18, OO9272-19, OO9272-20, OO9272-2155, OO9272-2255, OO9272-2355, OO9272-2455, OO9272-2555, OO9272-2755, OO9272-2855</p>'
    },

    {
      id:  'wl223-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl223-fit-photo-guide.jpg?v=1789488771',
      alt: 'How to find the SKU on your Oakley Conquest frame'
    },
    {
      id:   'wl223-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4101 model codes (7)</h3><p style="margin:0 0 14px;">Every Oakley Conquest OO4101 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4101-01, OO4101-02, OO4101-03, OO4101-04, OO4101-05, OO4101-06, OO4101-07</p>'
    },

    {
      id:  'wl199-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl199-fit-photo-guide.jpg?v=1789488771',
      alt: 'How to find the SKU on your Oakley Drop Point frame'
    },
    {
      id:   'wl199-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9367 model codes (38)</h3><p style="margin:0 0 14px;">Every Oakley Drop Point OO9367 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9367-0160, OO9367-0260, OO9367-0360, OO9367-0460, OO9367-0560, OO9367-0660, OO9367-0760, OO9367-0860, OO9367-0960, OO9367-1060, OO9367-1160, OO9367-1260, OO9367-1360, OO9367-1460, OO9367-1560, OO9367-1660, OO9367-1760, OO9367-1860, OO9367-1960, OO9367-2060, OO9367-2160, OO9367-2260, OO9367-2360, OO9367-2460, OO9367-2560, OO9367-2660, OO9367-2760, OO9367-2860, OO9367-3060, OO9367-3160, OO9367-3260, OO9367-3360, OO9367-3460, OO9367-3560, OO9367-3660, OO9367-3760, OO9367-3860, OO9367-3960</p>'
    },

    {
      id:  'wl222-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl222-fit-photo-guide.jpg?v=1789488772',
      alt: 'How to find the SKU on your Oakley M2 XL frame'
    },
    {
      id:   'wl222-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9343 model codes (18)</h3><p style="margin:0 0 14px;">Every Oakley M2 XL OO9343 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9343-01, OO9343-02, OO9343-03, OO9343-04, OO9343-05, OO9343-06, OO9343-07, OO9343-08, OO9343-09, OO9343-1145, OO9343-1245, OO9343-1345, OO9343-1445, OO9343-1645, OO9343-1845, OO9343-1945, OO9343-2145, OO9343-2245</p>'
    },

    {
      id:  'wl209-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl209-fit-photo-guide.jpg?v=1789488775',
      alt: 'How to find the SKU on your Oakley Double Edge frame'
    },
    {
      id:   'wl209-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9380 model codes (27)</h3><p style="margin:0 0 14px;">Every Oakley Double Edge OO9380 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9380-0166, OO9380-0266, OO9380-0366, OO9380-0466, OO9380-0566, OO9380-0666, OO9380-0766, OO9380-0866, OO9380-0966, OO9380-1066, OO9380-1166, OO9380-1266, OO9380-1366, OO9380-1466, OO9380-1666, OO9380-1766, OO9380-1866, OO9380-1966, OO9380-2066, OO9380-2166, OO9380-2266, OO9380-2366, OO9380-2466, OO9380-2566, OO9380-2766, OO9380-2866, OO9380-2966</p>'
    },

    {
      id:  'wl210-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl210-fit-photo-guide.jpg?v=1789488774',
      alt: 'How to find the SKU on your Oakley Crosslink 53 frame'
    },
    {
      id:   'wl210-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OX8027 model codes (0)</h3><p style="margin:0 0 14px;">Every Oakley Crosslink 53 OX8027 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;"></p>'
    },

    {
      id:  'wl198-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl198-fit-photo-guide.jpg?v=1789488774',
      alt: 'How to find the SKU on your Oakley Proxy frame'
    },
    {
      id:   'wl198-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9312 model codes (7)</h3><p style="margin:0 0 14px;">Every Oakley Proxy OO9312 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9312-01, OO9312-02, OO9312-03, OO9312-04, OO9312-05, OO9312-06, OO9312-07</p>'
    },

    {
      id:  'wl208-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl208-fit-photo-guide.jpg?v=1789488774',
      alt: 'How to find the SKU on your Oakley Kickback frame'
    },
    {
      id:   'wl208-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4102 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Kickback OO4102 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4102-01, OO4102-02, OO4102-03, OO4102-04, OO4102-05, OO4102-06, OO4102-11, OO4102-12, OO4102-13</p>'
    },

    {
      id:  'wl196-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl196-fit-photo-guide.jpg?v=1789488775',
      alt: 'How to find the SKU on your Oakley Moonlighter frame'
    },
    {
      id:   'wl196-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9320 model codes (19)</h3><p style="margin:0 0 14px;">Every Oakley Moonlighter OO9320 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9320-01, OO9320-02, OO9320-03, OO9320-04, OO9320-05, OO9320-06, OO9320-07, OO9320-08, OO9320-09, OO9320-10, OO9320-11, OO9320-12, OO9320-13, OO9320-14, OO9320-15, OO9320-1653, OO9320-1753, OO9320-1853, OO9320-1953</p>'
    },

    {
      id:  'wl207-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl207-fit-photo-guide.jpg?v=1789488777',
      alt: 'How to find the SKU on your Oakley EVZero Pitch frame'
    },
    {
      id:   'wl207-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9383 model codes (6)</h3><p style="margin:0 0 14px;">Every Oakley EVZero Pitch OO9383 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9383-0138, OO9383-0238, OO9383-0338, OO9383-0438, OO9383-0538, OO9383-0638</p>'
    },

    {
      id:  'wl221-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl221-fit-photo-guide.jpg?v=1789488776',
      alt: 'How to find the SKU on your Oakley Shocktube frame'
    },
    {
      id:   'wl221-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9329 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Shocktube OO9329 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9329-01, OO9329-02, OO9329-03, OO9329-04, OO9329-05, OO9329-06, OO9329-07, OO9329-08, OO9329-09, OO9329-1061, OO9329-1161</p>'
    },

    {
      id:  'wl206-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl206-fit-photo-guide.jpg?v=1789488777',
      alt: 'How to find the SKU on your Oakley Thinlink frame'
    },
    {
      id:   'wl206-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9316 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Thinlink OO9316 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9316-01, OO9316-02, OO9316-03, OO9316-04, OO9316-05, OO9316-06, OO9316-07, OO9316-08, OO9316-09</p>'
    },

    {
      id:  'wl205-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl205-fit-photo-guide.jpg?v=1789488777',
      alt: 'How to find the SKU on your Oakley Trillbe X frame'
    },
    {
      id:   'wl205-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9340 model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Trillbe X OO9340 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9340-01, OO9340-02, OO9340-03, OO9340-04, OO9340-05, OO9340-06, OO9340-07, OO9340-08, OO9340-0952, OO9340-1052, OO9340-1152, OO9340-1252, OO9340-1352, OO9340-1452, OO9340-1552, OO9340-1852, OO9340-2152</p>'
    },

    {
      id:  'wl204-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl204-fit-photo-guide.jpg?v=1789488777',
      alt: 'How to find the SKU on your Oakley Conductor 6 frame'
    },
    {
      id:   'wl204-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4106 model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley Conductor 6 OO4106 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4106-01, OO4106-02, OO4106-03, OO4106-04, OO4106-05, OO4106-0758, OO4106-0858, OO4106-0958</p>'
    },

    {
      id:  'wl203-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl203-fit-photo-guide.jpg?v=1789488783',
      alt: 'How to find the SKU on your Oakley Det Cord frame'
    },
    {
      id:   'wl203-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9253 model codes (14)</h3><p style="margin:0 0 14px;">Every Oakley Det Cord OO9253 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9253-01, OO9253-02, OO9253-03, OO9253-04, OO9253-05, OO9253-06, OO9253-07, OO9253-08, OO9253-1161, OO9253-1661, OO9253-1761, OO9253-1861, OO9253-2061, OO9253-2161</p>'
    },

    {
      id:  'wl202-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl202-fit-photo-guide.jpg?v=1789488779',
      alt: 'How to find the SKU on your Oakley Triggerman frame'
    },
    {
      id:   'wl202-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9266 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Triggerman OO9266 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9266-01, OO9266-02, OO9266-03, OO9266-04, OO9266-05, OO9266-06, OO9266-07, OO9266-08, OO9266-09, OO9266-10, OO9266-11</p>'
    },

    {
      id:  'wl190-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl190-fit-photo-guide.jpg?v=1789488779',
      alt: 'How to find the SKU on your Oakley RPM Squared frame'
    },
    {
      id:   'wl190-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9205 model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley RPM Squared OO9205 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9205-01, OO9205-02, OO9205-03, OO9205-04, OO9205-05, OO9205-06, OO9205-07, OO9205-08</p>'
    },

    {
      id:  'wl150-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl150-fit-photo-guide.jpg?v=1789488701',
      alt: 'How to find the SKU on your Maui Jim Hot Sands frame'
    },

    {
      id:  'wl193-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl193.jpg?v=1783257794',
      alt: 'How to find the SKU on your Oakley Square Wire II frame'
    },

    {
      id:  'wl149-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl149-fit-photo-guide.jpg?v=1789488701',
      alt: 'How to find the SKU on your Ray-Ban RB4175 (57mm) frame'
    },

    {
      id:  'wl192-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl192-fit-photo-guide.jpg?v=1789488780',
      alt: 'How to find the SKU on your Oakley Carbon Blade frame'
    },
    {
      id:   'wl192-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9174 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Carbon Blade OO9174 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9174-01, OO9174-02, OO9174-03, OO9174-04, OO9174-05, OO9174-06, OO9174-07, OO9174-08, OO9174-09, OO9174-0966, OO9174-1066</p>'
    },

    {
      id:  'wl191-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl191-fit-photo-guide.jpg?v=1789488781',
      alt: 'How to find the SKU on your Oakley Chainlink frame'
    },
    {
      id:   'wl191-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9247 model codes (18)</h3><p style="margin:0 0 14px;">Every Oakley Chainlink OO9247 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9247-01, OO9247-02, OO9247-03, OO9247-04, OO9247-05, OO9247-06, OO9247-07, OO9247-08, OO9247-09, OO9247-10, OO9247-11, OO9247-12, OO9247-13, OO9247-15, OO9247-16, OO9247-18, OO9247-19, OO9247-20</p>'
    },

    {
      id:  'wl201-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl201-fit-photo-guide.jpg?v=1789488781',
      alt: 'How to find the SKU on your Oakley Cohort frame'
    },
    {
      id:   'wl201-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9301 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley Cohort OO9301 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9301-01, OO9301-02, OO9301-03, OO9301-04, OO9301-05, OO9301-06, OO9301-0761, OO9301-1061, OO9301-1361, OO9301-1461, OO9301-1561, OO9301-1661, OO9301-1761, OO9301-1861, OO9301-1961</p>'
    },

    {
      id:  'wl189-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl189-fit-photo-guide.jpg?v=1789488781',
      alt: 'How to find the SKU on your Oakley Unstoppable frame'
    },
    {
      id:   'wl189-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9191 model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Unstoppable OO9191 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9191-01, OO9191-02, OO9191-03, OO9191-04, OO9191-05, OO9191-06, OO9191-07, OO9191-08, OO9191-09, OO9191-10, OO9191-11, OO9191-1465, OO9191-1565, OO9191-1665, OO9191-1965, OO9191-2065, OO9191-2265</p>'
    },

    {
      id:  'wl188-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl188-fit-photo-guide.jpg?v=1789488784',
      alt: 'How to find the SKU on your Oakley Urgency frame'
    },
    {
      id:   'wl188-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9158 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley Urgency OO9158 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9158-01, OO9158-02, OO9158-03, OO9158-04, OO9158-05, OO9158-06, OO9158-07, OO9158-08, OO9158-12, OO9158-13</p>'
    },

    {
      id:  'wl187-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl187-fit-photo-guide.jpg?v=1789488782',
      alt: 'How to find the SKU on your Oakley Drop In frame'
    },
    {
      id:   'wl187-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9232 model codes (16)</h3><p style="margin:0 0 14px;">Every Oakley Drop In OO9232 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9232-01, OO9232-02, OO9232-03, OO9232-04, OO9232-05, OO9232-06, OO9232-07, OO9232-08, OO9232-09, OO9232-10, OO9232-11, OO9232-12, OO9232-13, OO9232-15, OO9232-16, OO9232-18</p>'
    },

    {
      id:  'wl186-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl186-fit-photo-guide.jpg?v=1789488784',
      alt: 'How to find the SKU on your Oakley Forehand frame'
    },
    {
      id:   'wl186-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9179 model codes (28)</h3><p style="margin:0 0 14px;">Every Oakley Forehand OO9179 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9179-01, OO9179-02, OO9179-03, OO9179-05, OO9179-06, OO9179-07, OO9179-08, OO9179-09, OO9179-10, OO9179-11, OO9179-12, OO9179-13, OO9179-14, OO9179-15, OO9179-16, OO9179-17, OO9179-18, OO9179-20, OO9179-21, OO9179-24, OO9179-26, OO9179-27, OO9179-28, OO9179-29, OO9179-30, OO9179-31, OO9179-32, OO9179-40</p>'
    },

    {
      id:  'wl185-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl185-fit-photo-guide.jpg?v=1789488787',
      alt: 'How to find the SKU on your Oakley Crossrange frame'
    },
    {
      id:   'wl185-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9361 model codes (18)</h3><p style="margin:0 0 14px;">Every Oakley Crossrange OO9361 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9361-0157, OO9361-0257, OO9361-0357, OO9361-0457, OO9361-0557, OO9361-0657, OO9361-0757, OO9361-0857, OO9361-0957, OO9361-1057, OO9361-1157, OO9361-1257, OO9361-1357, OO9361-1457, OO9361-1557, OO9361-1657, OO9361-1757, OO9361-1857</p>'
    },

    {
      id:  'wl180-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL180-OO9341-06.jpg?v=1783200699',
      alt: 'How to find the SKU on your Oakley Sliver XL frame'
    },
    {
      id:   'wl180-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9341 model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley Sliver XL OO9341 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9341-01, OO9341-02, OO9341-03, OO9341-04, OO9341-05, OO9341-06, OO9341-07, OO9341-08, OO9341-09, OO9341-10, OO9341-11, OO9341-12, OO9341-1357, OO9341-1457, OO9341-1557, OO9341-1657, OO9341-1757, OO9341-1957, OO9341-2057, OO9341-2257, OO9341-2357, OO9341-2457, OO9341-2557, OO9341-2757</p>'
    },

    {
      id:  'wl179-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl179-fit-photo-guide.jpg?v=1789488784',
      alt: 'How to find the SKU on your Oakley Flak Beta frame'
    },
    {
      id:   'wl179-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9363 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Flak Beta OO9363 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9363-0164, OO9363-0264, OO9363-0364, OO9363-0464, OO9363-0564, OO9363-0664, OO9363-0764, OO9363-0864, OO9363-0964, OO9363-1064, OO9363-1164</p>'
    },

    {
      id:  'wl184-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl184-fit-photo-guide.jpg?v=1789488785',
      alt: 'How to find the SKU on your Oakley Flak Draft frame'
    },
    {
      id:   'wl184-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9364 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley Flak Draft OO9364 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9364-0160, OO9364-0167, OO9364-0267, OO9364-0367, OO9364-0467, OO9364-0567, OO9364-0667, OO9364-0767, OO9364-0867, OO9364-1067</p>'
    },

    {
      id:  'wl178-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl178-fit-photo-guide.jpg?v=1789488786',
      alt: 'How to find the SKU on your Oakley Sliver frame'
    },
    {
      id:   'wl178-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9262 model codes (51)</h3><p style="margin:0 0 14px;">Every Oakley Sliver OO9262 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9262-01, OO9262-02, OO9262-03, OO9262-04, OO9262-05, OO9262-06, OO9262-07, OO9262-08, OO9262-09, OO9262-10, OO9262-11, OO9262-12, OO9262-13, OO9262-14, OO9262-15, OO9262-16, OO9262-17, OO9262-18, OO9262-19, OO9262-20, OO9262-21, OO9262-22, OO9262-23, OO9262-24, OO9262-26, OO9262-27, OO9262-28, OO9262-30, OO9262-32, OO9262-33, OO9262-34, OO9262-35, OO9262-36, OO9262-38, OO9262-39, OO9262-40, OO9262-55, OO9262-59, OO9262-4257, OO9262-4457, OO9262-4557, OO9262-4657, OO9262-4757, OO9262-5957, OO9262-6057, OO9262-6157, OO9262-6257, OO9262-6357, OO9262-6657, OO9262-6857, OO9262-6957</p>'
    },

    {
      id:  'wl177-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl177-fit-photo-guide.jpg?v=1789488787',
      alt: 'How to find the SKU on your Oakley Latch SQ frame'
    },
    {
      id:   'wl177-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9353 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Latch SQ OO9353 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9353-01, OO9353-02, OO9353-03, OO9353-04, OO9353-05, OO9353-06, OO9353-07, OO9353-08, OO9353-09, OO9353-10, OO9353-1252</p>'
    },

    {
      id:  'wl176-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl176-fit-photo-guide.jpg?v=1789488786',
      alt: 'How to find the SKU on your Oakley Latch frame'
    },
    {
      id:   'wl176-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9265 model codes (64)</h3><p style="margin:0 0 14px;">Every Oakley Latch OO9265 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9265-01, OO9265-02, OO9265-03, OO9265-04, OO9265-05, OO9265-06, OO9265-07, OO9265-08, OO9265-09, OO9265-10, OO9265-11, OO9265-12, OO9265-13, OO9265-14, OO9265-15, OO9265-16, OO9265-1853, OO9265-2153, OO9265-2253, OO9265-2353, OO9265-2453, OO9265-2553, OO9265-2653, OO9265-2753, OO9265-2853, OO9265-2953, OO9265-3053, OO9265-3153, OO9265-3253, OO9265-3353, OO9265-3453, OO9265-3553, OO9265-3653, OO9265-3753, OO9265-3853, OO9265-4053, OO9265-4153, OO9265-4253, OO9265-4453, OO9265-4753, OO9265-4853, OO9265-4953, OO9265-5053, OO9265-5153, OO9265-5253, OO9265-5353, OO9265-5453, OO9265-5553, OO9265-5653, OO9265-5753, OO9265-5853, OO9265-5953, OO9265-6053, OO9265-6153, OO9265-6253, OO9265-6553, OO9265-6653, OO9265-6753, OO9265-6853, OO9265-6953, OO9265-7053, OO9265-7253, OO9265-7353, OO9265-7453</p>'
    },

    {
      id:  'wl183-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl183-fit-photo-guide.jpg?v=1789488787',
      alt: 'How to find the SKU on your Oakley Carbon Shift frame'
    },
    {
      id:   'wl183-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9302 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley Carbon Shift OO9302 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9302-01, OO9302-02, OO9302-03, OO9302-04, OO9302-05, OO9302-06, OO9302-07, OO9302-0862, OO9302-0962, OO9302-1062</p>'
    },

    {
      id:  'wl175-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl175-fit-photo-guide.jpg?v=1789488789',
      alt: 'How to find the SKU on your POC Half Blade frame'
    },

    {
      id:  'wl181-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl181-fit-photo-guide.jpg?v=1789488789',
      alt: 'How to find the SKU on your Oakley Mainlink frame'
    },
    {
      id:   'wl181-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9264 model codes (30)</h3><p style="margin:0 0 14px;">Every Oakley Mainlink OO9264 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9264-01, OO9264-02, OO9264-03, OO9264-04, OO9264-05, OO9264-06, OO9264-07, OO9264-08, OO9264-12, OO9264-13, OO9264-18, OO9264-19, OO9264-20, OO9264-21, OO9264-22, OO9264-23, OO9264-2457, OO9264-2557, OO9264-2657, OO9264-2757, OO9264-2957, OO9264-3057, OO9264-3157, OO9264-3257, OO9264-3457, OO9264-3557, OO9264-3757, OO9264-3857, OO9264-3957, OO9264-4057</p>'
    },

    {
      id:  'wl174-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl174-fit-photo-guide.jpg?v=1789488790',
      alt: 'How to find the SKU on your POC Blade frame'
    },

    {
      id:  'wl173-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl173-fit-photo-guide.jpg?v=1789488791',
      alt: 'How to find the SKU on your Wiley X Valor frame'
    },

    {
      id:  'wl172-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl172-fit-photo-guide.jpg?v=1789488791',
      alt: 'How to find the SKU on your VonZipper Fulton frame'
    },

    {
      id:  'wl171-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl171-fit-photo-guide.jpg?v=1789488791',
      alt: 'How to find the SKU on your VonZipper Elmore frame'
    },

    {
      id:  'wl170-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl170-fit-photo-guide.jpg?v=1789488791',
      alt: 'How to find the SKU on your Smith Parallel Max frame'
    },

    {
      id:  'wl140-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl140-fit-photo-guide.jpg?v=1789488792',
      alt: 'How to find the SKU on your Oakley Tinfoil frame'
    },
    {
      id:   'wl140-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4083 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Tinfoil OO4083 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4083-01, OO4083-02, OO4083-03, OO4083-04, OO4083-05, OO4083-06, OO4083-07, OO4083-08, OO4083-09</p>'
    },

    {
      id:  'wl169-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl169-fit-photo-guide.jpg?v=1789488792',
      alt: 'How to find the SKU on your Smith Lowdown frame'
    },

    {
      id:  'wl168-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl168-fit-photo-guide.jpg?v=1789488794',
      alt: 'How to find the SKU on your Smith Serpico frame'
    },

    {
      id:  'wl167-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl167-fit-photo-guide.jpg?v=1789488794',
      alt: 'How to find the SKU on your Spy Optic Wayfarer frame'
    },

    {
      id:  'wl160-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl160-fit-photo-guide.jpg?v=1789488794',
      alt: 'How to find the SKU on your Oakley Flak 2.0 frame'
    },
    {
      id:   'wl160-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9295 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Flak 2.0 OO9295 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9295-01, OO9295-02, OO9295-03, OO9295-04, OO9295-05, OO9295-06, OO9295-07, OO9295-08, OO9295-2059</p>'
    },

    {
      id:  'wl166-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl166-fit-photo-guide.jpg?v=1789488794',
      alt: 'How to find the SKU on your Bolle Recoil frame'
    },

    {
      id:  'wl159-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl159.jpg?v=1783257792',
      alt: 'How to find the SKU on your Oakley Tincan frame'
    },
    {
      id:   'wl159-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4082 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Tincan OO4082 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4082-01, OO4082-02, OO4082-03, OO4082-04, OO4082-05, OO4082-06, OO4082-07, OO4082-08, OO4082-09</p>'
    },

    {
      id:  'wl165-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl165-fit-photo-guide.jpg?v=1789488794',
      alt: 'How to find the SKU on your Bolle Anaconda frame'
    },

    {
      id:  'wl158-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl158-fit-photo-guide.jpg?v=1789488796',
      alt: 'How to find the SKU on your Maui Jim World Cup frame'
    },

    {
      id:  'wl163-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl163-fit-photo-guide.jpg?v=1789488797',
      alt: 'How to find the SKU on your Oakley New Valve frame'
    },
    {
      id:   'wl163-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9236 model codes (23)</h3><p style="margin:0 0 14px;">Every Oakley New Valve OO9236 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9236-01, OO9236-02, OO9236-03, OO9236-04, OO9236-05, OO9236-06, OO9236-07, OO9236-10, OO9236-11, OO9236-12, OO9236-13, OO9236-14, OO9236-16, OO9236-17, OO9236-19, OO9236-21, OO9236-22, OO9236-24, OO9236-25, OO9236-27, OO9236-28, OO9236-29, OO9236-3060</p>'
    },

    {
      id:  'wl162-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl162-fit-photo-guide.jpg?v=1789488797',
      alt: 'How to find the SKU on your Oakley Sliver F frame'
    },
    {
      id:   'wl162-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9246 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley Sliver F OO9246 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9246-01, OO9246-02, OO9246-03, OO9246-04, OO9246-05, OO9246-06, OO9246-07, OO9246-10, OO9246-11, OO9246-12, OO9246-13, OO9246-14, OO9246-15, OO9246-16, OO9246-17</p>'
    },

    {
      id:  'wl161-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl161-fit-photo-guide.jpg?v=1789488797',
      alt: 'How to find the SKU on your Oakley Turbine frame'
    },
    {
      id:   'wl161-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9263 model codes (46)</h3><p style="margin:0 0 14px;">Every Oakley Turbine OO9263 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9263-01, OO9263-02, OO9263-03, OO9263-05, OO9263-06, OO9263-07, OO9263-09, OO9263-13, OO9263-14, OO9263-15, OO9263-17, OO9263-18, OO9263-19, OO9263-22, OO9263-23, OO9263-24, OO9263-25, OO9263-28, OO9263-29, OO9263-30, OO9263-31, OO9263-33, OO9263-34, OO9263-37, OO9263-42, OO9263-45, OO9263-57, OO9263-58, OO9263-1063, OO9263-3663, OO9263-3763, OO9263-3863, OO9263-3963, OO9263-4063, OO9263-4163, OO9263-4463, OO9263-4663, OO9263-5063, OO9263-5163, OO9263-5263, OO9263-5463, OO9263-5563, OO9263-5663, OO9263-5963, OO9263-6063, OO9263-6463</p>'
    },

    {
      id:  'wl156-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl156-fit-photo-guide.jpg?v=1789488797',
      alt: 'How to find the SKU on your Maui Jim Ho\'okipa MJ407 frame'
    },

    {
      id:  'wl155-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl155-fit-photo-guide.jpg?v=1789488797',
      alt: 'How to find the SKU on your Maui Jim Banyans frame'
    },

    {
      id:  'wl139-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl139.jpg?v=1783257790',
      alt: 'How to find the SKU on your Oakley Breadbox frame'
    },
    {
      id:   'wl139-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9199 model codes (26)</h3><p style="margin:0 0 14px;">Every Oakley Breadbox OO9199 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9199-01, OO9199-02, OO9199-03, OO9199-04, OO9199-05, OO9199-06, OO9199-07, OO9199-11, OO9199-13, OO9199-14, OO9199-15, OO9199-16, OO9199-17, OO9199-18, OO9199-19, OO9199-26, OO9199-27, OO9199-28, OO9199-29, OO9199-30, OO9199-31, OO9199-32, OO9199-36, OO9199-42, OO9199-43, OO9199-44</p>'
    },

    {
      id:  'wl138-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl138-fit-photo-guide.jpg?v=1789488799',
      alt: 'How to find the SKU on your Oakley Enduro frame'
    },

    {
      id:  'wl137-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl137-fit-photo-guide.jpg?v=1789488799',
      alt: 'How to find the SKU on your Oakley Quarter Jacket frame'
    },
    {
      id:   'wl137-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9200 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley Quarter Jacket OO9200 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9200-01, OO9200-02, OO9200-03, OO9200-04, OO9200-05, OO9200-06, OO9200-07, OO9200-08, OO9200-09, OO9200-16, OO9200-17, OO9200-1961, OO9200-2461, OO9200-2561, OO9200-2661</p>'
    },

    {
      id:  'wl154-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl154-fit-photo-guide.jpg?v=1789488354',
      alt: 'How to find the SKU on your Maui Jim Kanaha frame'
    },

    {
      id:  'wl153-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL153-408-10.jpg?v=1784557323',
      alt: 'How to find the SKU on your Maui Jim Sandy Beach frame'
    },

    {
      id:  'wl136-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl136-fit-photo-guide.jpg?v=1789488799',
      alt: 'How to find the SKU on your Oakley Taper frame'
    },
    {
      id:   'wl136-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4074 model codes (7)</h3><p style="margin:0 0 14px;">Every Oakley Taper OO4074 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4074-01, OO4074-02, OO4074-03, OO4074-04, OO4074-05, OO4074-06, OO4074-07</p>'
    },

    {
      id:  'wl148-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl148-fit-photo-guide.jpg?v=1789488800',
      alt: 'How to find the SKU on your Ray-Ban Round Metal RB3447 (50mm) frame'
    },

    {
      id:  'wl104-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl104-fit-photo-guide.jpg?v=1789488800',
      alt: 'How to find the SKU on your Spy Optic DIRK frame'
    },

    {
      id:  'wl147-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl147-fit-photo-guide.jpg?v=1789488800',
      alt: 'How to find the SKU on your Ray-Ban RB4147 (60mm) frame'
    },

    {
      id:  'wl146-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl146-fit-photo-guide.jpg?v=1789488801',
      alt: 'How to find the SKU on your Ray-Ban Clubmaster RB3016 (49mm) frame'
    },

    {
      id:  'wl102-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl102-fit-photo-guide.jpg?v=1789488802',
      alt: 'How to find the SKU on your Ray-Ban Aviator RB3025 (58mm) frame'
    },

    {
      id:  'wl145-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl145-fit-photo-guide.jpg?v=1789488802',
      alt: 'How to find the SKU on your Ray-Ban Clubmaster RB3016 (51mm) frame'
    },

    {
      id:  'wl101-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl101-fit-photo-guide.jpg?v=1789488803',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB2140 (54mm) frame'
    },

    {
      id:  'wl133-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL133-OO6019-04.jpg?v=1783200697',
      alt: 'How to find the SKU on your Oakley Madman frame'
    },

    {
      id:  'wl144-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl144-fit-photo-guide.jpg?v=1789488803',
      alt: 'How to find the SKU on your Ray-Ban Erika RB4171 (54mm) frame'
    },

    {
      id:  'wl151-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl151-fit-photo-guide.jpg?v=1789488804',
      alt: 'How to find the SKU on your Maui Jim Kahuna frame'
    },

    {
      id:  'wl143-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl143-fit-photo-guide.jpg?v=1789488804',
      alt: 'How to find the SKU on your Oakley Distress frame'
    },

    {
      id:  'wl132-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl132.jpg?v=1783257788',
      alt: 'How to find the SKU on your Oakley Badman frame'
    },
    {
      id:   'wl132-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO6020 model codes (7)</h3><p style="margin:0 0 14px;">Every Oakley Badman OO6020 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO6020-01, OO6020-02, OO6020-03, OO6020-04, OO6020-05, OO6020-06, OO6020-07</p>'
    },

    {
      id:  'wl142-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl142-fit-photo-guide.jpg?v=1789488805',
      alt: 'How to find the SKU on your Oakley Feedback frame'
    },

    {
      id:  'wl141-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl141-fit-photo-guide.jpg?v=1789488807',
      alt: 'How to find the SKU on your Oakley Pulse frame'
    },

    {
      id:  'wl131-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl131-fit-photo-guide.jpg?v=1789488805',
      alt: 'How to find the SKU on your Oakley Flak 2.0 XL frame'
    },
    {
      id:   'wl131-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9188 model codes (123)</h3><p style="margin:0 0 14px;">Every Oakley Flak 2.0 XL OO9188 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9188-01, OO9188-02, OO9188-03, OO9188-04, OO9188-05, OO9188-06, OO9188-07, OO9188-08, OO9188-09, OO9188-10, OO9188-11, OO9188-12, OO9188-13, OO9188-14, OO9188-15, OO9188-16, OO9188-17, OO9188-18, OO9188-19, OO9188-20, OO9188-21, OO9188-22, OO9188-23, OO9188-24, OO9188-31, OO9188-38, OO9188-40, OO9188-41, OO9188-42, OO9188-43, OO9188-44, OO9188-46, OO9188-47, OO9188-49, OO9188-50, OO9188-51, OO9188-52, OO9188-53, OO9188-54, OO9188-55, OO9188-57, OO9188-58, OO9188-59, OO9188-60, OO9188-6159, OO9188-6459, OO9188-6559, OO9188-6659, OO9188-6759, OO9188-6859, OO9188-7059, OO9188-7159, OO9188-7259, OO9188-7359, OO9188-7459, OO9188-7659, OO9188-7759, OO9188-7959, OO9188-8059, OO9188-8159, OO9188-8259, OO9188-8359, OO9188-8459, OO9188-8559, OO9188-8659, OO9188-8759, OO9188-8859, OO9188-8959, OO9188-9059, OO9188-9159, OO9188-9259, OO9188-9359, OO9188-9459, OO9188-9559, OO9188-9659, OO9188-9859, OO9188-9959, OO9188-A059, OO9188-A659, OO9188-A759, OO9188-A859, OO9188-A959, OO9188-B159, OO9188-B259, OO9188-B359, OO9188-B559, OO9188-B859, OO9188-C659, OO9188-D059, OO9188-D359, OO9188-D759, OO9188-E059, OO9188-F359, OO9188-F459, OO9188-F759, OO9188-F859, OO9188-F959, OO9188-G059, OO9188-G159, OO9188-G359, OO9188-G559, OO9188-G659, OO9188-G759, OO9188-H159, OO9188-H259, OO9188-H359, OO9188-I459, OO9188-I559, OO9188-I659, OO9188-I759, OO9188-I859, OO9188-I959, OO9188-J059, OO9188-J159, OO9188-J259, OO9188-J359, OO9188-J459, OO9188-J559, OO9188-J659, OO9188-J859, OO9188-J959, OO9188-K159, OO9188-K259</p>'
    },

    
    {
      id:  'wl119-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl119-fit-photo-guide.jpg?v=1789488806',
      alt: 'How to find the SKU on your Spy Optic Dirty MO frame'
    },

    {
      id:  'wl118-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl118.jpg?v=1783257786',
      alt: 'How to find the SKU on your Spy Optic MC frame'
    },

    {
      id:  'wl130-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl130-fit-photo-guide.jpg?v=1789488806',
      alt: 'How to find the SKU on your Oakley Crankshaft frame'
    },
    {
      id:   'wl130-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9239 model codes (20)</h3><p style="margin:0 0 14px;">Every Oakley Crankshaft OO9239 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9239-01, OO9239-02, OO9239-03, OO9239-04, OO9239-05, OO9239-06, OO9239-07, OO9239-08, OO9239-09, OO9239-11, OO9239-12, OO9239-14, OO9239-16, OO9239-18, OO9239-20, OO9239-22, OO9239-23, OO9239-2560, OO9239-2660, OO9239-3060</p>'
    },

    {
      id:  'wl117-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl117-fit-photo-guide.jpg?v=1789488807',
      alt: 'How to find the SKU on your Spy Optic Logan frame'
    },

    {
      id:  'wl109-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl109-fit-photo-guide.jpg?v=1789488807',
      alt: 'How to find the SKU on your Oakley TwoFace frame'
    },
    {
      id:   'wl109-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9189 model codes (36)</h3><p style="margin:0 0 14px;">Every Oakley TwoFace OO9189 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9189-01, OO9189-02, OO9189-03, OO9189-04, OO9189-05, OO9189-06, OO9189-08, OO9256-09, OO9189-11, OO9189-12, OO9189-13, OO9189-14, OO9189-15, OO9189-17, OO9189-18, OO9189-20, OO9189-21, OO9189-22, OO9189-26, OO9189-28, OO9189-30, OO9189-32, OO9189-34, OO9189-3560, OO9189-3660, OO9189-3760, OO9189-3860, OO9189-3960, OO9189-4060, OO9189-4160, OO9189-4260, OO9189-4360, OO9189-4560, OO9189-4660, OO9189-4760, OO9189-4860</p>'
    },

    {
      id:  'wl116-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl116-fit-photo-guide.jpg?v=1789488808',
      alt: 'How to find the SKU on your Spy Optic Cooper frame'
    },

    
    {
      id:  'wl129-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl129-fit-photo-guide.jpg?v=1789488809',
      alt: 'How to find the SKU on your Oakley Commit SQ frame'
    },

    {
      id:  'wl128-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl128-fit-photo-guide.jpg?v=1789488809',
      alt: 'How to find the SKU on your Oakley Pit Boss II frame'
    },
    {
      id:   'wl128-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9137 model codes (3)</h3><p style="margin:0 0 14px;">Every Oakley Pit Boss II OO9137 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9137-01, OO9137-02, OO9137-03</p>'
    },

    {
      id:  'wl127-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl127-fit-photo-guide.jpg?v=1789488810',
      alt: 'How to find the SKU on your Oakley Scalpel frame'
    },
    {
      id:   'wl127-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9095 model codes (21)</h3><p style="margin:0 0 14px;">Every Oakley Scalpel OO9095 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9095-01, OO9095-02, OO9095-03, OO9095-04, OO9095-05, OO9095-06, OO9095-07, OO9095-08, OO9095-09, OO9095-10, OO9095-11, OO9095-12, OO9095-14, OO9095-15, OO9095-16, OO9095-18, OO9095-19, OO9095-22, OO9095-23, OO9095-26, OO9095-28</p>'
    },

    {
      id:  'wl126-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl126-fit-photo-guide.jpg?v=1789488810',
      alt: 'How to find the SKU on your Oakley Razrwire frame'
    },

    {
      id:  'wl125-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl125-fit-photo-guide.jpg?v=1789488810',
      alt: 'How to find the SKU on your Ray-Ban RB8301 (59mm) frame'
    },

    {
      id:  'wl124-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl124-fit-photo-guide.jpg?v=1789488811',
      alt: 'How to find the SKU on your Ray-Ban RB3183 (63mm) frame'
    },

    {
      id:  'wl114-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl114-fit-photo-guide.jpg?v=1789488811',
      alt: 'How to find the SKU on your Oakley M2 frame'
    },
    {
      id:   'wl114-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9212 model codes (14)</h3><p style="margin:0 0 14px;">Every Oakley M2 OO9212 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9212-01, OO9212-02, OO9212-03, OO9212-04, OO9212-05, OO9212-06, OO9212-07, OO9212-08, OO9343-10, OO9212-12, OO9212-13, OO9212-17, OO9212-18, OO9212-19</p>'
    },

    {
      id:  'wl123-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl123-fit-photo-guide.jpg?v=1789488814',
      alt: 'How to find the SKU on your Ray-Ban RB4115 frame'
    },

    {
      id:  'wl113-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl113-fit-photo-guide.jpg?v=1789488814',
      alt: 'How to find the SKU on your Oakley Offshoot frame'
    },
    {
      id:   'wl113-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9190 model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley Offshoot OO9190 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9190-01, OO9190-02, OO9190-03, OO9190-04, OO9190-05, OO9190-07, OO9190-09, OO9190-10, OO9190-11, OO9190-12</p>'
    },

    {
      id:  'wl122-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl122-fit-photo-guide.jpg?v=1789488813',
      alt: 'How to find the SKU on your Costa Del Mar Brine frame'
    },

    {
      id:  'wl112-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl112-fit-photo-guide.jpg?v=1789488813',
      alt: 'How to find the SKU on your Oakley Plaintiff Squared frame'
    },
    {
      id:   'wl112-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4063 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley Plaintiff Squared OO4063 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4063-01, OO4063-02, OO4063-03, OO4063-04, OO4063-06, OO4063-07, OO4063-08, OO4063-09, OO4063-10</p>'
    },

    {
      id:  'wl121-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl121-fit-photo-guide.jpg?v=1789488814',
      alt: 'How to find the SKU on your Costa Del Mar Fantail frame'
    },

    {
      id:  'wl111-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl111-fit-photo-guide.jpg?v=1789488814',
      alt: 'How to find the SKU on your Oakley Big Taco frame'
    },
    {
      id:   'wl111-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9173 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Big Taco OO9173 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9173-01, OO9173-02, OO9173-03, OO9173-04, OO9173-05, OO9173-06, OO9173-07, OO9173-08, OO9173-09, OO9173-10, OO9173-11</p>'
    },

    {
      id:  'wl080-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl080-fit-photo-guide.jpg?v=1789488815',
      alt: 'How to find the SKU on your Oakley Caveat frame'
    },

    {
      id:  'wl090-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl090-fit-photo-guide.jpg?v=1789488816',
      alt: 'How to find the SKU on your Oakley Bottle Rocket frame'
    },
    {
      id:   'wl090-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9164 model codes (14)</h3><p style="margin:0 0 14px;">Every Oakley Bottle Rocket OO9164 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9164-01, OO9164-02, OO9164-04, OO9164-05, OO9164-06, OO9164-07, OO9164-08, OO9164-09, OO9164-10, OO9164-11, OO9164-12, OO9164-13, OO9164-14, OO9164-15</p>'
    },

    {
      id:  'wl089-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl089-fit-photo-guide.jpg?v=1789488816',
      alt: 'How to find the SKU on your Oakley Crankcase frame'
    },
    {
      id:   'wl089-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9165 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley Crankcase OO9165 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9165-01, OO9165-02, OO9165-03, OO9165-05, OO9165-06, OO9165-07, OO9165-08, OO9165-09, OO9165-12, OO9165-13, OO9165-14</p>'
    },

    {
      id:  'wl088-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl088-fit-photo-guide.jpg?v=1789488817',
      alt: 'How to find the SKU on your Oakley Jupiter Squared frame'
    },
    {
      id:   'wl088-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9135 model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley Jupiter Squared OO9135 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9135-01, OO9135-02, OO9135-03, OO9135-04, OO9135-05, OO9135-06, OO9135-07, OO9135-08, OO9135-09, OO9135-10, OO9135-11, OO9135-12, OO9135-13, OO9135-14, OO9135-15, OO9135-16, OO9135-19, OO9135-20, OO9135-23, OO9135-25, OO9135-26, OO9135-2956, OO9135-3356, OO9135-3456</p>'
    },

    {
      id:  'wl087-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl087-fit-photo-guide.jpg?v=1789488817',
      alt: 'How to find the SKU on your Oakley New Crosshair frame'
    },
    {
      id:   'wl087-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4060 model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley New Crosshair OO4060 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4060-01, OO6014-01, OO4060-02, OO6014-02, OO4060-03, OO4060-04, OO4060-05, OO4060-06, OO4060-08, OO4060-09, OO4060-10, OO4060-11, OO4060-13, OO4060-2261, OO4060-2361</p>'
    },

    {
      id:  'wl108-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl108-fit-photo-guide.jpg?v=1789488817',
      alt: 'How to find the SKU on your Oakley M Frame Strike (Vented) frame'
    },
    {
      id:   'wl108-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9024 model codes (1)</h3><p style="margin:0 0 14px;">Every Oakley M Frame Strike (Vented) OO9024 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9024-01</p>'
    },

    {
      id:  'wl107-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl107-fit-photo-guide.jpg?v=1789488818',
      alt: 'How to find the SKU on your Oakley M Frame Heater (Vented) frame'
    },

    {
      id:  'wl106-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl106-fit-photo-guide.jpg?v=1789488818',
      alt: 'How to find the SKU on your Oakley M Frame Hybrid (Vented) frame'
    },
    {
      id:   'wl106-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9024 model codes (2)</h3><p style="margin:0 0 14px;">Every Oakley M Frame Hybrid (Vented) OO9024 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9024-04, OO9024-0729</p>'
    },

    {
      id:  'wl105-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl105-fit-photo-guide.jpg?v=1789488819',
      alt: 'How to find the SKU on your Oakley M Frame Sweep (Vented) frame'
    },
    {
      id:   'wl105-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9059 model codes (1)</h3><p style="margin:0 0 14px;">Every Oakley M Frame Sweep (Vented) OO9059 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9059-01</p>'
    },

    {
      id:  'wl039-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl039-fit-photo-guide.jpg?v=1789488820',
      alt: 'How to find the SKU on your Oakley X Squared frame'
    },
    {
      id:   'wl039-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO6011 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley X Squared OO6011 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO6011-01, OO6011-02, OO6011-03, OO6011-04, OO6011-05, OO6011-06, OO6011-08, OO6011-09, OO6011-10</p>'
    },

    {
      id:  'wl103-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl103-fit-photo-guide.jpg?v=1789488820',
      alt: 'How to find the SKU on your Oakley Style Switch frame'
    },
    {
      id:   'wl103-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9194 model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Style Switch OO9194 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9194-01, OO9194-02, OO9194-03, OO9194-04, OO9194-05, OO9194-06, OO9194-07, OO9194-08, OO9194-10, OO9194-11, OO9194-12, OO9194-13, OO9194-14, OO9194-15, OO9194-24, OO9194-26, OO9194-27</p>'
    },

    {
      id:  'wl038-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl038-fit-photo-guide.jpg?v=1789488820',
      alt: 'How to find the SKU on your Oakley X Metal XX frame'
    },

    {
      id:  'wl035-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl035-fit-photo-guide.jpg?v=1789488821',
      alt: 'How to find the SKU on your Oakley Straight Jacket frame'
    },

    {
      id:  'wl033-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl033-fit-photo-guide.jpg?v=1789488821',
      alt: 'How to find the SKU on your Oakley Split Jacket (vented) frame'
    },
    {
      id:   'wl033-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9099 model codes (26)</h3><p style="margin:0 0 14px;">Every Oakley Split Jacket (vented) OO9099 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9099-01, OO9099-02, OO9099-03, OO9099-04, OO9099-05, OO9099-06, OO9099-07, OO9099-08, OO9099-11, OO9099-12, OO9099-13, OO9099-14, OO9099-15, OO9099-16, OO9099-17, OO9099-18, OO9099-19, OO9099-20, OO9099-21, OO9099-22, OO9099-23, OO9099-24, OO9099-25, OO9099-26, OO9099-27, OO9099-28</p>'
    },

    {
      id:  'wl032-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl032-fit-photo-guide.jpg?v=1789488821',
      alt: 'How to find the SKU on your Oakley Split Jacket frame'
    },
    {
      id:   'wl032-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9099 model codes (26)</h3><p style="margin:0 0 14px;">Every Oakley Split Jacket OO9099 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9099-01, OO9099-02, OO9099-03, OO9099-04, OO9099-05, OO9099-06, OO9099-07, OO9099-08, OO9099-11, OO9099-12, OO9099-13, OO9099-14, OO9099-15, OO9099-16, OO9099-17, OO9099-18, OO9099-19, OO9099-20, OO9099-21, OO9099-22, OO9099-23, OO9099-24, OO9099-25, OO9099-26, OO9099-27, OO9099-28</p>'
    },

    {
      id:  'wl070-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl070-fit-photo-guide.jpg?v=1789488822',
      alt: 'How to find the SKU on your Oakley Minute 2.0 frame'
    },

        {
      id:   'wl031-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Oakley Radar Path — compatible part numbers (66)</h3><p style="margin:0;line-height:2;word-spacing:2px;">OO9051-01, OO9051-04, OO9051-08, OO9051-09, 09-670, 09-670L1, 09-671, 09-672, 09-673, 09-674, 09-675, 09-689, 09-698, 09-720, 09-721, 09-722, 09-729, 09-730, 09-731, 09-748, 09-749, 09-751, 09-752J, 09-757, 09-758, 09-760, 09-761, 09-762, 09-765, 09-767, 09-772, 09-773, 09-774, 09-775, 09-776, 09-777, 09-778, 09-779, 09-780, 09-781, 09-782, 1-762, 1-767, 11-472, 12-763, 12-763L1, 12-780, 12-799, 24-037, 24-147, 24-219, 24-275, 24-280, 24-301, 24-302, 24-322, 24-327, 24-371, 26-212, 26-213, 26-214, 26-215, 26-266, 26-267, 26-268, 42-421</p>'
    },

    {
      id:  'wl069-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl069-fit-photo-guide.jpg?v=1789488822',
      alt: 'How to find the SKU on your Oakley Racing Jacket (vented) frame'
    },
    {
      id:   'wl069-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9171 model codes (43)</h3><p style="margin:0 0 14px;">Every Oakley Racing Jacket (vented) OO9171 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9171-02, OO9171-03, OO9171-04, OO9171-05, OO9171-06, OO9195-07, OO9171-07, OO9171-08, OO9171-09, OO9171-10, OO9171-11, OO9171-12, OO9171-13, OO9171-14, OO9171-15, OO9171-16, OO9171-17, OO9171-18, OO9171-19, OO9171-20, OO9171-21, OO9171-22, OO9171-23, OO9171-24, OO9171-25, OO9171-26, OO9171-27, OO9171-28, OO9171-29, OO9171-30, OO9171-31, OO9171-32, OO9171-33, OO9171-35, OO9171-36, OO9171-38, OO9171-39, OO9171-3762, OO9171-3862, OO9171-4062, OO9171-4162, OO9171-4262, OO9171-4362</p>'
    },

    {
      id:  'wl068-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl068-fit-photo-guide.jpg?v=1789488823',
      alt: 'How to find the SKU on your Oakley Racing Jacket frame'
    },
    {
      id:   'wl068-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9171 model codes (43)</h3><p style="margin:0 0 14px;">Every Oakley Racing Jacket OO9171 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9171-02, OO9171-03, OO9171-04, OO9171-05, OO9171-06, OO9195-07, OO9171-07, OO9171-08, OO9171-09, OO9171-10, OO9171-11, OO9171-12, OO9171-13, OO9171-14, OO9171-15, OO9171-16, OO9171-17, OO9171-18, OO9171-19, OO9171-20, OO9171-21, OO9171-22, OO9171-23, OO9171-24, OO9171-25, OO9171-26, OO9171-27, OO9171-28, OO9171-29, OO9171-30, OO9171-31, OO9171-32, OO9171-33, OO9171-35, OO9171-36, OO9171-38, OO9171-39, OO9171-3762, OO9171-3862, OO9171-4062, OO9171-4162, OO9171-4262, OO9171-4362</p>'
    },

    {
      id:  'wl067-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl067-fit-photo-guide.jpg?v=1789488823',
      alt: 'How to find the SKU on your Oakley Splinter frame'
    },

    {
      id:  'wl060-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl060-fit-photo-guide.jpg?v=1789488833',
      alt: 'How to find the SKU on your Oakley Half Jacket 2.0 XL frame'
    },
    {
      id:   'wl060-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9154 model codes (43)</h3><p style="margin:0 0 14px;">Every Oakley Half Jacket 2.0 XL OO9154 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9154-01, OO9154-02, OO9154-05, OO9155-06, OO9154-06, OO9154-08, OO9154-11, OO9154-12, OO9154-13, OO9154-14, OO9154-15, OO9154-16, OO9154-17, OO9154-19, OO9154-20, OO9154-21, OO9154-23, OO9154-24, OO9154-25, OO9154-26, OO9154-27, OO9154-28, OO9154-29, OO9154-33, OO9154-34, OO9154-35, OO9154-36, OO9154-37, OO9154-38, OO9154-39, OO9154-40, OO9154-41, OO9154-42, OO9154-43, OO9154-44, OO9154-45, OO9154-46, OO9154-49, OO9154-51, OO9154-52, OO9154-53, OO9154-54, OO9154-65</p>'
    },

    {
      id:  'wl066-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl066-fit-photo-guide.jpg?v=1789488824',
      alt: 'How to find the SKU on your Oakley M Frame Strike frame'
    },

    {
      id:  'wl059-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl059-fit-photo-guide.jpg?v=1789488825',
      alt: 'How to find the SKU on your Oakley Hatchet Wire frame'
    },

    {
      id:  'wl058-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl058-fit-photo-guide.jpg?v=1789488825',
      alt: 'How to find the SKU on your Oakley Square Wire 2.0 frame'
    },

    {
      id:  'wl056-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl056-fit-photo-guide.jpg?v=1789488826',
      alt: 'How to find the SKU on your Oakley Ten frame'
    },
    {
      id:   'wl056-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9128 model codes (14)</h3><p style="margin:0 0 14px;">Every Oakley Ten OO9128 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9128-01, OO9128-02, OO9128-03, OO9128-04, OO9128-05, OO9128-06, OO9128-07, OO9128-08, OO9128-09, OO9128-10, OO9128-11, OO9128-12, OO9128-13, OO9128-16</p>'
    },

    {
      id:  'wl065-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl065-fit-photo-guide.jpg?v=1789488826',
      alt: 'How to find the SKU on your Oakley M Frame Heater frame'
    },

    {
      id:  'wl055-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl055-fit-photo-guide.jpg?v=1789488826',
      alt: 'How to find the SKU on your Oakley Jury frame'
    },
    {
      id:   'wl055-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4045 model codes (6)</h3><p style="margin:0 0 14px;">Every Oakley Jury OO4045 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4045-01, OO4045-02, OO4045-03, OO4045-04, OO4045-05, OO4045-06</p>'
    },

    {
      id:  'wl054-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl054-fit-photo-guide.jpg?v=1789488828',
      alt: 'How to find the SKU on your Oakley Fives 3.0 frame'
    },

    {
      id:  'wl052-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl052-fit-photo-guide.jpg?v=1789488828',
      alt: 'How to find the SKU on your Oakley Bottlecap frame'
    },

    {
      id:  'wl064-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl064-fit-photo-guide.jpg?v=1789488828',
      alt: 'How to find the SKU on your Oakley Half Jacket 2.0 frame'
    },
    {
      id:   'wl064-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9144 model codes (13)</h3><p style="margin:0 0 14px;">Every Oakley Half Jacket 2.0 OO9144 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9144-01, OO9144-02, OO9144-04, OO9144-05, OO9144-08, OO9144-11, OO9144-12, OO9144-16, OO9144-17, OO9144-19, OO9144-20, OO9144-2262, OO9144-2362</p>'
    },

    {
      id:  'wl051-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl051-fit-photo-guide.jpg?v=1789488829',
      alt: 'How to find the SKU on your Oakley Half Wire 2.0 frame'
    },

    {
      id:  'wl063-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl063-fit-photo-guide.jpg?v=1789488829',
      alt: 'How to find the SKU on your Oakley RadarLock Pitch frame'
    },
    {
      id:   'wl063-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9182 model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley RadarLock Pitch OO9182 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9182-01, OO9182-03, OO9182-05, OO9182-07, OO9182-10, OO9182-11, OO9182-12, OO9182-13, OO9182-14, OO9182-16, OO9182-1838</p>'
    },

    {
      id:  'wl057-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl057-fit-photo-guide.jpg?v=1789488830',
      alt: 'How to find the SKU on your Oakley Antix frame'
    },

    {
      id:  'wl062-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl062-fit-photo-guide.jpg?v=1789488830',
      alt: 'How to find the SKU on your Oakley Batwolf frame'
    },
    {
      id:   'wl062-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9101 model codes (52)</h3><p style="margin:0 0 14px;">Every Oakley Batwolf OO9101 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9101-01, OO9101-02, OO9101-03, OO9101-04, OO9101-05, OO9101-06, OO9101-07, OO9101-08, OO9101-10, OO9101-11, OO9101-12, OO9101-13, OO9101-14, OO9101-15, OO9101-16, OO9101-17, OO9101-18, OO9101-19, OO9101-20, OO9101-22, OO9101-23, OO9101-24, OO9101-25, OO9101-28, OO9101-29, OO9101-30, OO9101-32, OO9101-34, OO9101-35, OO9101-36, OO9101-37, OO9101-38, OO9101-39, OO9101-40, OO9101-41, OO9101-42, OO9101-43, OO9101-44, OO9101-45, OO9101-46, OO9101-47, OO9101-48, OO9101-51, OO9101-5427, OO9101-5527, OO9101-5727, OO9101-5827, OO9101-6127, OO9101-6227, OO9101-6327, OO9101-6827, OO9101-6927</p>'
    },

    {
      id:  'wl061-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl061-fit-photo-guide.jpg?v=1789488830',
      alt: 'How to find the SKU on your Oakley Plaintiff frame'
    },
    {
      id:   'wl061-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4057 model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Plaintiff OO4057 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4057-01, OO4057-02, OO4057-03, OO4057-04, OO4057-05, OO4057-06, OO4057-07, OO4057-08, OO4057-09, OO4057-10, OO4057-11, OO4057-12, OO4057-13, OO4057-14, OO4057-16, OO4057-25, OO4057-27</p>'
    },

    {
      id:  'wl053-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl053-fit-photo-guide.jpg?v=1789488831',
      alt: 'How to find the SKU on your Oakley M Frame Hybrid frame'
    },

    {
      id:  'wl100-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl100-fit-photo-guide.jpg?v=1789488831',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB2140 (50mm) frame'
    },

    {
      id:  'wl086-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl086-fit-photo-guide.jpg?v=1789488833',
      alt: 'How to find the SKU on your Oakley Fatcat frame'
    },

    {
      id:  'wl079-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl079-fit-photo-guide.jpg?v=1789488833',
      alt: 'How to find the SKU on your Oakley Dispatch II frame'
    },

    {
      id:  'wl078-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl078.jpg?v=1783257784',
      alt: 'How to find the SKU on your Oakley Radar Pitch frame'
    },

    {
      id:  'wl085-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl085-fit-photo-guide.jpg?v=1789488833',
      alt: 'How to find the SKU on your Oakley Oil Drum II frame'
    },

    {
      id:  'wl099-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl099-fit-photo-guide.jpg?v=1789488834',
      alt: 'How to find the SKU on your Ray-Ban Aviator RB3044 (52mm) frame'
    },

    {
      id:  'wl098-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl098-fit-photo-guide.jpg?v=1789488836',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB4105 (50mm) frame'
    },

    {
      id:  'wl077-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl077.jpg?v=1783257782',
      alt: 'How to find the SKU on your Oakley Radar Range frame'
    },

    {
      id:  'wl084-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl084-fit-photo-guide.jpg?v=1789488835',
      alt: 'How to find the SKU on your Oakley RadarLock XL Vented frame'
    },

    {
      id:  'wl097-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl097-fit-photo-guide.jpg?v=1789488835',
      alt: 'How to find the SKU on your Ray-Ban RB4075 (61mm) frame'
    },

    {
      id:  'wl076-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl076-fit-photo-guide.jpg?v=1789488836',
      alt: 'How to find the SKU on your Oakley Dart frame'
    },

    {
      id:  'wl083-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl083-fit-photo-guide.jpg?v=1789488836',
      alt: 'How to find the SKU on your Ray-Ban Aviator RB3025 (55mm) frame'
    },

    {
      id:  'wl096-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl096-fit-photo-guide.jpg?v=1789488842',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB4105 (54mm) frame'
    },

    {
      id:  'wl095-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl095-fit-photo-guide.jpg?v=1789488838',
      alt: 'How to find the SKU on your Ray-Ban Aviator RB3025 (62mm) frame'
    },

    {
      id:  'wl075-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl075.jpg?v=1783257780',
      alt: 'How to find the SKU on your Oakley Deviation frame'
    },

    {
      id:  'wl082-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl082-fit-photo-guide.jpg?v=1789488838',
      alt: 'How to find the SKU on your Oakley RadarLock Path frame'
    },
    {
      id:   'wl082-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9181 model codes (46)</h3><p style="margin:0 0 14px;">Every Oakley RadarLock Path OO9181 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9181-01, OO9181-02, OO9181-03, OO9181-04, OO9181-05, OO9181-06, OO9181-07, OO9181-08, OO9181-09, OO9181-10, OO9181-11, OO9181-12, OO9181-15, OO9181-16, OO9181-17, OO9181-18, OO9181-19, OO9181-20, OO9181-21, OO9181-22, OO9181-23, OO9181-24, OO9181-25, OO9181-26, OO9181-28, OO9181-29, OO9181-30, OO9181-31, OO9181-32, OO9181-33, OO9181-34, OO9181-35, OO9181-36, OO9181-37, OO9181-40, OO9181-41, OO9181-42, OO9181-44, OO9181-45, OO9181-46, OO9181-47, OO9181-48, OO9181-49, OO9181-53, OO9181-57, OO9181-59</p>'
    },

    {
      id:  'wl094-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl094-fit-photo-guide.jpg?v=1789488838',
      alt: 'How to find the SKU on your Oakley Half Wire XL frame'
    },

    {
      id:  'wl074-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl074-fit-photo-guide.jpg?v=1789488839',
      alt: 'How to find the SKU on your Oakley New Twenty frame'
    },

    {
      id:  'wl081-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl081-fit-photo-guide.jpg?v=1789488839',
      alt: 'How to find the SKU on your Oakley Tightrope frame'
    },
    {
      id:   'wl081-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4040 model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley Tightrope OO4040 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4040-01, OO4040-02, OO4040-03, OO4040-04, OO4040-05, OO4040-06, OO4040-07, OO4040-09</p>'
    },

    {
      id:  'wl093-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl093-fit-photo-guide.jpg?v=1789488841',
      alt: 'How to find the SKU on your Rudy Project Noyz frame'
    },

    {
      id:  'wl071-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl071-fit-photo-guide.jpg?v=1789488841',
      alt: 'How to find the SKU on your Oakley Probation frame'
    },

    {
      id:  'wl092-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl092-fit-photo-guide.jpg?v=1789488841',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB2132 (52mm) frame'
    },

    {
      id:  'wl072-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl072-fit-photo-guide.jpg?v=1789488841',
      alt: 'How to find the SKU on your Ray-Ban Wayfarer RB2132 55mm frame'
    },

    {
      id:  'wl050-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl050-fit-photo-guide.jpg?v=1789488841',
      alt: 'How to find the SKU on your Oakley M Frame Sweep frame'
    },

    {
      id:  'wl091-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl091-fit-photo-guide.jpg?v=1789488843',
      alt: 'How to find the SKU on your Oakley Blender frame'
    },
    {
      id:   'wl091-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4059 model codes (12)</h3><p style="margin:0 0 14px;">Every Oakley Blender OO4059 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4059-01, OO4059-02, OO4059-03, OO4059-04, OO4059-05, OO4059-06, OO4059-08, OO4059-10, OO4059-11, OO4059-12, OO4059-13, OO4059-15</p>'
    },

    {
      id:  'wl073-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl073-fit-photo-guide.jpg?v=1789488843',
      alt: 'How to find the SKU on your Rudy Project Rydon frame'
    },

    {
      id:  'wl028-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl028-fit-photo-guide.jpg?v=1789488844',
      alt: 'How to find the SKU on your Oakley Oil Rig II frame'
    },

        {
      id:   'wl045-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Oakley Radar Path — compatible part numbers (62)</h3><p style="margin:0;line-height:2;word-spacing:2px;">09-670, 09-670L1, 09-671, 09-672, 09-673, 09-674, 09-675, 09-689, 09-698, 09-720, 09-721, 09-722, 09-729, 09-730, 09-731, 09-748, 09-749, 09-751, 09-752J, 09-757, 09-758, 09-760, 09-761, 09-762, 09-765, 09-767, 09-772, 09-773, 09-774, 09-775, 09-776, 09-777, 09-778, 09-779, 09-780, 09-781, 09-782, 1-762, 1-767, 11-472, 12-763, 12-763L1, 12-780, 12-799, 24-037, 24-147, 24-219, 24-275, 24-280, 24-301, 24-302, 24-322, 24-327, 24-371, 26-212, 26-213, 26-214, 26-215, 26-266, 26-267, 26-268, 42-421</p>'
    },

    {
      id:  'wl027-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl027-fit-photo-guide.jpg?v=1789488844',
      alt: 'How to find the SKU on your Oakley Monster Dog frame'
    },

    {
      id:  'wl024-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl024-fit-photo-guide.jpg?v=1789488845',
      alt: 'How to find the SKU on your Oakley Juliet (vented) frame'
    },
    {
      id:   'wl024-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4064 model codes (1)</h3><p style="margin:0 0 14px;">Every Oakley Juliet (vented) OO4064 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4064-01</p>'
    },

    {
      id:  'wl022-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl022-fit-photo-guide.jpg?v=1789488845',
      alt: 'How to find the SKU on your Oakley Jawbone (vented) frame'
    },

    {
      id:  'wl007-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl007-fit-photo-guide.jpg?v=1789488846',
      alt: 'How to find the SKU on your Oakley Flak Jacket XLJ frame'
    },
    {
      id:   'wl007-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9009 model codes (22)</h3><p style="margin:0 0 14px;">Every Oakley Flak Jacket XLJ OO9009 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9009-01, OO9009-02, OO9009-05, OO9009-06, OO9009-07, OO9009-08, OO9009-09, OO9009-10, OO9009-11, OO9009-12, OO9009-13, OO9009-14, OO9009-15, OO9009-20, OO9009-22, OO9009-23, OO9009-25, OO9009-2763, OO9009-2863, OO9009-2963, OO9009-3063, OO9009-3263</p>'
    },

    {
      id:  'wl006-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl006-fit-photo-guide.jpg?v=1789488846',
      alt: 'How to find the SKU on your Oakley Flak Jacket frame'
    },
    {
      id:   'wl006-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9008 model codes (1)</h3><p style="margin:0 0 14px;">Every Oakley Flak Jacket OO9008 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9008-14</p>'
    },

    {
      id:   'we011-3229-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Path model codes (47)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Path</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9181-08, OO9181-24, OO9181-59, OO9181-34, OO9181-45, OO9181-44, OO9181-47, OO9181-46, OO9181-29, OO9181-57, OO9181-11, OO9181-48, OO9181-16, OO9181-09, OO9181-26, OO9181-49, OO9181-10, OO9181-06, OO9181-23, OO9181-07, OO9181-04, OO9181-37, OO9181-02, OO9181-20, OO9181-15, OO9181-01, OO9181-36, OO9181-18, OO9181-14, OO9181-31, OO9181-41, OO9181-25, OO9181-28, OO9181-53, OO9181-42, OO9181-19, OO9181-12, OO9181-17, OO9181-32, OO9181-33, OO9181-05, OO9181-35, OO9181-30, OO9181-40, OO9181-22, OO9181-03, OO9181-21</p>'
    },
    {
      id:   'we011-3433-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Edge model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Edge</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9183-03, OO9183-08, OO9183-04, OO9183-05, OO9183-02, OO9183-07, OO9183-01, OO9183-06</p>'
    },
    {
      id:   'we011-3156-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Pitch model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Pitch</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9182-05, OO9182-14, OO9182-13, OO9182-16, OO9182-01, OO9182-10, OO9182-03, OO9182-11, OO9182-07, OO9182-12, OO9182-1838</p>'
    },

    {
      id:   'we007-2627-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Path model codes (66)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Path</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">24-147, 24-037, 24-327, 24-275, 09-671, 09-749, 24-302, OO9051-01, 1-762, 26-266, 09-752J, 24-301, 26-213, 09-720, 09-674, 09-689, 09-670, 09-670L1, 12-763, 12-763L1, 09-748, 11-472, 24-322, 09-675, 26-214, 09-730, 42-421, 26-215, 09-672, 09-698, 09-772, 09-731, OO9051-04, 09-760, 26-268, 09-761, 09-777, 09-782, 09-779, 09-775, 09-780, 09-774, 09-773, OO9051-08, 09-757, 09-778, 09-776, 09-721, 09-758, 09-765, 26-267, 12-799, 24-371, 09-767, 26-212, 09-762, 09-781, 24-219, 09-729, 12-780, OO9051-09, 09-751, 09-722, 24-280, 09-673, 1-767</p>'
    },
    {
      id:   'we007-3230-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Edge model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Edge</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9184-13, OO9184-12, OO9184-10, OO9184-03, OO9184-17, OO9184-15, OO9184-02, OO9184-05, OO9184-08, OO9184-09, OO9184-04, OO9184-16, OO9184-07, OO9184-14, OO9184-01</p>'
    },

    {
      id:   'we005-110-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Sweep, New model codes (27)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Sweep, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">09-137, 09-009, 09-101, 09-011, 09-010, 09-176, 09-117, 09-126, 09-194, 09-192, 09-121, 09-154, 09-142, 09-109, 09-185, 09-234, 09-149, 09-239, 09-113, 09-236, 42-308, 09-182, 09-105, 12-589, 09-193, OO9059-01, 09-611</p>'
    },
    {
      id:   'we005-104-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame New Hybrid, New model codes (60)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame New Hybrid, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">11-108, 09-139, 11-054, OO9024-04, 11-055, 09-103, 11-057, 11-109, 11-096, 11-056, 13-852, 12-556, 09-175, 13-860, 13-851, 12-554, 13-854, 09-119, 09-128, 13-857, 13-862, 13-874, 13-864, 12-570, 09-197, 09-198, 12-508, 12-553, 13-866, 13-865, 13-873, 09-123, 09-156, 09-144, 09-111, 09-187, 09-235, 09-151, 09-115, 12-555, 13-861, 13-869, 13-867, 13-870, 13-853, 13-872, 13-850, 13-856, 13-871, 13-863, 09-107, 12-557, 09-146, 09-196, 13-855, 13-858, 13-859, 13-868, 09-613, OO9024-0729</p>'
    },
    {
      id:   'we005-102-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Heater, New model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Heater, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">09-136, 09-001, 09-002, 09-100, 09-004, 12-600, 11-118, 09-003, 12-558, 09-116, 09-125, 09-120, 09-153, 09-141, 09-108, 09-233, 09-148, 09-112, 12-559, 09-104, 09-167, 09-231, 09-610, 09-164</p>'
    },
    {
      id:   'we005-108-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Strike, New model codes (37)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Strike, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">11-116, 09-138, 09-005, 09-124, 09-006, 11-161, 09-102, 09-008, 11-162, 11-117, 11-119, 12-600, 11-095, 09-007, 12-561, 09-118, 09-127, 12-571, 12-509, 09-122, 09-155, 09-143, 09-110, 09-189, 12-652, 09-150, 09-238, 09-114, 09-237, OO9024-01, 09-106, 12-562, 12-590, 09-168, 09-232, 09-612, 09-165</p>'
    },

    {
      id:   'we013-3986-codes',
      html: '<h3 style="margin:0 0 10px;">All Jawbreaker model codes (73)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Jawbreaker</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9290-3331, OO9290-09, OO9290-08, OO9290-3531, OO9290-4931, OO9290-2531, OO9290-5931, OO9290-3731, OO9290-4731, OO9290-15, OO9290-4631, OO9290-3131, OO9290-7131, OO9290-5631, OO9290-2031, OO9290-5031, OO9290-5231, OO9290-5331, OO9290-5131, OO9290-4831, OO9290-7931, OO9290-4331, OO9290-6331, OO9290-3431, OO9290-3831, OO9290-7231, OO9290-3931, OO9290-4031, OO9290-6631, OO9290-13, OO9290-6831, OO9290-7831, OO9290-64, OO9290-11, OO9290-2731, OO9290-6031, OO9290-3631, OO9290-12, OO9290-04, OO9290-01, OO9290-07, OO9290-1931, OO9290-14, OO9290-2931, OO9290-2831, OO9290-5431, OO9290-10, OO9290-06, OO9290-03, OO9290-3231, OO9290-5531, OO9290-05, OO9290-2131, OO9290-18, OO9290-5831, OO9290-3031, OO9290-6731, OO9290-6531, OO9290-5731, OO9290-2431, OO9290-2631, OO9290-2331, OO9290-4431, OO9290-2231, OO9290-6131, OO9290-02, OO9290-4231, OO9290-7331, OO9290-7731, OO9290-4131, OO9290-4531, OO9290-17, OO9290-16</p>'
    },

    {
      id:   'we008-2627-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Path model codes (66)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Path</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">24-147, 24-037, 24-327, 24-275, 09-671, 09-749, 24-302, OO9051-01, 1-762, 26-266, 09-752J, 24-301, 26-213, 09-720, 09-674, 09-689, 09-670, 09-670L1, 12-763, 12-763L1, 09-748, 11-472, 24-322, 09-675, 26-214, 09-730, 42-421, 26-215, 09-672, 09-698, 09-772, 09-731, OO9051-04, 09-760, 26-268, 09-761, 09-777, 09-782, 09-779, 09-775, 09-780, 09-774, 09-773, OO9051-08, 09-757, 09-778, 09-776, 09-721, 09-758, 09-765, 26-267, 12-799, 24-371, 09-767, 26-212, 09-762, 09-781, 24-219, 09-729, 12-780, OO9051-09, 09-751, 09-722, 24-280, 09-673, 1-767</p>'
    },
    {
      id:   'we008-3230-codes',
      html: '<h3 style="margin:0 0 10px;">All Radar Edge model codes (15)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Radar Edge</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9184-13, OO9184-12, OO9184-10, OO9184-03, OO9184-17, OO9184-15, OO9184-02, OO9184-05, OO9184-08, OO9184-09, OO9184-04, OO9184-16, OO9184-07, OO9184-14, OO9184-01</p>'
    },
    {
      id:   'we008-3229-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Path model codes (47)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Path</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9181-08, OO9181-24, OO9181-59, OO9181-34, OO9181-45, OO9181-44, OO9181-47, OO9181-46, OO9181-29, OO9181-57, OO9181-11, OO9181-48, OO9181-16, OO9181-09, OO9181-26, OO9181-49, OO9181-10, OO9181-06, OO9181-23, OO9181-07, OO9181-04, OO9181-37, OO9181-02, OO9181-20, OO9181-15, OO9181-01, OO9181-36, OO9181-18, OO9181-14, OO9181-31, OO9181-41, OO9181-25, OO9181-28, OO9181-53, OO9181-42, OO9181-19, OO9181-12, OO9181-17, OO9181-32, OO9181-33, OO9181-05, OO9181-35, OO9181-30, OO9181-40, OO9181-22, OO9181-03, OO9181-21</p>'
    },
    {
      id:   'we008-3433-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Edge model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Edge</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9183-03, OO9183-08, OO9183-04, OO9183-05, OO9183-02, OO9183-07, OO9183-01, OO9183-06</p>'
    },
    {
      id:   'we008-3156-codes',
      html: '<h3 style="margin:0 0 10px;">All RadarLock Pitch model codes (11)</h3><p style="margin:0 0 14px;">Every Oakley <strong>RadarLock Pitch</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9182-05, OO9182-14, OO9182-13, OO9182-16, OO9182-01, OO9182-10, OO9182-03, OO9182-11, OO9182-07, OO9182-12, OO9182-1838</p>'
    },

    {
      id:   'we006-110-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Sweep, New model codes (27)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Sweep, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">09-137, 09-009, 09-101, 09-011, 09-010, 09-176, 09-117, 09-126, 09-194, 09-192, 09-121, 09-154, 09-142, 09-109, 09-185, 09-234, 09-149, 09-239, 09-113, 09-236, 42-308, 09-182, 09-105, 12-589, 09-193, OO9059-01, 09-611</p>'
    },
    {
      id:   'we006-104-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame New Hybrid, New model codes (60)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame New Hybrid, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">11-108, 09-139, 11-054, OO9024-04, 11-055, 09-103, 11-057, 11-109, 11-096, 11-056, 13-852, 12-556, 09-175, 13-860, 13-851, 12-554, 13-854, 09-119, 09-128, 13-857, 13-862, 13-874, 13-864, 12-570, 09-197, 09-198, 12-508, 12-553, 13-866, 13-865, 13-873, 09-123, 09-156, 09-144, 09-111, 09-187, 09-235, 09-151, 09-115, 12-555, 13-861, 13-869, 13-867, 13-870, 13-853, 13-872, 13-850, 13-856, 13-871, 13-863, 09-107, 12-557, 09-146, 09-196, 13-855, 13-858, 13-859, 13-868, 09-613, OO9024-0729</p>'
    },
    {
      id:   'we006-102-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Heater, New model codes (24)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Heater, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">09-136, 09-001, 09-002, 09-100, 09-004, 12-600, 11-118, 09-003, 12-558, 09-116, 09-125, 09-120, 09-153, 09-141, 09-108, 09-233, 09-148, 09-112, 12-559, 09-104, 09-167, 09-231, 09-610, 09-164</p>'
    },
    {
      id:   'we006-108-codes',
      html: '<h3 style="margin:0 0 10px;">All M Frame Strike, New model codes (37)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M Frame Strike, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">11-116, 09-138, 09-005, 09-124, 09-006, 11-161, 09-102, 09-008, 11-162, 11-117, 11-119, 12-600, 11-095, 09-007, 12-561, 09-118, 09-127, 12-571, 12-509, 09-122, 09-155, 09-143, 09-110, 09-189, 12-652, 09-150, 09-238, 09-114, 09-237, OO9024-01, 09-106, 12-562, 12-590, 09-168, 09-232, 09-612, 09-165</p>'
    },

    {
      id:   'we014-3814-codes',
      html: '<h3 style="margin:0 0 10px;">All M2 model codes (14)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M2</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9212-13, OO9212-18, OO9212-19, OO9212-03, OO9212-17, OO9212-01, OO9212-05, OO9212-02, OO9212-08, OO9212-06, OO9343-10, OO9212-07, OO9212-12, OO9212-04</p>'
    },

    {
      id:   'we014-4076-codes',
      html: '<h3 style="margin:0 0 10px;">All M2 XL model codes (20)</h3><p style="margin:0 0 14px;">Every Oakley <strong>M2 XL</strong> uses the same frame shell as the M2, so <strong>this kit fits any M2 XL colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9343-01, OO9343-02, OO9343-03, OO9343-04, OO9343-05, OO9343-06, OO9343-07, OO9343-08, OO9343-09, OO9343-10, OO9343-1145, OO9343-1245, OO9343-1345, OO9343-1445, OO9343-1645, OO9343-1845, OO9343-1945, OO9343-2045, OO9343-2145, OO9343-2245</p>'
    },

    {
      id:   'we002-2853-codes',
      html: '<h3 style="margin:0 0 10px;">All Jawbone model codes (34)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Jawbone</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-206, 24-262, 24-218, 42-487, 24-294, 24-255, 04-210, 04-215, 42-489, 24-202, 42-491, 24-276, 04-207, 24-220, 26-224, 04-204, 24-223, 04-208, 04-211, 24-274, 04-203, 26-223, 24-300, 26-210, 24-273, 24-328, 04-205, 04-209, 26-211, 04-214, 42-526, 42-531, 42-301, 24-281</p>'
    },
    {
      id:   'we002-3046-codes',
      html: '<h3 style="margin:0 0 10px;">All Split Jacket model codes (26)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Split Jacket</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9099-07, OO9099-22, OO9099-17, OO9099-23, OO9099-06, OO9099-20, OO9099-26, OO9099-05, OO9099-28, OO9099-24, OO9099-01, OO9099-11, OO9099-16, OO9099-15, OO9099-18, OO9099-02, OO9099-27, OO9099-19, OO9099-13, OO9099-14, OO9099-04, OO9099-08, OO9099-21, OO9099-25, OO9099-12, OO9099-03</p>'
    },
    {
      id:   'we002-2713-codes',
      html: '<h3 style="margin:0 0 10px;">All Straight Jacket II, New model codes (36)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Straight Jacket II, New</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-326, 12-790, 24-123, 24-156, OO9038-02, 24-033, 13-799, 04-327, 04-325, 04-325L1, 12-988, 11-013, 24-124, 11-014, OO9039-01, 12-936, OO9039-05, 26-200, 13-795, 12-792, 12-935, 26-238, 24-019, 04-328, 26-236, OO9039-04, 24-018, 26-237, 24-022, 12-792L1, 13-794, 04-331, 04-332, 04-329, 42-435, 24-157</p>'
    },
    {
      id:   'we002-2714-codes',
      html: '<h3 style="margin:0 0 10px;">All Minute 2.0 model codes (28)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Minute 2.0</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">12-934, 04-523, 04-522, 04-516, 42-313, 42-315, 42-316, 11-009, 11-010, 42-318, 12-933, 04-517, 13-792, 04-520, 04-518, 04-515, 42-324, 13-790, 42-328, 42-334, 42-336, 24-021, 04-515L2, 42-348, 04-519, 42-357, 42-359, 42-365</p>'
    },

    {
      id:   'we015-4075-codes',
      html: '<h3 style="margin:0 0 10px;">All Flak 2.0 model codes (9)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Flak 2.0</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9295-08, OO9295-01, OO9295-07, OO9295-2059, OO9295-06, OO9295-05, OO9295-04, OO9295-02, OO9295-03</p>'
    },
    {
      id:   'we015-3981-codes',
      html: '<h3 style="margin:0 0 10px;">All Flak 2.0 XL model codes (124)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Flak 2.0 XL</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9188-8659, OO9188-09, OO9188-47, OO9188-46, OO9188-J059, OO9188-J359, OO9188-G059, OO9188-A059, OO9188-57, OO9188-38, OO9188-8459, OO9188-6759, OO9188-43, OO9188-8959, OO9188-8759, OO9188-I759, OO9188-H359, OO9188-7459, OO9188-I959, OO9188-A859, OO9188-I559, OO9188-6159, OO9188-J459, OO9188-01, OO9188-53, OO9188-07, OO9188-12, OO9188-9859, OO9188-40, OO9188-13, OO9188-14, OO9188-I859, OO9188-D759, OO9188-B859, OO9188-7359, OO9188-G759, OO9188-G659, OO9188-9659, OO9188-9059, OO9188-58, OO9188-A659, OO9188-7959, OO9188-8559, OO9188-E059, OO9188-7759, OO9188-41, OO9188-B559, OO9188-B359, OO9188-C659, OO9188-J659, OO9188-D059, OO9188-D359, OO9188-A759, OO9188-42, OO9188-15, OO9188-G359, OO9188-18, OO9188-J859, OO9188-J959, OO9188-10, OO9188-04, OO9188-K259, OO9188-9959, OO9188-J559, OO9188-K159, OO9188-J159, OO9188-59, OO9188-J259, OO9188-F459, OO9188-I459, OO9188-11, OO9188-K359, OO9188-02, OO9188-F959, OO9188-G559, OO9188-9559, OO9188-I659, OO9188-G159, OO9188-24, OO9188-52, OO9188-08, OO9188-50, OO9188-22, OO9188-7259, OO9188-9159, OO9188-7059, OO9188-05, OO9188-8059, OO9188-F759, OO9188-06, OO9188-17, OO9188-23, OO9188-44, OO9188-21, OO9188-54, OO9188-51, OO9188-19, OO9188-7659, OO9188-B159, OO9188-8259, OO9188-03, OO9188-9259, OO9188-8859, OO9188-9359, OO9188-9459, OO9188-20, OO9188-8159, OO9188-H259, OO9188-7159, OO9188-6659, OO9188-6559, OO9188-6459, OO9188-6859, OO9188-31, OO9188-8359, OO9188-16, OO9188-F859, OO9188-60, OO9188-B259, OO9188-49, OO9188-F359, OO9188-H159, OO9188-A959, OO9188-55</p>'
    },

    {
      id:   'we010-3232-codes',
      html: '<h3 style="margin:0 0 10px;">All Half Jacket 2.0 model codes (13)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Half Jacket 2.0</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9144-20, OO9144-19, OO9144-11, OO9144-12, OO9144-16, OO9144-2262, OO9144-2362, OO9144-08, OO9144-01, OO9144-04, OO9144-05, OO9144-17, OO9144-02</p>'
    },
    {
      id:   'we010-3233-codes',
      html: '<h3 style="margin:0 0 10px;">All Half Jacket 2.0 XL model codes (43)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Half Jacket 2.0 XL</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9154-11, OO9154-02, OO9154-20, OO9154-14, OO9154-51, OO9154-52, OO9154-54, OO9154-53, OO9154-19, OO9154-12, OO9154-46, OO9154-13, OO9154-34, OO9154-17, OO9154-65, OO9155-06, OO9154-01, OO9154-05, OO9154-29, OO9154-16, OO9154-26, OO9154-45, OO9154-21, OO9154-27, OO9154-49, OO9154-28, OO9154-39, OO9154-25, OO9154-44, OO9154-41, OO9154-37, OO9154-42, OO9154-36, OO9154-35, OO9154-24, OO9154-40, OO9154-38, OO9154-08, OO9154-23, OO9154-15, OO9154-43, OO9154-33, OO9154-06</p>'
    },

    {
      id:   'we004-78-codes',
      html: '<h3 style="margin:0 0 10px;">All Half Jacket model codes (42)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Half Jacket</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">03-609, 11-074, 11-100, 03-617, 12-801, 12-666, 12-896, 42-471, 12-668, 03-619, 12-819, 03-610, 03-615, 03-615J, 03-616, 03-612, 12-864, 03-614, 12-800, 13-701, 03-613, 03-625, 12-840, 13-711, 13-700, 11-007, 03-623, 03-627, 03-611, 03-620, 03-624, 03-622, 12-824, 03-618, 12-655, 03-621, 12-640, 12-446, 03-626, 42-455, 42-551, 42-552</p>'
    },
    {
      id:   'we004-84-codes',
      html: '<h3 style="margin:0 0 10px;">All Half Jacket XLJ model codes (30)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Half Jacket XLJ</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">11-075, 11-101, 03-654, 12-667, 12-897, 03-656, 12-669, 03-657, 42-381, 12-818, 03-652, 12-865, 03-650, 12-839, 13-702, 12-751, 03-659, 12-803, 13-712, 12-752, 13-703, 11-008, 03-653, 03-660, 03-658, 12-825, 03-655, 12-656, 03-651, 12-802</p>'
    },

    {
      id:   'we001-93-codes',
      html: '<h3 style="margin:0 0 10px;">All Juliet model codes (44)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Juliet</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">24-293, 04-129, 12-628, 04-128, 04-159, 04-148, 12-673, 04-149, 12-835, 12-676, 24-088, 12-643, 04-150, 04-115, 04-151, 04-113, 04-152, 04-114, 04-123, 04-153, 12-623, 24-308, 04-117, 12-614, 12-684, 04-126, 04-147, 04-119, 04-118, 12-633, 12-624, 04-158, 24-126, 22-350, 04-124, 04-111, 12-636, 04-146, 04-110, 04-112, OO4064-01, 04-116, 24-125, 12-726</p>'
    },
    {
      id:   'we001-118-codes',
      html: '<h3 style="margin:0 0 10px;">All Mars model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Mars</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-103, 04-106, 04-107, 04-105, 04-109, 04-104, OO6015-0144, 04-108</p>'
    },
    {
      id:   'we001-144-codes',
      html: '<h3 style="margin:0 0 10px;">All Penny model codes (6)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Penny</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-134, 04-131, 04-133, 04-130, 04-132, 04-135</p>'
    },
    {
      id:   'we001-168-codes',
      html: '<h3 style="margin:0 0 10px;">All Romeo model codes (4)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Romeo</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-102, 04-101, 04-100, OO4064-01</p>'
    },
    {
      id:   'we001-235-codes',
      html: '<h3 style="margin:0 0 10px;">All X Metal XX model codes (6)</h3><p style="margin:0 0 14px;">Every Oakley <strong>X Metal XX</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">04-145, 04-122, 04-125, 04-121, 04-144, 04-120</p>'
    },
    {
      id:   'we001-3011-codes',
      html: '<h3 style="margin:0 0 10px;">All X-Squared model codes (10)</h3><p style="margin:0 0 14px;">Every Oakley <strong>X-Squared</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">GBP-001, OO6011-10, OO6011-09, OO6011-01, OO6011-08, OO6011-04, OO6011-02, OO6011-05, OO6011-06, OO6011-03</p>'
    },

    {
      id:   'we003-2624-codes',
      html: '<h3 style="margin:0 0 10px;">All Flak Jacket model codes (49)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Flak Jacket</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">03-887, 24-119, 42-542, 42-399, 03-891, 13-798, 03-889, 03-905, 03-896, 03-881, 12-900, 13-718, 03-888, 03-881L1, 12-762, 12-762L1, 03-892, 12-990, 24-429, 11-003, 11-434, 11-433, 12-902, 13-722, 42-429, 26-221, 03-883, 13-720, 03-886, 03-885, 26-219, OO9008-14, 03-904, 12-901, 03-882, 26-202, 24-017, 03-908, 12-761, 42-534, 42-535, 42-536, 12-775J, 03-884, 24-120, 42-545, 03-890, 42-400, 24-025</p>'
    },
    {
      id:   'we003-2625-codes',
      html: '<h3 style="margin:0 0 10px;">All Flak Jacket XLJ model codes (134)</h3><p style="margin:0 0 14px;">Every Oakley <strong>Flak Jacket XLJ</strong> uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full model-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">24-015, 24-071, 24-077, OO9009-2763, 24-121, 24-005, 24-421, 24-006, 24-065, 24-078, 24-068, 24-073, OO9009-20, 24-122, 03-910, 24-299, 11-052, 24-152, 53-100, 24-093, 24-007, OO9009-22, OO9009-03, 24-076, 26-263, 13-721, 03-897, 03-922, 24-080, 03-902, OO9009-06, 03-898, 03-915, 12-903, 13-719, 03-921, 24-016, 24-020, 12-791, 12-791L1, 24-074, 24-008, 24-009, 24-434, 24-433, 11-490, 11-004, 11-435, 11-432, OO9009-12, OO9009-13, 53-094, 53-095, OO9009-15, 12-905, 13-723, OO9009-02, 26-222, 03-919, 03-928, 03-918, 03-926, 24-063, 24-070, OO9009-23, 03-916, 24-011, 24-010, 24-064, 03-939, 24-012, 24-066, 24-406, 03-944, 03-947, 03-948, 24-195, 26-240, 26-243, 26-232, 03-899, 26-239, 03-909, 26-265, 24-365, 26-220, 26-241, OO9009-11, 24-428, OO9009-10, OO9009-09, OO9009-08, 24-216, 26-242, OO9009-05, OO9009-01, OO9009-25, 03-903, 26-231, 12-904, 24-030, 03-942, 03-917, 03-943, 26-264, 24-374, 24-340, 03-941, 24-373, 03-945, 24-426, OO9009-07, 03-927, 24-013, 24-067, 24-014, 03-920, OO9009-3063, 24-072, 24-062, OO9009-2963, 03-929, 03-932, 03-934, 03-931, 03-933, OO9009-3263, 24-069, 24-075, OO9009-2863, 24-079, 24-026, 24-153, OO9009-14</p>'
    },

    {
      id:   'wl026-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO6015 model codes (1)</h3><p style="margin:0;line-height:2;">OO6015-0144</p>'
    },
    {
      id:  'wl023-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl023.jpg?v=1783257779',
      alt: 'How to find the SKU on your Oakley Juliet frame'
    },
    {
      id:   'wl023-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4064 model codes (1)</h3><p style="margin:0;line-height:2;">OO4064-01</p>'
    },
    {
      id:  'wl016-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl016-fit-photo-guide.jpg?v=1789488849',
      alt: 'How to find the SKU on your Oakley Half Jacket XLJ (vented) frame'
    },
    {
      id:  'wl015-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl015-fit-photo-guide.jpg?v=1789488846',
      alt: 'How to find the SKU on your Oakley Half Jacket XLJ frame'
    },
    {
      id:  'wl014-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl014-fit-photo-guide.jpg?v=1789488848',
      alt: 'How to find the SKU on your Oakley Half Jacket frame'
    },
    {
      id:  'wl008-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl008.jpg?v=1783257775',
      alt: 'How to find the SKU on your Oakley Flak Jacket XLJ (vented) frame'
    },
    {
      id:   'wl008-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9009 model codes (22)</h3><p style="margin:0;line-height:2;">OO9009-01, OO9009-02, OO9009-05, OO9009-06, OO9009-07, OO9009-08, OO9009-09, OO9009-10, OO9009-11, OO9009-12, OO9009-13, OO9009-14, OO9009-15, OO9009-20, OO9009-22, OO9009-23, OO9009-25, OO9009-2763, OO9009-2863, OO9009-2963, OO9009-3063, OO9009-3263</p>'
    },
    {
      id:   'wl008-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Compatible part numbers (111)</h3><p style="margin:0;line-height:2;">03-897, 03-898, 03-899, 03-902, 03-903, 03-909, 03-910, 03-915, 03-916, 03-917, 03-918, 03-919, 03-920, 03-921, 03-922, 03-926, 03-927, 03-928, 03-929, 03-931, 03-932, 03-933, 03-934, 03-939, 03-941, 03-942, 03-943, 03-944, 03-945, 03-947, 03-948, 11-004, 11-052, 11-432, 11-435, 11-490, 12-791, 12-791L1, 12-903, 12-904, 12-905, 13-719, 13-721, 13-723, 24-005, 24-006, 24-007, 24-008, 24-009, 24-010, 24-011, 24-012, 24-013, 24-014, 24-015, 24-016, 24-020, 24-026, 24-030, 24-062, 24-063, 24-064, 24-065, 24-066, 24-067, 24-068, 24-069, 24-070, 24-071, 24-072, 24-073, 24-074, 24-075, 24-076, 24-077, 24-078, 24-079, 24-080, 24-093, 24-121, 24-122, 24-152, 24-153, 24-195, 24-216, 24-299, 24-340, 24-365, 24-373, 24-374, 24-406, 24-421, 24-426, 24-428, 24-433, 24-434, 26-220, 26-222, 26-231, 26-232, 26-239, 26-240, 26-241, 26-242, 26-243, 26-263, 26-264, 26-265, 53-094, 53-095, 53-100</p>'
    },
    {
      id:   'we009-oo9097-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9097 (Fast Jacket) model codes (17)</h3><p style="margin:0 0 14px;">Every Oakley Fast Jacket OO9097 uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9097-01, OO9097-02, OO9097-03, OO9097-04, OO9097-05, OO9097-06, OO9097-07, OO9097-08, OO9097-09, OO9097-11, OO9097-12, OO9097-13, OO9097-16, OO9097-17, OO9097-19, OO9097-20, OO9097-2872</p>'
    },
    {
      id:   'we009-oo9156-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9156 (Fast Jacket XL) model codes (31)</h3><p style="margin:0 0 14px;">Every Oakley Fast Jacket XL OO9156 uses the same frame shape, so <strong>this kit fits any colorway</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9156-01, OO9156-02, OO9156-03, OO9156-04, OO9156-05, OO9156-06, OO9156-07, OO9156-08, OO9156-09, OO9156-10, OO9156-11, OO9156-12, OO9156-13, OO9156-14, OO9156-16, OO9156-17, OO9156-18, OO9156-19, OO9156-20, OO9156-21, OO9156-22, OO9156-23, OO9156-24, OO9156-25, OO9156-27, OO9156-28, OO9156-30, OO9156-32, OO9156-3371, OO9156-3871, OO9156-4071</p>'
    },

    {
      id:  'wl044-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl044-fit-photo-guide.jpg?v=1789488848',
      alt: 'How to find the SKU on your Oakley Monster Pup frame'
    },

    {
      id:  'wl043-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl043-fit-photo-guide.jpg?v=1789488848',
      alt: 'How to find the SKU on your Oakley Eyepatch 2 frame'
    },
    {
      id:   'wl043-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9136 model codes (20)</h3><p style="margin:0 0 14px;">Every Oakley Eyepatch 2 OO9136 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9136-01, OO9136-02, OO9136-03, OO9136-04, OO9136-05, OO9136-06, OO9136-07, OO9136-08, OO9136-09, OO9136-10, OO9136-11, OO9136-12, OO9136-13, OO9136-15, OO9136-16, OO9136-19, OO9136-21, OO9136-22, OO9136-24, OO9136-25</p>'
    },

    {
      id:  'wl049-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl049-fit-photo-guide.jpg?v=1789488848',
      alt: 'How to find the SKU on your Oakley Crosshair 2.0 frame'
    },
    {
      id:   'wl049-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO4044 model codes (8)</h3><p style="margin:0 0 14px;">Every Oakley Crosshair 2.0 OO4044 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO4044-01, OO4044-02, OO4044-03, OO4044-04, OO4044-05, OO4044-07, OO4044-08, OO4044-09</p>'
    },

    {
      id:  'wl047-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl047-fit-photo-guide.jpg?v=1789488855',
      alt: 'How to find the SKU on your Oakley Romeo 2 frame'
    },

    {
      id:  'wl042-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl042-fit-photo-guide.jpg?v=1789488850',
      alt: 'How to find the SKU on your Oakley New Square Wire frame'
    },

    {
      id:  'wl041-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl041-fit-photo-guide.jpg?v=1789488850',
      alt: 'How to find the SKU on your Oakley Canteen frame'
    },

    {
      id:  'wl040-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl040-fit-photo-guide.jpg?v=1789488851',
      alt: 'How to find the SKU on your Oakley XX (Twenty XX) frame'
    },
    {
      id:   'wl040-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Oakley XX (Twenty XX) — compatible part numbers (66)</h3><p style="margin:0;line-height:2;word-spacing:2px;">04-280, 04-281, 04-282, 04-283, 04-284, 04-285, 04-286, 04-287, 04-289, 04-290, 04-291, 04-292, 04-293, 04-294, 04-295, 04-296, 04-297, 04-298, 04-299, 04-355, 04-356, 04-357, 04-580, 04-591, 11-068, 11-083, 12-580, 12-591, 12-597, 12-598, 12-606, 12-613, 12-619, 12-630, 12-647, 12-648, 12-805, 12-806, 13-825, 13-826, 13-827, 13-828, 13-829, 13-830, 13-831, 13-832, 13-833, 13-834, 13-835, 13-836, 13-837, 13-838, 13-839, 13-840, 13-841, 13-842, 13-843, 13-844, 13-845, 13-846, 13-847, 13-848, 13-849, 13-876, 30-484, 30-485</p>'
    },

    {
      id:  'wl048-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl048-fit-photo-guide.jpg?v=1789488851',
      alt: 'How to find the SKU on your Oakley Square Whisker frame'
    },

    {
      id:  'wl037-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl037.jpg?v=1783256368',
      alt: 'How to find the SKU on your Oakley Whisker frame'
    },
    {
      id:  'wl030-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl030.jpg?v=1783256370',
      alt: 'How to find the SKU on your Oakley Pit Bull frame'
    },
    {
      id: 'wl030-oo-codes',
      html: '<h3>Oakley Pit Bull — OO9127 model codes</h3><p>These are all the same lens shape; any colorway fits. Just confirm the inner arm of your frame reads "OO9127".</p><p>OO9127-01, OO9127-02, OO9127-03, OO9127-04, OO9127-05, OO9127-06, OO9127-07, OO9127-08, OO9127-09, OO9127-10, OO9127-12, OO9127-13, OO9127-14, OO9127-15, OO9127-16, OO9127-20, OO9127-24, OO9127-26, OO9127-32, OO9127-34, OO9127-35</p>'
    },

    {
      id:  'wl020-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl020-fit-photo-guide.jpg?v=1789488851',
      alt: 'How to find the SKU on your Oakley Inmate frame'
    },
    {
      id:  'wl026-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL026-04-103.jpg?v=1783200693',
      alt: 'How to find the SKU on your Oakley Mars frame'
    },
    {
      id:  'wl029-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL029-04-143.jpg?v=1783200695',
      alt: 'How to find the SKU on your Oakley Penny frame'
    },
    {
      id:  'wl025-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl025-fit-photo-guide.jpg?v=1789488853',
      alt: 'How to find the SKU on your Oakley Jupiter frame'
    },
    {
      id:  'wl019-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL019-OO9102-01.jpg?v=1783200692',
      alt: 'How to find the SKU on your Oakley Holbrook frame'
    },
    {
      id:  'wl017-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl017-fit-photo-guide.jpg?v=1789488853',
      alt: 'How to find the SKU on your Oakley Half X frame'
    },
    {
      id:  'wl011-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl011-fit-photo-guide.jpg?v=1789488855',
      alt: 'How to find the SKU on your Oakley Gascan frame'
    },
    {
      id:  'wl010-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl010-fit-photo-guide.jpg?v=1789488853',
      alt: 'How to find the SKU on your Oakley Fuel Cell frame'
    },
    {
      id:  'wl009-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl009-fit-photo-guide.jpg?v=1789488854',
      alt: 'How to find the SKU on your Oakley Frogskins frame'
    },
    {
      id:  'wl001-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl001-fit-photo-guide.jpg?v=1789488856',
      alt: 'How to find the SKU on your Oakley Crosshair 1.0 frame'
    },
    {
      id:  'wl002-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl002-fit-photo-guide.jpg?v=1789488856',
      alt: 'How to find the SKU on your Oakley Dispatch frame'
    },
  {
    id:  'wl003-sku-modal',
    src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/sku_modal_ref_wl003.jpg?v=1783257773',
    alt: 'How to find the SKU on your Oakley Fast Jacket XL frame'
  },
    {
      id:  'wl004-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl004-fit-photo-guide.jpg?v=1789488856',
      alt: 'How to find the SKU on your Oakley Fives 4.0 frame'
    },
    {
      id:  'wl005-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl005-fit-photo-guide.jpg?v=1789488857',
      alt: 'How to find the SKU on your Oakley Fives Squared frame'
    },
    {
      id:   'wl009-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9013 model codes (157)</h3>'
          + '<p style="margin:0 0 14px;">Every Oakley Frogskins OO9013 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p>'
          + '<p style="margin:0;line-height:2;word-spacing:2px;">OO9013-02, OO9013-03, OO9013-04, OO9013-05, OO9013-09, OO9013-10, OO9013-11, OO9013-12, OO9013-13, OO9013-14, OO9013-15, OO9013-16, OO9013-17, OO9013-18, OO9013-32, OO9013-33, OO9013-34, OO9013-35, OO9013-36, OO9013-37, OO9013-38, OO9013-39, OO9013-43, OO9013-44, OO9013-45, OO9013-46, OO9013-47, OO9013-48, OO9013-50, OO9013-51, OO9013-52, OO9013-53, OO9013-54, OO9013-55, OO9013-56, OO9013-66, OO9013-67, OO9013-68, OO9013-69, OO9013-70, OO9013-72, OO9013-73, OO9013-74, OO9013-75, OO9013-76, OO9013-77, OO9013-78, OO9013-84, OO9013-85, OO9013-87, OO9013-88, OO9013-89, OO9013-90, OO9013-92, OO9013-94, OO9013-99, OO9013-A3, OO9013-A4, OO9013-A5, OO9013-A6, OO9013-A7, OO9013-A8, OO9013-A9, OO9013-B1, OO9013-B255, OO9013-B355, OO9013-B455, OO9013-B555, OO9013-B655, OO9013-B755, OO9013-B855, OO9013-B955, OO9013-C055, OO9013-C155, OO9013-C255, OO9013-C455, OO9013-C555L, OO9013-C555, OO9013-C655, OO9013-C755, OO9013-C855, OO9013-C955, OO9013-D055, OO9013-D155, OO9013-D255, OO9013-D355, OO9013-D455, OO9013-D555, OO9013-D655, OO9013-D755, OO9013-D855, OO9013-D955, OO9013-E055, OO9013-E155, OO9013-E255, OO9013-E355, OO9013-E655, OO9013-E755, OO9013-F055, OO9013-F155, OO9013-F255, OO9013-F355, OO9013-F455, OO9013-F555, OO9013-F655, OO9013-F755, OO9013-F855, OO9013-F955, OO9013-G055, OO9013-G155, OO9013-G255, OO9013-G355, OO9013-G455, OO9013-G655, OO9013-G755, OO9013-G955, OO9013-H055, OO9013-H155, OO9013-H255, OO9013-H655, OO9013-H755, OO9013-H855, OO9013-H955, OO9013-I255, OO9013-I355, OO9013-I455, OO9013-I555, OO9013-I655, OO9013-I855, OO9013-I955, OO9013-J055, OO9013-J155, OO9013-J255, OO9013-J455, OO9013-J655, OO9013-J755, OO9013-J855, OO9013-J955, OO9013-K155, OO9013-K355, OO9013-K455, OO9013-K555, OO9013-K655, OO9013-K755, OO9013-K855, OO9013-K955, OO9013-L055, OO9013-L155, OO9013-L255, OO9013-L355, OO9013-L455, OO9013-L555, OO9013-M055, OO9013-M155, OO9013-M255, OO9013-M455, OO9013-M955</p>'
    },
    {
      id:   'wl002-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9090 model codes (20)</h3><p style="margin:0 0 14px;">Every Oakley Dispatch OO9090 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9090-01, OO9090-02, OO9090-03, OO9090-04, OO9090-05, OO9090-06, OO9090-07, OO9090-08, OO9090-09, OO9090-10, OO9090-11, OO9090-12, OO9090-13, OO9090-14, OO9090-15, OO9090-16, OO9090-17, OO9090-18, OO9090-19, OO9090-20</p>'
    },
    {
      id:   'wl003-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9156 model codes (31)</h3><p style="margin:0 0 14px;">Every Oakley Fast Jacket XL OO9156 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9156-01, OO9156-02, OO9156-03, OO9156-04, OO9156-05, OO9156-06, OO9156-07, OO9156-08, OO9156-09, OO9156-10, OO9156-11, OO9156-12, OO9156-13, OO9156-14, OO9156-16, OO9156-17, OO9156-18, OO9156-19, OO9156-20, OO9156-21, OO9156-22, OO9156-23, OO9156-24, OO9156-25, OO9156-27, OO9156-28, OO9156-30, OO9156-32, OO9156-3371, OO9156-3871, OO9156-4071</p>'
    },
    {
      id:   'wl005-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9238 model codes (21)</h3><p style="margin:0 0 14px;">Every Oakley Fives Squared OO9238 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9238-01, OO9238-02, OO9238-03, OO9238-04, OO9238-05, OO9238-06, OO9238-07, OO9238-08, OO9238-09, OO9238-10, OO9238-14, OO9238-15, OO9238-16, OO9238-17, OO9238-19, OO9238-2054, OO9238-2154, OO9238-3154, OO9238-3254, OO9238-3354, OO9238-3454</p>'
    },
    {
      id:   'wl010-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9096 model codes (159)</h3><p style="margin:0 0 14px;">Every Oakley Fuel Cell OO9096 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9096-01, OO9096-02, OO9096-03, OO9096-04, OO9096-05, OO9096-06, OO9096-07, OO9096-08, OO9096-09, OO9096-10, OO9096-11, OO9096-12, OO9096-13, OO9096-14, OO9096-15, OO9096-16, OO9096-17, OO9096-20, OO9096-21, OO9096-23, OO9096-24, OO9096-25, OO9096-26, OO9096-27, OO9096-28, OO9096-29, OO9096-30, OO9096-31, OO9096-32, OO9096-33, OO9096-34, OO9096-35, OO9096-36, OO9096-38, OO9096-39, OO9096-40, OO9096-41, OO9096-42, OO9096-44, OO9096-45, OO9096-46, OO9096-47, OO9096-48, OO9096-49, OO9096-50, OO9096-51, OO9096-52, OO9096-53, OO9096-54, OO9096-55, OO9096-56, OO9096-57, OO9096-58, OO9096-59, OO9096-60, OO9096-61, OO9096-63, OO9096-66, OO9096-68, OO9096-70, OO9096-71, OO9096-72, OO9096-73, OO9096-75, OO9096-76, OO9096-77, OO9096-78, OO9096-79, OO9096-80, OO9096-81, OO9096-82, OO9096-83, OO9096-84, OO9096-85, OO9096-86, OO9096-87, OO9096-88, OO9096-90, OO9096-91, OO9096-94, OO9096-97, OO9096-98, OO9096-99, OO9096-A1, OO9096-A2, OO9096-A3, OO9096-A4, OO9096-A5, OO9096-A6, OO9096-A7, OO9096-A8, OO9096-B1, OO9096-B2, OO9096-B3, OO9096-B4, OO9096-B5, OO9096-B6, OO9096-C2, OO9096-C9, OO9096-D1, OO9096-D3, OO9096-D4, OO9096-D5, OO9096-D8, OO9096-D9, OO9096-E1, OO9096-F7, OO9096-F9, OO9096-G1, OO9096-G2, OO9096-G4, OO9096-G5, OO9096-G6, OO9096-G7, OO9096-G8, OO9096-H560, OO9096-H660, OO9096-H860, OO9096-H960, OO9096-I060, OO9096-I460, OO9096-I560, OO9096-I660, OO9096-I760, OO9096-J160, OO9096-J260, OO9096-J360, OO9096-J460, OO9096-J560, OO9096-J760, OO9096-J860, OO9096-J960, OO9096-K060, OO9096-K160, OO9096-K260, OO9095-K360, OO9096-K460, OO9096-K560, OO9096-K660, OO9096-K760, OO9096-K860, OO9096-L160, OO9096-L260, OO9096-L360, OO9096-L560, OO9096-L660, OO9096-L760, OO9096-L860, OO9096-L960, OO9096-M060, OO9096-M160, OO9096-M260, OO9096-M360, OO9096-M460, OO9096-M560, OO9096-M660, OO9096-M760, OO9096-N3, OO9096-N160</p>'
    },
    {
      id:   'wl011-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9014 model codes (93)</h3><p style="margin:0 0 14px;">Every Oakley Gascan OO9014 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9014-01, OO9143-01, OO9143-02, OO9014-03, OO9143-03, OO9143-04, OO9143-05, OO9014-05, OO9014-06, OO9143-07, OO9014-09, OO9014-10, OO9014-11, OO9014-12, OO9014-14, OO9014-15, OO9014-1660, OO9014-1860, OO9014-2060, OO9014-2160, OO9014-2660, OO9014-2760, OO9014-2860, OO9014-3060, OO9014-3260, OO9014-3460, OO9014-3560, OO9014-3660, OO9014-3760, OO9014-3860, OO9014-4060, OO9014-4160, OO9014-4260, OO9014-4360, OO9014-4460, OO9014-4760, OO9014-4860, OO9014-4960, OO9014-5060, OO9014-5160, OO9014-5260, OO9014-5360, OO9014-5460, OO9014-5560, OO9014-5660, OO9014-5760, OO9014-6360, OO9014-6460, OO9014-6660, OO9014-7060, OO9014-7160, OO9014-7460, OO9014-7860, OO9014-8160, OO9014-8260, OO9014-8460, OO9014-8760, OO9014-8860, OO9014-8960, OO9014-9060, OO9014-9160, OO9014-9260, OO9014-9360, OO9014-9460, OO9014-9660, OO9014-A160, OO9014-A260, OO9014-A360, OO9014-A660, OO9014-A760, OO9014-A860, OO9014-B160, OO9014-B260, OO9014-B360, OO9014-B460, OO9014-B660, OO9014-B760, OO9014-B860, OO9014-B960, OO9014-C060, OO9014-C160, OO9014-C260, OO9014-C460, OO9014-C560, OO9014-C660, OO9014-C860, OO9014-C960, OO9014-D060, OO9014-D160, OO9014-D260, OO9014-D360, OO9014-D460, OO9014-D560</p>'
    },
    {
      id:   'wl011-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Older Gascan frames — compatible part numbers (99)</h3><p style="margin:0 0 14px;">Pre-OO9014 and variant Gascan frames stamped with these legacy Oakley part numbers also fit:</p><p style="margin:0;line-height:2;word-spacing:2px;">03-470, 03-471, 03-472, 03-473, 03-474, 03-476, 03-481, 03-482, 03-483, 11-015, 11-122, 11-192, 115, 12-150GB10, 12-150GB11, 12-150GB12, 12-150GB3, 12-150GB4, 12-150GB5, 12-150GB6, 12-150GB7, 12-150GB8, 12-150GB9, 12-151GB10, 12-151GB11, 12-151GB12, 12-151GB3, 12-151GB4, 12-151GB5, 12-151GB6, 12-151GB7, 12-151GB8, 12-151GB9, 12-152GB10, 12-152GB11, 12-152GB12, 12-152GB3, 12-152GB4, 12-152GB5, 12-152GB6, 12-152GB7, 12-152GB8, 12-152GB9, 12-694, 12-703, 12-705, 12-706, 12-713, 12-720, 12-723, 12-732, 12-744, 12-748, 12-759, 12-767, 12-768, 12-769, 12-774, 12-774L1, 12-777, 12-782, 12-784, 12-785, 12-796, 12-855, 12-856, 12-863, 12-891, 12-892, 125, 24-003, 24-028, 24-050, 24-056, 24-061, 24-082, 24-083, 24-146, 24-166, 24-290, 24-296, 24-363, 24-400, 24-405, 24-412, 24-430, 24-435, 26-244, 26-245, 26-246, 42-550, 53-083, 53-098, 53-108, 53-109, 53-110, 53-111, 53-112, 53-113</p>'
    },
    {
      id:  'wl018-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/t/6/assets/wl018-fit-photo-guide.jpg?v=1789488858',
      alt: 'How to find the SKU on your Oakley Hijinx frame'
    },
    {
      id:   'wl018-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9021 model codes (5)</h3><p style="margin:0 0 14px;">Every Oakley Hijinx OO9021 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9021-01, OO9021-02, OO9021-03, OO9021-04, OO9021-05</p>'
    },
    {
      id:   'wl018-legacy-codes',
      html: '<h3 style="margin:0 0 10px;">Older Hijinx frames — compatible part numbers (71)</h3><p style="margin:0 0 14px;">Legacy and variant Hijinx frames stamped with these Oakley part numbers also fit:</p><p style="margin:0;line-height:2;word-spacing:2px;">03-590, 03-590L1, 03-591, 03-592, 03-593, 03-594, 03-595, 03-596, 03-597, 03-598, 03-599, 03-600, 12-153GB10, 12-153GB11, 12-153GB12, 12-153GB3, 12-153GB4, 12-153GB5, 12-153GB6, 12-153GB7, 12-153GB8, 12-153GB9, 12-154GB10, 12-154GB11, 12-154GB12, 12-154GB3, 12-154GB4, 12-154GB5, 12-154GB6, 12-154GB7, 12-154GB8, 12-154GB9, 12-155GB10, 12-155GB11, 12-155GB12, 12-155GB3, 12-155GB4, 12-155GB5, 12-155GB6, 12-155GB7, 12-155GB8, 12-155GB9, 12-212, 12-747, 12-764, 12-771, 12-776, 12-778, 12-789, 12-798, 12-928, 12-929, 12-940, 24-027, 24-040, 24-043, 24-051, 24-052, 24-053, 24-059, 24-091, 24-095, 24-100, 24-113, 24-201, 24-214, 24-235, 24-346, 24-771, 26-233, 42-474</p>'
    },
    {
      id:   'wl019-oo-codes',
      html: '<h3 style="margin:0 0 10px;">All OO9102 model codes (267)</h3><p style="margin:0 0 14px;">Every Oakley Holbrook OO9102 uses the same lens shape, so <strong>any colorway fits</strong>. Full color-code list:</p><p style="margin:0;line-height:2;word-spacing:2px;">OO9102-01, OO9102-02, OO9102-03, OO9102-04, OO9102-05, OO9102-06, OO9102-07, OO9102-08, OO9102-09, OO9102-10, OO9102-11, OO9102-12, OO9102-13, OO9102-14, OO9102-15, OO9102-16, OO9102-17, OO9102-18, OO9102-19, OO9102-20, OO9102-21, OO9102-22, OO9102-23, OO9102-24, OO9102-25, OO9102-26, OO9102-27, OO9102-28, OO9102-29, OO9102-30, OO9102-31, OO9102-32, OO9102-33, OO9102-34, OO9102-35, OO9102-36, OO9102-37, OO9102-38, OO9102-39, OO9102-40, OO9102-41, OO9102-42, OO9102-43, OO9102-44, OO9102-45, OO9102-46, OO9102-47, OO9102-50, OO9102-51, OO9102-52, OO9102-55, OO9102-56, OO9102-57, OO9102-58, OO9102-59, OO9102-60, OO9102-61, OO9102-62, OO9102-63, OO9102-64, OO9102-65, OO9102-66, OO9102-67, OO9102-68, OO9102-69, OO9102-70, OO9102-71, OO9102-72, OO9102-73, OO9102-74, OO9102-75, OO9102-76, OO9102-81, OO9102-82, OO9102-83, OO9102-86, OO9102-90, OO9102-91, OO9102-92, OO9102-93, OO9102-94, OO9102-95, OO9102-96, OO9102-97, OO9102-98, OO9102-99, OO9102-A1, OO9102-A2, OO9102-A3, OO9102-A6, OO9102-A7, OO9102-A8, OO9102-A9, OO9102-AA55, OO9102-AB55, OO9102-AD55, OO9102-AE55, OO9102-AF55, OO9102-AG55, OO9102-AH55, OO9102-AI55, OO9102-B1, OO9102-B2, OO9102-B4, OO9102-B5, OO9102-B7, OO9102-B8, OO9102-B9, OO9102-C0, OO9102-C1, OO9102-C355, OO9102-D255, OO9102-D355, OO9102-D455, OO9102-D555, OO9102-D655, OO9102-D755, OO9102-E155, OO9102-E255, OO9102-E455, OO9102-E555, OO9102-E655, OO9102-E755, OO9102-E855, OO9102-E955, OO9102-F055, OO9102-F155, OO9102-F255, OO9102-F355, OO9102-F455, OO9102-F555, OO9102-G055, OO9102-G155, OO9102-G255, OO9102-G355, OO9102-G455, OO9102-G555, OO9102-G655, OO9102-G755, OO9102-G855, OO9102-G955, OO9102-H055, OO9102-H155, OO9102-H555, OO9102-H655, OO9102-H755, OO9102-H855, OO9102-I055, OO9102-I155, OO9102-I255, OO9102-I355, OO9102-I555, OO9102-I655, OO9102-J255, OO9102-J755, OO9102-J855, OO9102-J955, OO9102-K055, OO9102-K155, OO9102-K655, OO9102-M355, OO9102-M455, OO9102-M955, OO9102-N955, OO9102-O055, OO9102-O255, OO9102-O355, OO9102-O455, OO9102-O655, OO9102-O855, OO9102-O955, OO9102, OO9102-P055, OO9102-P155, OO9102-P255, OO9102-P355, OO9102-P455, OO9102-P555, OO9102-P655, OO9102-P755, OO9102-P855, OO9102-Q055, OO9102-Q255, OO9102-Q355, OO9102-Q455, OO9102-Q555, OO9102-Q655, OO9102-Q755, OO9102-Q855, OO9102-Q955, OO9102-R055, OO9102-R155, OO9102-R255, OO9102-R355, OO9102-R455, OO9102-R555, OO9102-R655, OO9102-R755, OO9102-R855, OO9102-R955, OO9102-S055, OO9102-S155, OO9102-S255, OO9102-S355, OO9102-S455, OO9102-S555, OO9102-S655, OO9102-S755, OO9102-S855, OO9102-S955, OO9102-T055, OO9102-T155, OO9102-T255, OO9102-T455, OO9102-T555, OO9102-T655, OO9102-T955, OO9102-U055, OO9102-U455, OO9102-U555, OO9102-U655, OO9102-U755, OO9102-U855, OO9102-V055, OO9102-V155, OO9102-V255, OO9102-V555, OO9102-V655, OO9102-V755, OO9102-V855, OO9102-V955, OO9102-W055, OO9102-W155, OO9102-W255, OO9102-W355, OO9102-W455, OO9102-W555, OO9102-W655, OO9102-W755, OO9102-W855, OO9102-W955, OO9102-X055, OO9102-X255, OO9102-X355, OO9102-X455, OO9102-X555, OO9102-X755, OO9102-X855, OO9102-X955, OO9102-Y055, OO9102-Y155, OO9102-Y255, OO9102-Y355, OO9102-Y455, OO9102-Y555, OO9102-Y655, OO9102-Y755, OO9102-Y855, OO9102-Y955, OO9102-Z055, OO9102-Z155, OO9102-Z255, OO9102-Z355, OO9102-Z455, OO9102-Z555, OO9102-Z755, OO9102-Z955</p>'
    },
    {
      id:  'wl021-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL021-24-274.jpg?v=1784566896',
      alt: 'How to find the SKU on your Oakley Jawbone / Racing Jacket frame'
    },
    {
      id:  'wl031-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL031.jpg?v=1784567206',
      alt: 'How to find the SKU on your Oakley Radar Path frame'
    },
    {
      id:  'wl045-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL045.jpg?v=1784567215',
      alt: 'How to find the SKU on your Oakley Radar Path frame'
    },
    {
      id:  'wl046-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL046-OO9097-12.jpg?v=1784566910',
      alt: 'How to find the SKU on your Oakley Fast Jacket frame'
    },
    {
      id:  'wl110-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL110-OO9175-01.jpg?v=1784566917',
      alt: 'How to find the SKU on your Oakley Garage Rock frame'
    },
    {
      id:  'wl120-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL120.jpg?v=1784567223',
      alt: 'How to find the SKU on your Tifosi Jet frame'
    },
    {
      id:  'wl135-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL135-OO9184-07.jpg?v=1784566926',
      alt: 'How to find the SKU on your Oakley Radar Edge frame'
    },
    {
      id:  'wl152-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL152-405-10.jpg?v=1784566938',
      alt: 'How to find the SKU on your Maui Jim Makaha frame'
    },
    {
      id:  'wl157-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL157-103-02.jpg?v=1784566951',
      alt: 'How to find the SKU on your Maui Jim Stingray frame'
    },
    {
      id:  'wl164-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL164.jpg?v=1784567231',
      alt: 'How to find the SKU on your Bolle Vigilante frame'
    },
    {
      id:  'wl182-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL182-OO9315-03.jpg?v=1784566960',
      alt: 'How to find the SKU on your Oakley Stringer frame'
    },
    {
      id:  'wl217-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL217.jpg?v=1784567239',
      alt: 'How to find the SKU on your Bolle Parole frame'
    },
    {
      id:  'wl220-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL220-OO9411-0127.jpg?v=1784566968',
      alt: 'How to find the SKU on your Oakley Straightback frame'
    },
    {
      id:  'wl230-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL230-OO9298-01.jpg?v=1784566980',
      alt: 'How to find the SKU on your Oakley Hold On frame'
    },
    {
      id:  'wl232-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL232-OO4124-0962-_2.jpg?v=1784566992',
      alt: 'How to find the SKU on your Oakley Gauge 8 L frame'
    },
    {
      id:  'wl238-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL238.jpg?v=1784567247',
      alt: 'How to find the SKU on your Spy Optic Piper frame'
    },
    {
      id:  'wl243-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL243.jpg?v=1784567255',
      alt: 'How to find the SKU on your Smith Optics Approach Max frame'
    },
    {
      id:  'wl276-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL276-445-2M.jpg?v=1784567006',
      alt: 'How to find the SKU on your Maui Jim Hikina frame'
    },
    {
      id:  'wl283-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL283-RB2027-62mm.jpg?v=1784567018',
      alt: 'How to find the SKU on your Ray-Ban RB2027 frame'
    },
    {
      id:  'wl290-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL290-RB4125-59mm.jpg?v=1784567031',
      alt: 'How to find the SKU on your Ray-Ban RB4125 Cats 5000 frame'
    },
    {
      id:  'wl306-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL306-MJ758-13A.jpg?v=1784567043',
      alt: 'How to find the SKU on your Maui Jim Honi frame'
    },
    {
      id:  'wl308-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL308-MJ839-07C.jpg?v=1784567051',
      alt: 'How to find the SKU on your Maui Jim Alenuihaha frame'
    },
    {
      id:  'wl316-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL316-SPR-51O.jpg?v=1784567063',
      alt: 'How to find the SKU on your Prada Conceptual SPR51O frame'
    },
    {
      id:  'wl318-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL318-OO9406-0337.jpg?v=1784567075',
      alt: 'How to find the SKU on your Oakley Sutro frame'
    },
    {
      id:  'wl336-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL336-OO9212-05.jpg?v=1784567087',
      alt: 'How to find the SKU on your Oakley M Frame frame'
    },
    {
      id:  'wl346-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/Glasses-SKU_WL346.jpg?v=1784567263',
      alt: 'How to find the SKU on your Gucci GG0010S frame'
    },
    {
      id:  'wl348-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL348-RB4098-Jackie-Ohh-II.jpg?v=1784567096',
      alt: 'How to find the SKU on your Ray-Ban RB4098 Jackie Ohh II frame'
    },
    {
      id:  'wl357-sku-modal',
      src: 'https://cdn.shopify.com/s/files/1/0991/0694/7374/files/WL357-OO9470-0362.jpg?v=1784567104',
      alt: 'How to find the SKU on your Oakley Gibston XL frame'
    },
  ];

  function makeModal(cfg) {
    var m = document.createElement('div');
    m.id = cfg.id;
    Object.assign(m.style, {
      display: 'none', position: 'fixed',
      top: '0', left: '0', width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.88)', zIndex: '10000',
      cursor: 'pointer', alignItems: 'center', justifyContent: 'center'
    });
    var x = document.createElement('span');
    x.innerHTML = '&#10005;';
    Object.assign(x.style, {
      position: 'fixed', top: '18px', right: '26px',
      color: '#fff', fontSize: '30px', lineHeight: '1',
      fontFamily: 'sans-serif', pointerEvents: 'none'
    });
    m.appendChild(x);
    if (cfg.html) {
      // Text/HTML modal (e.g. long compatible-SKU list)
      var panel = document.createElement('div');
      Object.assign(panel.style, {
        background: '#fff', color: '#222', maxWidth: '680px', width: '90%',
        maxHeight: '80%', overflowY: 'auto', padding: '28px 30px',
        borderRadius: '6px', cursor: 'auto', boxSizing: 'border-box',
        fontSize: '15px', lineHeight: '1.7'
      });
      panel.innerHTML = cfg.html;
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
      m.appendChild(panel);
    } else {
      var img = document.createElement('img');
      img.src = cfg.src;
      img.alt = cfg.alt;
      Object.assign(img.style, {
        maxWidth: '92%', maxHeight: '92%',
        objectFit: 'contain', pointerEvents: 'none'
      });
      m.appendChild(img);
    }
    m.addEventListener('click', function () { m.style.display = 'none'; });
    return m;
  }

  var MODAL_IDS = {};
  document.addEventListener('DOMContentLoaded', function () {
    MODALS.forEach(function (cfg) {
      MODAL_IDS[cfg.id] = true;
      document.body.appendChild(makeModal(cfg));
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var id = href.slice(1);
      if (!MODAL_IDS[id]) return;
      var modal = document.getElementById(id);
      if (modal) {
        e.preventDefault();
        e.stopPropagation();
        modal.style.display = 'flex';
      }
    });
  });
})();

// ── Bidirectional variant swatch filtering ────────────────────────────────────
// Impulse's built-in VariantAvailability filters option2 (Material) and option3
// (Bundle) based on the selected option1 (Color) — but NOT the reverse.
// This extension also filters option1 (Color) based on selected option2 + option3,
// so that when "Mr. Shield Polarized" is chosen, colors with no PCP variant are
// visually disabled; and when "Lenses + Rubber Kit" is chosen, colors that have
// no matching-color rubber kit are disabled.
//
// How it works:
//   1. Reads variant data from [data-variant-json] in the product section container.
//   2. Listens to Impulse's 'variantChange' event, which fires AFTER Impulse has
//      finished updating DOM state — so our pass runs last and wins.
//   3. Reads the now-current option2 + option3 selection and disables option1
//      swatches that have no variant for that combination.
//      (Existence check only — out-of-stock colors remain enabled; Shopify's own
//       sold-out indicator handles the inventory state separately.)
// Updated 2026-05: option3-aware (Bundle option for WL003 + future products)
(function () {
  'use strict';

  function applyColorFilter(container, variants) {
    var opt2Wrap = container.querySelector('.variant-input-wrap[data-index="option2"]');
    if (!opt2Wrap) return; // single-option product — nothing to do

    var opt2Checked = opt2Wrap.querySelector('input[data-variant-input]:checked');
    if (!opt2Checked) return;
    var selectedMaterial = opt2Checked.value;

    // Read option3 (Bundle) if present — null means no 3rd option or none selected yet
    var selectedBundle = null;
    var opt3Wrap = container.querySelector('.variant-input-wrap[data-index="option3"]');
    if (opt3Wrap) {
      var opt3Checked = opt3Wrap.querySelector('input[data-variant-input]:checked');
      if (opt3Checked) { selectedBundle = opt3Checked.value; }
    }

    // A color is valid if ANY variant exists with (color + material [+ bundle if present])
    // Existence check only — no inventory gate here.
    var colorOk = {};
    variants.forEach(function (v) {
      if (v.option2 === selectedMaterial) {
        if (!selectedBundle || v.option3 === selectedBundle) {
          colorOk[v.option1] = true;
        }
      }
    });

    // Apply / remove disabled class on option1 (Color) swatches
    var opt1Wrap = container.querySelector('.variant-input-wrap[data-index="option1"]');
    if (!opt1Wrap) return;

    opt1Wrap.querySelectorAll('.variant-input').forEach(function (variantInput) {
      var colorValue = variantInput.getAttribute('data-value');
      var input = variantInput.querySelector('input[data-variant-input]');
      var label = variantInput.querySelector('label');
      if (!input || !label) return;

      if (colorOk[colorValue]) {
        input.classList.remove('disabled');
        label.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
        label.classList.add('disabled');
      }
    });
  }

  function initProduct(container) {
    var jsonEl = container.querySelector('[data-variant-json]');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent || jsonEl.innerHTML);
    } catch (e) { return; }
    if (!variants || !variants.length) return;

    // Only 2+ option products need this filtering
    if (!container.querySelector('.variant-input-wrap[data-index="option2"]')) return;

    // Listen to Impulse's variantChange event (fires after Impulse finishes DOM updates)
    container.addEventListener('variantChange', function () {
      applyColorFilter(container, variants);
    });

    // Apply initial filter state — delay to let Impulse initialize first
    setTimeout(function () {
      applyColorFilter(container, variants);
    }, 80);
  }

  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



// ── Disabled "Bundle" placeholder buttons ────────────────────────────────────
// Renders non-purchasable Bundle options (e.g. "Lenses + Rubber Kit") as visible
// disabled buttons even though no variant uses that value. Generic: any product
// whose 3rd option is named "Bundle". No radio input -> not selectable, never
// alters variant selection or the color filter (which reads :checked radios only).
(function () {
  'use strict';
  // Per-product disabled-bundle teasers. Only the listed handle gets placeholder
  // buttons for un-built bundle tiers; products not listed (e.g. WL029 Penny, which
  // sells a real "Lenses + Rubber Kit") show no bogus disabled buttons.
  var PLACEHOLDERS = {};   // WL003 ex-bundle: bundle option removed, lens+rubber via BXGY — no disabled bundle buttons
  function currentHandle() {
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  var EXTRA = PLACEHOLDERS[currentHandle()] || [];

  function inject(wrap) {
    if (!EXTRA.length) return;
    if (!wrap) return;
    var present = {};
    wrap.querySelectorAll('.variant-input').forEach(function (vi) {
      present[(vi.getAttribute('data-value') || '').trim()] = true;
    });
    EXTRA.forEach(function (val) {
      if (present[val]) return;
      if (wrap.querySelector('.wl-bundle-placeholder[data-value="' + val + '"]')) return;
      var div = document.createElement('div');
      div.className = 'variant-input wl-bundle-placeholder';
      div.setAttribute('data-index', 'option3');
      div.setAttribute('data-value', val);
      var label = document.createElement('label');
      label.className = 'variant__button-label wl-bundle-disabled';
      label.setAttribute('aria-disabled', 'true');
      label.setAttribute('title', 'Lenses only \u2014 this bundle is not available for this lens');
      label.textContent = val;
      div.appendChild(label);
      wrap.appendChild(div);
    });
  }
  function run() {
    document.querySelectorAll('.variant-input-wrap[data-handle="bundle"]').forEach(inject);
  }
  function init() {
    run();
    document.querySelectorAll('[data-section-type="product"]').forEach(function (c) {
      c.addEventListener('variantChange', run);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();

// ██ WALLEVA CUSTOM — Variant-specific KEY FEATURES box (Style B) — prototype 2026-05-23 ██
// Renders a per-variant key-features grid between the buy buttons and the description.
// Driven by (Color, Material) rules + per-product config. Guarded to configured products only.
(function () {
  'use strict';
  try {
    var CONFIG = {
      "walleva-replacement-lenses-for-smith-lowdown": {
        brand: "Smith", frame: "Lowdown", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-anaa": {
        brand: "Costa Del Mar",
        frame: "Anaa",
        width: "55",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-blackfin": {
        brand: "Costa Del Mar",
        frame: "Blackfin",
        width: "62",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-caballito": {
        brand: "Costa Del Mar",
        frame: "Caballito",
        width: "59",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-gannet": {
        brand: "Costa Del Mar",
        frame: "Gannet",
        width: "58",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-jose": {
        brand: "Costa Del Mar",
        frame: "Jose",
        width: "62",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-loreto": {
        brand: "Costa Del Mar",
        frame: "Loreto",
        width: "56",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-permit": {
        brand: "Costa Del Mar",
        frame: "Permit",
        width: "63",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-cruzem": {
        brand: "Maui Jim",
        frame: "Cruzem",
        width: "57",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-hot-sands": {
        brand: "Maui Jim",
        frame: "Hot Sands",
        width: "71",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-makoa": {
        brand: "Maui Jim",
        frame: "Makoa",
        width: "59",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-red-sands": {
        brand: "Maui Jim",
        frame: "Red Sands",
        width: "59",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-starfish": {
        brand: "Maui Jim",
        frame: "Starfish",
        width: "56",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-swinging-bridges": {
        brand: "Maui Jim",
        frame: "Swinging Bridges",
        width: "61",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-canteen": {
        frame: "Canteen",
        width: "56",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-crosshair-2-0": {
        frame: "Crosshair 2.0",
        width: "64",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-enduro": {
        frame: "Enduro",
        width: "55",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-eyepatch-2": {
        frame: "Eyepatch 2",
        width: "64",
        pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-feedback": {
        frame: "Feedback",
        width: "59",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-gibston-xl": {
        frame: "Gibston XL",
        width: "62",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-half-wire-xl": {
        frame: "Half Wire XL",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-monster-pup": {
        frame: "Monster Pup",
        width: "57",
        pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-new-square-wire": {
        frame: "New Square Wire",
        width: "57",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-quarter-jacket": {
        frame: "Quarter Jacket",
        width: "61",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-romeo-2": {
        frame: "Romeo 2",
        width: "64",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-si-ballistic-m-frame-3-0": {
        frame: "SI Ballistic M Frame 3.0",
        pieces: "shield",
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-square-whisker": {
        frame: "Square Whisker",
        width: "61",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-tailpin": {
        frame: "Tailpin",
        width: "61",
        pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-prada-linea-rossa-sps01x": {
        brand: "Prada",
        frame: "Linea Rossa SPS01X",
        width: "59",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2027-62mm": {
        brand: "Ray-Ban",
        frame: "RB2027 (62mm)",
        width: "62",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3029-outdoorsman-ii": {
        brand: "Ray-Ban",
        frame: "RB3029 Outdoorsman II",
        width: "62",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb4105-50mm": {
        brand: "Ray-Ban",
        frame: "Wayfarer RB4105 (50mm)",
        width: "50",
        pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-wiley-x-valor": {
        brand: "Wiley X",
        frame: "Valor",
        width: "70",
        pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },

      "walleva-replacement-lenses-for-ray-ban-clubmaster-rb3016-51mm": {
        brand: "Ray-Ban",
        frame: "Clubmaster RB3016 (51mm)",
        width: "51",
        pieces: 2,
        th: { "Polarized": "1.0" }
      },

      "walleva-replacement-lenses-for-oakley-m-frame-sweep": {
        frame: "M Frame Sweep",
        pieces: "shield",
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },

      "walleva-replacement-lenses-for-smith-optics-parallel-2": {
        brand: "Smith Optics", frame: "Parallel 2", width: "71", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-parallel-max-2": {
        brand: "Smith Optics", frame: "Parallel Max 2", width: "71", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-ballast": {
        brand: "Costa Del Mar", frame: "Ballast", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-poc-blade": {
        brand: "POC", frame: "Blade", width: "130", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-half-jacket-2-0-xl": {
        frame: "Half Jacket 2.0 XL", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-half-jacket-2-0": {
        frame: "Half Jacket 2.0", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-half-jacket-xlj-vented": {
        frame: "Half Jacket XLJ (vented)", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-half-jacket-xlj": {
        frame: "Half Jacket XLJ", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-half-jacket": {
        frame: "Half Jacket", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-flak-draft": {
        frame: "Flak Draft", width: "67", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-flak-beta": {
        frame: "Flak Beta", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-flak-2-0": {
        frame: "Flak 2.0", width: "59", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-flak-2-0-xl": {
        frame: "Flak 2.0 XL", width: "59", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-flak-jacket-xlj-vented": {
        frame: "Flak Jacket XLJ (vented)", width: "63", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-flak-jacket-xlj": {
        frame: "Flak Jacket XLJ", width: "63", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-flak-jacket": {
        frame: "Flak Jacket", width: "63", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-jawbreaker": {
        frame: "Jawbreaker", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-rinconcito": {
        brand: "Costa Del Mar", frame: "Rinconcito", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4165-justin-51mm": {
        brand: "Ray-Ban", frame: "RB4165 Justin (51mm)", width: "51", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4098-jackie-ohh-ii": {
        brand: "Ray-Ban", frame: "RB4098 Jackie Ohh II", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-lowdown-xl-2": {
        brand: "Smith Optics", frame: "Lowdown XL 2", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb1971-square-54mm": {
        brand: "Ray-Ban", frame: "RB1971 Square (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-split-thump": {
        frame: "Split Thump", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-gascan-asian-fit": {
        frame: "Gascan Asian Fit", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-gascan-vented": {
        frame: "Gascan (vented)", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-radarlock-path": {
        frame: "RadarLock Path", width: "131", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-racing-jacket-vented": {
        frame: "Racing Jacket (vented)", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-racing-jacket": {
        frame: "Racing Jacket", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-strike": {
        frame: "M Frame Strike", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-heater": {
        frame: "M Frame Heater", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-radarlock-pitch": {
        frame: "RadarLock Pitch", width: "131", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-sutro": {
        frame: "Sutro", width: "140", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-lowdown-2": {
        brand: "Smith Optics", frame: "Lowdown 2", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sutro-lite": {
        frame: "Sutro Lite", width: "138", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sutro-low-bridge-fit": {
        frame: "Sutro Low Bridge Fit", width: "140", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sutro-s": {
        frame: "Sutro S", width: "134", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-castel": {
        frame: "Castel", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-reefton": {
        brand: "Costa Del Mar", frame: "Reefton", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-south-point": {
        brand: "Costa Del Mar", frame: "South Point", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-rincon": {
        brand: "Costa Del Mar", frame: "Rincon", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-cat-cay": {
        brand: "Costa Del Mar", frame: "Cat Cay", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-tuna-alley": {
        brand: "Costa Del Mar", frame: "Tuna Alley", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3548n-51mm": {
        brand: "Ray-Ban", frame: "RB3548N (51mm)", width: "51", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-saltbreak": {
        brand: "Costa Del Mar", frame: "Saltbreak", width: "65", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-turbine-rotor": {
        frame: "Turbine Rotor", width: "132", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-holbrook-mix": {
        frame: "Holbrook Mix", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-waterwoman": {
        brand: "Costa Del Mar", frame: "Waterwoman", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-mainlink-xl": {
        frame: "Mainlink XL", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-gibston": {
        frame: "Gibston", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-gucci-gg0010s": {
        brand: "Gucci", frame: "GG0010S", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sylas-60mm": {
        frame: "Sylas (60mm)", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-inlet": {
        brand: "Costa Del Mar", frame: "Inlet", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3548n-54mm": {
        brand: "Ray-Ban", frame: "RB3548N (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-sylas-57mm": {
        frame: "Sylas (57mm)", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3548n-48mm": {
        brand: "Ray-Ban", frame: "RB3548N (48mm)", width: "48", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-m2-shape": {
        frame: "M Frame (M2 Shape)", width: "134", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-clifden": {
        frame: "Clifden", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-stories-wayfarer-rw4004-53mm": {
        brand: "Ray-Ban Stories", frame: "Wayfarer RW4004 (53mm)", width: "53", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-portal-x": {
        frame: "Portal X", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-stories-wayfarer-rw4002-50mm": {
        brand: "Ray-Ban Stories", frame: "Wayfarer RW4002 (50mm)", width: "50", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-gulf-shore": {
        brand: "Costa Del Mar", frame: "Gulf Shore", width: "66", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-cut": {
        brand: "Costa Del Mar", frame: "Cut", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-split-shot": {
        frame: "Split Shot", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-donahugh-designer": {
        brand: "Donahugh", frame: "Designer", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-prada-conceptual-spr51o": {
        brand: "Prada", frame: "Conceptual SPR51O", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-radar-ev-path": {
        frame: "Radar EV Path", width: "128", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4068-60mm": {
        brand: "Ray-Ban", frame: "RB4068 (60mm)", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2180-51mm": {
        brand: "Ray-Ban", frame: "RB2180 (51mm)", width: "51", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-maui-jim-baby-beach": {
        brand: "Maui Jim", frame: "Baby Beach", width: "56", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-maui-jim-local-kine": {
        brand: "Maui Jim", frame: "Local Kine", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-akau": {
        brand: "Maui Jim", frame: "Akau", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2447-52mm": {
        brand: "Ray-Ban", frame: "RB2447 (52mm)", width: "52", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-alenuihaha": {
        brand: "Maui Jim", frame: "Alenuihaha", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2447-49mm": {
        brand: "Ray-Ban", frame: "RB2447 (49mm)", width: "49", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4264-chromance-58mm": {
        brand: "Ray-Ban", frame: "RB4264 Chromance (58mm)", width: "58", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4125-cats-5000-59mm": {
        brand: "Ray-Ban", frame: "RB4125 Cats 5000 (59mm)", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4101-jackie-ohh-58mm": {
        brand: "Ray-Ban", frame: "RB4101 Jackie Ohh (58mm)", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3364-62mm": {
        brand: "Ray-Ban", frame: "RB3364 (62mm)", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4033-60mm": {
        brand: "Ray-Ban", frame: "RB4033 (60mm)", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-honi": {
        brand: "Maui Jim", frame: "Honi", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4165-justin-54mm": {
        brand: "Ray-Ban", frame: "RB4165 Justin (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-bamboo-forest": {
        brand: "Maui Jim", frame: "Bamboo Forest", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3362-cockpit-59mm": {
        brand: "Ray-Ban", frame: "RB3362 Cockpit (59mm)", width: "59", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4173-62mm": {
        brand: "Ray-Ban", frame: "RB4173 (62mm)", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kanaio-coast": {
        brand: "Maui Jim", frame: "Kanaio Coast", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-castles": {
        brand: "Maui Jim", frame: "Castles", width: "61", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3362-cockpit-56mm": {
        brand: "Ray-Ban", frame: "RB3362 Cockpit (56mm)", width: "56", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2180-49mm": {
        brand: "Ray-Ban", frame: "RB2180 (49mm)", width: "49", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb2016-daddy-o-59mm": {
        brand: "Ray-Ban", frame: "RB2016 Daddy-O (59mm)", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-ocean": {
        brand: "Maui Jim", frame: "Ocean", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-hikina": {
        brand: "Maui Jim", frame: "Hikina", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3498-61mm": {
        brand: "Ray-Ban", frame: "RB3498 (61mm)", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kumu": {
        brand: "Maui Jim", frame: "Kumu", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-si-industrial-m-frame-2-0-strike": {
        frame: "SI Industrial M Frame 2.0 Strike", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3136-caravan-58mm": {
        brand: "Ray-Ban", frame: "RB3136 Caravan (58mm)", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3498-64mm": {
        brand: "Ray-Ban", frame: "RB3498 (64mm)", width: "64", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4089-balorama-62mm": {
        brand: "Ray-Ban", frame: "RB4089 Balorama (62mm)", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3136-caravan-55mm": {
        brand: "Ray-Ban", frame: "RB3136 Caravan (55mm)", width: "55", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3478-60mm": {
        brand: "Ray-Ban", frame: "RB3478 (60mm)", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-maui-jim-big-wave": {
        brand: "Maui Jim", frame: "Big Wave", width: "67", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3647-n-51mm": {
        brand: "Ray-Ban", frame: "RB3647-N (51mm)", width: "51", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-breakwall": {
        brand: "Maui Jim", frame: "Breakwall", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-hema": {
        brand: "Maui Jim", frame: "Hema", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-pokowai-arch": {
        brand: "Maui Jim", frame: "Pokowai Arch", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kuiaha-bay": {
        brand: "Maui Jim", frame: "Kuiaha Bay", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-lowdown-xl": {
        brand: "Smith Optics", frame: "Lowdown XL", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-twin-falls": {
        brand: "Maui Jim", frame: "Twin Falls", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-outlier": {
        brand: "Smith Optics", frame: "Outlier", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kipahulu": {
        brand: "Maui Jim", frame: "Kipahulu", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-black-coral": {
        brand: "Maui Jim", frame: "Black Coral", width: "65", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-maui-jim-nalani": {
        brand: "Maui Jim", frame: "Nalani", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-sugar-beach": {
        brand: "Maui Jim", frame: "Sugar Beach", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-peahi": {
        brand: "Maui Jim", frame: "Peahi", width: "65", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-parallel": {
        brand: "Smith Optics", frame: "Parallel", width: "65", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-maui-jim-guardrails": {
        brand: "Maui Jim", frame: "Guardrails", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-approach-max": {
        brand: "Smith Optics", frame: "Approach Max", width: "67", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-punchbowl": {
        brand: "Maui Jim", frame: "Punchbowl", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-outlier-xl": {
        brand: "Smith Optics", frame: "Outlier XL", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kawika": {
        brand: "Maui Jim", frame: "Kawika", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-lighthouse": {
        brand: "Maui Jim", frame: "Lighthouse", width: "65", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-purist": {
        brand: "Smith Optics", frame: "Purist", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-cloud-break": {
        brand: "Maui Jim", frame: "Cloud Break", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-nomad": {
        brand: "Smith Optics", frame: "Nomad", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-wiki-wiki": {
        brand: "Maui Jim", frame: "Wiki Wiki", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-helm": {
        brand: "Spy Optic", frame: "Helm", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-guides-choice": {
        brand: "Smith Optics", frame: "Guide's Choice", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-approach": {
        brand: "Smith Optics", frame: "Approach", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-parallel-d-max": {
        brand: "Smith Optics", frame: "Parallel D-Max", width: "71", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-spy-optic-konvoy": {
        brand: "Spy Optic", frame: "Konvoy", width: "66", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-prospect": {
        brand: "Smith Optics", frame: "Prospect", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-piper": {
        brand: "Spy Optic", frame: "Piper", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-sidney": {
        brand: "Smith Optics", frame: "Sidney", width: "52", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-colt": {
        brand: "Spy Optic", frame: "Colt", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-optics-cheetah": {
        brand: "Smith Optics", frame: "Cheetah", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-whistler": {
        brand: "Spy Optic", frame: "Whistler", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-under-armour-battlewrap": {
        brand: "Under Armour", frame: "Battlewrap", width: "68", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-conductor-8": {
        frame: "Conductor 8", width: "60", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-tailhook": {
        frame: "Tailhook", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-gauge-8-m": {
        frame: "Gauge 8 M", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-hold-on": {
        frame: "Hold On", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-moonlighter": {
        frame: "Moonlighter", width: "53", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-straightback": {
        frame: "Straightback", width: "133", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sliver-r": {
        frame: "Sliver R", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-siphon": {
        frame: "Siphon", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-hold-out": {
        frame: "Hold Out", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-straightlink": {
        frame: "Straightlink", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-square-wire-ii": {
        frame: "Square Wire II", width: "60", pieces: 2,
        th: { "Polarized": "1.0", "Non-Polarized": "1.7", "ISARC Polarized": "1.0", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-gauge-8-l": {
        frame: "Gauge 8 L", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-bolle-parole": {
        brand: "Bolle", frame: "Parole", width: "70", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-given": {
        frame: "Given", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-holston": {
        frame: "Holston", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-split-time": {
        frame: "Split Time", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-elmont-m": {
        frame: "Elmont M", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-twoface-xl": {
        frame: "TwoFace XL", width: "59", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-sliver-edge": {
        frame: "Sliver Edge", width: "65", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-elmont-l": {
        frame: "Elmont L", width: "60", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-flight-jacket": {
        frame: "Flight Jacket", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-tie-breaker": {
        frame: "Tie Breaker", width: "56", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-crosslink-53": {
        frame: "Crosslink 53", width: "53", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-holbrook-xl": {
        frame: "Holbrook XL", width: "59", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-targetline": {
        frame: "Targetline", width: "58", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-crosslink-55": {
        frame: "Crosslink 55", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-catalyst": {
        frame: "Catalyst", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-conquest": {
        frame: "Conquest", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-drop-point": {
        frame: "Drop Point", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-m2-xl": {
        frame: "M2 XL", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-double-edge": {
        frame: "Double Edge", width: "66", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-proxy": {
        frame: "Proxy", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-kickback": {
        frame: "Kickback", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-evzero-pitch": {
        frame: "EVZero Pitch", width: "125", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-shocktube": {
        frame: "Shocktube", width: "61", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-thinlink": {
        frame: "Thinlink", width: "63", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-carbon-blade": {
        frame: "Carbon Blade", width: "66", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-trillbe-x": {
        frame: "Trillbe X", width: "52", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-chainlink": {
        frame: "Chainlink", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-conductor-6": {
        frame: "Conductor 6", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-det-cord": {
        frame: "Det Cord", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-triggerman": {
        frame: "Triggerman", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-rpm-squared": {
        frame: "RPM Squared", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4175-57mm": {
        brand: "Ray-Ban", frame: "RB4175 (57mm)", width: "57", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-round-metal-rb3447-50mm": {
        brand: "Ray-Ban", frame: "Round Metal RB3447 (50mm)", width: "50", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-cohort": {
        frame: "Cohort", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-unstoppable": {
        frame: "Unstoppable", width: "65", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-urgency": {
        frame: "Urgency", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-drop-in": {
        frame: "Drop In", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-forehand": {
        frame: "Forehand", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-crossrange": {
        frame: "Crossrange", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sliver-xl": {
        frame: "Sliver XL", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sliver": {
        frame: "Sliver", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-latch-sq": {
        frame: "Latch SQ", width: "52", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-latch": {
        frame: "Latch", width: "53", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-carbon-shift": {
        frame: "Carbon Shift", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-poc-half-blade": {
        brand: "POC", frame: "Half Blade", width: "130", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-stringer": {
        frame: "Stringer", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-mainlink": {
        frame: "Mainlink", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-vonzipper-fulton": {
        brand: "VonZipper", frame: "Fulton", width: "56", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-vonzipper-elmore": {
        brand: "VonZipper", frame: "Elmore", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-parallel-max": {
        brand: "Smith", frame: "Parallel Max", width: "70", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-tinfoil": {
        frame: "Tinfoil", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-breadbox": {
        frame: "Breadbox", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-smith-serpico": {
        brand: "Smith", frame: "Serpico", width: "66", pieces: 2,
        th: { "Polarized": "1.0", "Non-Polarized": "1.7", "ISARC Polarized": "1.0", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-spy-optic-wayfarer": {
        brand: "Spy Optic", frame: "Wayfarer", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-bolle-recoil": {
        brand: "Bolle", frame: "Recoil", width: "66", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-tincan": {
        frame: "Tincan", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-bolle-anaconda": {
        brand: "Bolle", frame: "Anaconda", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-world-cup": {
        brand: "Maui Jim", frame: "World Cup", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-bolle-vigilante": {
        brand: "Bolle", frame: "Vigilante", width: "73", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-new-valve": {
        frame: "New Valve", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-stingray": {
        brand: "Maui Jim", frame: "Stingray", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-sliver-f": {
        frame: "Sliver F", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-turbine": {
        frame: "Turbine", width: "65", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-hookipa-mj407": {
        brand: "Maui Jim", frame: "Ho'okipa MJ407", width: "64", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-maui-jim-banyans": {
        frame: "Maui Jim Banyans", width: "70", pieces: 2,
        th: { "Polarized": "1.4", "ISARC Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-maui-jim-kanaha": {
        brand: "Maui Jim", frame: "Kanaha", width: "61", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-taper": {
        frame: "Taper", width: "61", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-maui-jim-sandy-beach": {
        brand: "Maui Jim", frame: "Sandy Beach", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-dirk": {
        brand: "Spy Optic", frame: "DIRK", width: "64", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4147-60mm": {
        brand: "Ray-Ban", frame: "RB4147 (60mm)", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-clubmaster-rb3016-49mm": {
        brand: "Ray-Ban", frame: "Clubmaster RB3016 (49mm)", width: "49", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-radar-edge": {
        frame: "Radar Edge", width: "132", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-aviator-rb3025-58mm": {
        brand: "Ray-Ban", frame: "Aviator RB3025 (58mm)", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-maui-jim-makaha": {
        brand: "Maui Jim", frame: "Makaha", width: "64", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb2140-54mm": {
        brand: "Ray-Ban", frame: "Wayfarer RB2140 (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-madman": {
        frame: "Madman", width: "42", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-erika-rb4171-54mm": {
        brand: "Ray-Ban", frame: "Erika RB4171 (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-maui-jim-kahuna": {
        brand: "Maui Jim", frame: "Kahuna", width: "59", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-distress": {
        frame: "Distress", width: "130", pieces: 'shield',
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-badman": {
        frame: "Badman", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-pulse": {
        frame: "Pulse", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-tifosi-jet": {
        brand: "Tifosi", frame: "Jet", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-garage-rock": {
        frame: "Garage Rock", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-dirty-mo": {
        brand: "Spy Optic", frame: "Dirty MO", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-spy-optic-mc": {
        brand: "Spy Optic", frame: "MC", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-crankshaft": {
        frame: "Crankshaft", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-commit-sq": {
        frame: "Commit SQ", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-twoface": {
        frame: "TwoFace", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-spy-optic-logan": {
        brand: "Spy Optic", frame: "Logan", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-spy-optic-cooper": {
        brand: "Spy Optic", frame: "Cooper", width: "59", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-giro-air-attack": {
        brand: "Giro", frame: "Air Attack", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-strike-vented": {
        frame: "M Frame Strike (Vented)", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-pit-boss-ii": {
        frame: "Pit Boss II", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-scalpel": {
        frame: "Scalpel", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-razrwire": {
        frame: "Razrwire", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb8301-59mm": {
        brand: "Ray-Ban", frame: "RB8301 (59mm)", width: "59", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb3183-63mm": {
        brand: "Ray-Ban", frame: "RB3183 (63mm)", width: "63", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-m2": {
        frame: "M2", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4115": {
        brand: "Ray-Ban", frame: "RB4115", width: "57", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-offshoot": {
        frame: "Offshoot", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-brine": {
        brand: "Costa Del Mar", frame: "Brine", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-plaintiff-squared": {
        frame: "Plaintiff Squared", width: "63", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-costa-del-mar-fantail": {
        brand: "Costa Del Mar", frame: "Fantail", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-big-taco": {
        frame: "Big Taco", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb2132-55mm": {
        brand: "Ray-Ban", frame: "Wayfarer RB2132 (55mm)", width: "55", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-radar-pitch": {
        frame: "Radar Pitch", pieces: 'shield',
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-dispatch-ii": {
        frame: "Dispatch II", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-caveat": {
        frame: "Caveat", width: "60", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-aviator-rb3025-55mm": {
        brand: "Ray-Ban", frame: "Aviator RB3025 (55mm)", width: "55", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-bottle-rocket": {
        frame: "Bottle Rocket", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-crankcase": {
        frame: "Crankcase", width: "56", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-jupiter-squared": {
        frame: "Jupiter Squared", width: "56", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-new-crosshair": {
        frame: "New Crosshair", width: "61", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-fatcat": {
        frame: "Fatcat", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-heater-vented": {
        frame: "M Frame Heater (Vented)", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-hybrid-vented": {
        frame: "M Frame Hybrid (Vented)", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-twenty-xx": {
        frame: "XX (Twenty XX)", width: "56", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-whisker": {
        frame: "Whisker", width: "60", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-sweep-vented": {
        frame: "M Frame Sweep (Vented)", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-x-squared": {
        frame: "X Squared", width: "57", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-style-switch": {
        frame: "Style Switch", width: "60", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-x-metal-xx": {
        frame: "X Metal XX", width: "56", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-straight-jacket": {
        frame: "Straight Jacket", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-vented-lenses-for-oakley-split-jacket": {
        frame: "Split Jacket (vented)", width: "61", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-split-jacket": {
        frame: "Split Jacket", width: "61", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-minute-2-0": {
        frame: "Minute 2.0", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-vented-lenses-for-oakley-radar-path": {
        frame: "Radar Path", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-splinter": {
        frame: "Splinter", width: "61", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-hatchet-wire": {
        frame: "Hatchet Wire", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-square-wire-2-0": {
        frame: "Square Wire 2.0", width: "52", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-ten": {
        frame: "Ten", width: "61", pieces: 2,
        th: { "Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-jury": {
        frame: "Jury", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-fives-3-0": {
        frame: "Fives 3.0", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-bottlecap": {
        frame: "Bottlecap", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-half-wire-2-0": {
        frame: "Half Wire 2.0", width: "57", pieces: 2,
        th: { "Polarized": "1.0", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-antix": {
        frame: "Antix", width: "131", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-batwolf": {
        frame: "Batwolf", width: "127", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-plaintiff": {
        frame: "Plaintiff", width: "61", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-m-frame-hybrid": {
        frame: "M Frame Hybrid", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-radar-range": {
        frame: "Radar Range", width: "136", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb2140-50mm": {
        brand: "Ray-Ban", frame: "Wayfarer RB2140 (50mm)", width: "50", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-oil-drum-ii": {
        frame: "Oil Drum II", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-aviator-rb3044-52mm": {
        brand: "Ray-Ban", frame: "Aviator RB3044 (52mm)", width: "52", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-radarlock-xl-vented": {
        frame: "RadarLock XL Vented", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-ray-ban-rb4075-61mm": {
        brand: "Ray-Ban", frame: "RB4075 (61mm)", width: "61", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-dart": {
        frame: "Dart", width: "130", pieces: 'shield',
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb4105-54mm": {
        brand: "Ray-Ban", frame: "Wayfarer RB4105 (54mm)", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-ray-ban-aviator-rb3025-62mm": {
        brand: "Ray-Ban", frame: "Aviator RB3025 (62mm)", width: "62", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-deviation": {
        frame: "Deviation", width: "59", pieces: 2,
        th: { "Polarized": "1.0", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-new-twenty": {
        frame: "New Twenty", width: "55", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-tightrope": {
        frame: "Tightrope", width: "58", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-rudy-project-noyz": {
        brand: "Rudy Project", frame: "Noyz", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-probation": {
        frame: "Probation", width: "131", pieces: 'shield',
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-ray-ban-wayfarer-rb2132-52mm": {
        brand: "Ray-Ban", frame: "Wayfarer RB2132 (52mm)", width: "52", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-blender": {
        frame: "Blender", width: "59", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-rudy-project-rydon": {
        brand: "Rudy Project", frame: "Rydon", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-oil-rig-ii": {
        frame: "Oil Rig II", width: "128", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-fast-jacket": {
        frame: "Fast Jacket", width: "71", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-radar-path": {
        frame: "Radar Path", pieces: 'shield',
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-monster-dog": {
        frame: "Monster Dog", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-juliet-vented": {
        frame: "Juliet (vented)", width: "55", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-jawbone-vented": {
        frame: "Jawbone (vented)", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-pit-bull": {
        frame: "Pit Bull", width: "62", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-penny": {
        frame: "Penny", width: "53", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-mars": {
        frame: "Mars", width: "42", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-jupiter": {
        frame: "Jupiter", width: "58", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-juliet": {
        frame: "Juliet", width: "55", pieces: 2,
        th: { "Polarized": "1.0", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-jawbone": {
        frame: "Jawbone", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-inmate": {
        frame: "Inmate", width: "65", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-hijinx": {
        frame: "Hijinx", width: "64", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-half-x": {
        frame: "Half X", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-gascan": {
        frame: "Gascan", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-fuel-cell": {
        frame: "Fuel Cell", width: "60", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-frogskins": {
        frame: "Frogskins", width: "55", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-fives-squared": {
        frame: "Fives Squared", width: "54", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "ISARC Polarized": "1.4", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-fives-4-0": {
        frame: "Fives 4.0", width: "54", pieces: 2,
        th: { "Polarized": "1.4" }
      },
      "walleva-replacement-lenses-for-oakley-dispatch-oo9090-series": {
        frame: "Dispatch", width: "62", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7" }
      },
      "walleva-replacement-lenses-for-oakley-crosshair-1-0": {
        frame: "Crosshair 1.0", pieces: 2,
        th: { "Polarized": "1.0" }
      },
      "walleva-replacement-lenses-for-oakley-holbrook": {
        frame: "Holbrook", width: "55", pieces: 2,
        th: { "Polarized": "1.4", "ISARC Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      },
      "walleva-replacement-lenses-for-oakley-fast-jacket-xl": {
        frame: "Fast Jacket XL", pieces: 2,
        th: { "Polarized": "1.4", "Non-Polarized": "1.7", "Mr. Shield Polarized": "1.5" }
      }
    };
    var handle = (location.pathname.split('/products/')[1] || '').split('/')[0].split('?')[0];
    var cfg = CONFIG[handle];
    if (!cfg) return; // not a configured product — do nothing

    var MIRROR = {"Fire Red":1,"24K Gold":1,"Emerald Green":1,"Titanium":1};
    var COATED = {"Ice Blue":"Blue","Purple":"Purple"};  // color-coated, NOT mirror
    var NOUV = {"Clear":1,"Yellow":1,"Pink":1};
    var NPUSE = {"Clear":["target","Ideal for shooting & low light"],"Yellow":["moon","Boosts contrast for night riding"],"Pink":["cloud","Boosts contrast in cloudy / low light"]};
    var IC = {
      uv:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.2"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/></svg>',
      frame:'<svg viewBox="0 0 24 24"><circle cx="6.5" cy="13" r="3.5"/><circle cx="17.5" cy="13" r="3.5"/><path d="M10 12.5c1-1 3-1 4 0M3 11l1.5-2.5M21 11l-1.5-2.5"/></svg>',
      polar:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2"/><path d="M4 20 20 4"/></svg>',
      screen:'<svg viewBox="0 0 24 24"><rect x="6" y="3" width="12" height="18" rx="2"/><path d="M10 18h4"/></svg>',
      light:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 4a8 8 0 0 0 0 16z" fill="currentColor" stroke="none" opacity=".55"/></svg>',
      mirror:'<svg viewBox="0 0 24 24"><path d="M12 2l1.6 4.4L18 8l-4.4 1.6L12 14l-1.6-4.4L6 8l4.4-1.6z"/><path d="M18 15l.8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8z"/></svg>',
      coated:'<svg viewBox="0 0 24 24"><path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z" fill="currentColor" stroke="none"/></svg>',
      target:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 1v3M12 20v3M1 12h3M20 12h3"/></svg>',
      moon:'<svg viewBox="0 0 24 24"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/></svg>',
      cloud:'<svg viewBox="0 0 24 24"><path d="M7 18a4 4 0 0 1 0-8 5 5 0 0 1 9.6-1.3A3.5 3.5 0 0 1 18 18z"/></svg>',
      material:'<svg viewBox="0 0 24 24"><path d="M12 3 3 8l9 5 9-5z"/><path d="M3 13l9 5 9-5"/></svg>',
      thick:'<svg viewBox="0 0 24 24"><path d="M5 6h14M5 18h14M12 8v8M12 8l-2.5 2.5M12 8l2.5 2.5M12 16l-2.5-2.5M12 16l2.5-2.5"/></svg>',
      width:'<svg viewBox="0 0 24 24"><path d="M3 8v8M21 8v8M5 12h14M5 12l2.5-2.5M5 12l2.5 2.5M19 12l-2.5-2.5M19 12l-2.5 2.5"/></svg>',
      box:'<svg viewBox="0 0 24 24"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
      plus:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>',
      pair:'<svg viewBox="0 0 24 24"><ellipse cx="7" cy="12" rx="4.3" ry="5.5"/><ellipse cx="17" cy="12" rx="4.3" ry="5.5"/></svg>',
      shieldlens:'<svg viewBox="0 0 24 24"><path d="M3 9c4.5-3.2 13.5-3.2 18 0-1.2 5.2-4 8.2-9 9.4C7 17.2 4.2 14.2 3 9z"/></svg>',
      impact:'<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
      taper:'<svg viewBox="0 0 24 24"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="2.5"/></svg>',
      water:'<svg viewBox="0 0 24 24"><path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/></svg>',
      shatter:'<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M12 7l-1.7 4.2h3.4L12 16"/></svg>',
      rearglare:'<svg viewBox="0 0 24 24"><path d="M3 19h18"/><path d="M8 15a4 4 0 0 1 8 0"/><path d="M12 5v2M5.5 8l1.4 1.4M18.5 8l-1.4 1.4M3.5 13h2M18.5 13h2"/></svg>'
    };
    function lt(c){ if(c==="Transition")return "Light grey \u2192 dark grey (12\u201340%)"; if(c==="Clear")return "99% light transmission"; if(c==="Yellow")return "75% light transmission"; if(c==="Pink")return "36% light transmission"; return "16% light transmission"; }
    function feats(color, material){
      var pc = (material==="Non-Polarized"||material==="Mr. Shield Polarized");
      var f=[];
      if(!NOUV[color]) f.push(['uv','100% UV protection']);
      f.push(['frame','Fits '+(cfg.brand||'Oakley')+' '+cfg.frame]);
      f.push((cfg.pieces==='shield'||cfg.pieces===1) ? ['shieldlens','Single shield lens'] : ['pair','2 lenses (left + right)']);
      if(material==="Non-Polarized"){ var u=NPUSE[color]; f.push(u?[u[0],u[1]]:['screen','Non-Polarized — easy to read screens']); }
      else f.push(['polar','Polarized — blocks glare']);
      f.push(['light',lt(color)]);
      if(MIRROR[color]) f.push(['mirror','Mirror finish']); else if(COATED[color]) f.push(['coated', COATED[color]+' color coating (non-mirror)']);
      f.push(['material', pc?'Polycarbonate (PC)':'Triacetate (TAC)']);
      f.push(['thick',(cfg.th[material]||cfg.th.Polarized)+' mm lens thickness']);
      if(cfg.width) f.push(['width',cfg.width+' mm lens width']);
      var z87=(material==="Mr. Shield Polarized"||material==="Non-Polarized");
      f.push(['impact', (z87?'Z87.1':'Z80.3')+' impact certified']);
      f.push(['shatter','Shatterproof']);
      if(material==="Mr. Shield Polarized"){ f.push(['taper','Taper-corrected optics']); f.push(['water','Sea, pool & detergent resistant']); }
      if(material==="ISARC Polarized"){ f.push(['water','Inner anti-reflection coating']); f.push(['rearglare','Eliminates rear glare']); }
      f.push(['box','Includes microfiber cloth & lens bag']);
      if(cfg.accessory) f.push(['plus', cfg.accessory]);
      return f;
    }
    function current(container){
      function chk(i){ var w=container.querySelector('.variant-input-wrap[data-index="'+i+'"]'); if(!w)return null; var c=w.querySelector('input[data-variant-input]:checked'); return c?c.value:null; }
      return [chk('option1'), chk('option2')||'Polarized'];
    }
    function render(container, box){
      var cv=current(container); var color=cv[0]; if(!color) return;
      var items=feats(color, cv[1]);
      box.innerHTML='<div class="wl-kf__t">Key Features</div><ul class="wl-kf__list">'+
        items.map(function(it){return '<li><span class="wl-kf__ic">'+IC[it[0]]+'</span><span>'+it[1]+'</span></li>';}).join('')+'</ul>';
    }
    function init(container){
      // place the box right under the swatches (after the variant-picker block, before buy buttons)
      var picker = container.querySelector('.variant-input-wrap[data-index="option2"]')
                || container.querySelector('.variant-input-wrap[data-index="option1"]');
      var anchor = picker ? (picker.closest('.product-block') || picker) : null;
      if(!anchor){ var pay = container.querySelector('.payment-buttons'); anchor = pay ? (pay.closest('.product-block')||pay) : null; }
      if(!anchor) return;
      var box=document.createElement('div'); box.className='wl-kf';
      anchor.insertAdjacentElement('afterend', box);
      var draw=function(){ render(container, box); };
      container.addEventListener('variantChange', draw);
      container.querySelectorAll('.variant-input-wrap input[data-variant-input]').forEach(function(i){ i.addEventListener('change', function(){ setTimeout(draw,30); }); });
      setTimeout(draw, 120);
    }
    function go(){ document.querySelectorAll('[data-section-type="product"]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  } catch(e){ /* never break the page */ }
})();

// ██ WALLEVA CUSTOM — combo "2-Pair Sets" group caption — 2026-05-23 ██
// Breaks the 2-pair combo swatches onto their own line under a caption so customers
// know they're 2-pair value sets (not single lenses). Combos = Color values containing " + ".
(function(){'use strict';try{
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  if(handle!=='walleva-replacement-lenses-for-oakley-holbrook') return; // prototype guard (WL019)
  function run(wrap){
    if(wrap.querySelector('.wl-combo-head')) return;
    var sw=[].slice.call(wrap.querySelectorAll('.variant-input'));
    var combos=sw.filter(function(s){return (s.getAttribute('data-value')||'').indexOf(' + ')>-1;});
    if(!combos.length) return;
    var h=document.createElement('div'); h.className='wl-combo-head';
    h.textContent='2-Pair Sets — two pairs of lenses, save more';
    combos[0].parentNode.insertBefore(h, combos[0]);
  }
  function init(){ document.querySelectorAll('.variant-input-wrap[data-index="option1"]').forEach(run); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
}catch(e){}})();


// ██ WALLEVA CUSTOM — volume offer banner (Buy 2+ save) — 2026-05-23 ██
(function(){'use strict';try{
  var OFFERS={"walleva-replacement-lenses-for-oakley-holbrook":"Buy more, save more — 2 pairs 20% off · 3 pairs 25% off · 5 pairs 30% off (mix any colors)","walleva-replacement-lenses-for-oakley-fast-jacket-xl":"Buy more, save more — 2 pairs 20% off · 3 pairs 25% off · 5 pairs 30% off (mix any colors)"};
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  var DEF="Buy more, save more — 2 pairs 20%25 off · 3 pairs 25%25 off · 5 pairs 30%25 off (mix any colors)".replace(/%25/g,"%");var msg=OFFERS[handle]; if(!msg){ if((handle.indexOf("replacement")>-1 && handle.indexOf("lenses")>-1)||/(earsocks|rubber-kit|nose-pad)/.test(handle)) msg=DEF; else return; }
  function go(){
    document.querySelectorAll('[data-section-type="product"]').forEach(function(c){
      if(c.querySelector('.wl-vol')) return;
      var price=c.querySelector('.product__price,[data-product-price],.price__regular,.price');
      if(!price) return;
      var anchor=price.closest('.product-block')||price;
      var d=document.createElement('div'); d.className='wl-vol';
      d.innerHTML='<svg viewBox="0 0 24 24"><path d="M20.5 13.5l-7 7-9-9V4.5h7z"/><circle cx="9" cy="9" r="1.3"/></svg><span>'+msg+'</span>';
      anchor.insertAdjacentElement('afterend', d);
    });
  }
  if(document.readyState==="loading")document.addEventListener('DOMContentLoaded',go);else go();
}catch(e){}})();


// ██ WALLEVA CUSTOM — rubber-kit KEY FEATURES box — 2026-05-22 ██
(function(){'use strict';try{
  var KF={"walleva-rubber-kit-for-oakley-fast-jacket": [["shield", "Medical-grade silicone"], ["skin", "Hypoallergenic — skin-safe"], ["water", "Won't absorb sweat or oils"], ["grip", "Stays flexible in heat and cold"], ["box", "Tool-free installation"], ["restore", "Restore your frame — no need to replace"]], "walleva-replacement-lenses-for-oakley-dispatch-oo9090-series-multi-pack-lot": [["frame", "Fits Oakley Dispatch"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-half-jacket-xlj-vented-multi-pack-lot": [["frame", "Fits Oakley Half Jacket XLJ (vented)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-hijinx-multi-pack-lot": [["frame", "Fits Oakley Hijinx"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "64 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-inmate-multi-pack-lot": [["frame", "Fits Oakley Inmate"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "65 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-jawbone-multi-pack-lot": [["frame", "Fits Oakley Jawbone"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-jawbone-vented-multi-pack-lot": [["frame", "Fits Oakley Jawbone (vented)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-mars-multi-pack-lot": [["frame", "Fits Oakley Mars"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "42 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-oil-rig-ii-multi-pack-lot": [["frame", "Fits Oakley Oil Rig II"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 or 10 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "128 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-pit-bull-multi-pack-lot": [["frame", "Fits Oakley Pit Bull"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-vented-lenses-for-oakley-radar-path-multi-pack-lot": [["frame", "Fits Oakley Radar Path"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 or 10 lenses per pack — every lens in its own small bag"], ["polar", "Non-Polarized lenses"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-straight-jacket-multi-pack-lot": [["frame", "Fits Oakley Straight Jacket"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-twenty-xx-multi-pack-lot": [["frame", "Fits Oakley XX (Twenty XX)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-monster-pup-multi-pack-lot": [["frame", "Fits Oakley Monster Pup"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-fast-jacket-multi-pack-lot": [["frame", "Fits Oakley Fast Jacket"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "71 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-romeo-2-multi-pack-lot": [["frame", "Fits Oakley Romeo 2"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "64 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-square-whisker-multi-pack-lot": [["frame", "Fits Oakley Square Whisker"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-crosshair-2-0-multi-pack-lot": [["frame", "Fits Oakley Crosshair 2.0"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "64 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-half-wire-2-0-multi-pack-lot": [["frame", "Fits Oakley Half Wire 2.0"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-bottlecap-multi-pack-lot": [["frame", "Fits Oakley Bottlecap"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-antix-multi-pack-lot": [["frame", "Fits Oakley Antix"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "131 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-square-wire-2-0-multi-pack-lot": [["frame", "Fits Oakley Square Wire 2.0"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "52 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-plaintiff-multi-pack-lot": [["frame", "Fits Oakley Plaintiff"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-half-jacket-2-0-multi-pack-lot": [["frame", "Fits Oakley Half Jacket 2.0"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-new-twenty-multi-pack-lot": [["frame", "Fits Oakley New Twenty"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-deviation-multi-pack-lot": [["frame", "Fits Oakley Deviation"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-caveat-multi-pack-lot": [["frame", "Fits Oakley Caveat"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-tightrope-multi-pack-lot": [["frame", "Fits Oakley Tightrope"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-radarlock-xl-vented-multi-pack-lot": [["frame", "Fits Oakley RadarLock XL Vented"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-oil-drum-ii-multi-pack-lot": [["frame", "Fits Oakley Oil Drum II"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-fatcat-multi-pack-lot": [["frame", "Fits Oakley Fatcat"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-jupiter-squared-multi-pack-lot": [["frame", "Fits Oakley Jupiter Squared"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-blender-multi-pack-lot": [["frame", "Fits Oakley Blender"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-half-wire-xl-multi-pack-lot": [["frame", "Fits Oakley Half Wire XL"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-wayfarer-rb4105-54mm-multi-pack-lot": [["frame", "Fits Ray-Ban Wayfarer RB4105 (54mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-aviator-rb3044-52mm-multi-pack-lot": [["frame", "Fits Ray-Ban Aviator RB3044 (52mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "52 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-plaintiff-squared-multi-pack-lot": [["frame", "Fits Oakley Plaintiff Squared"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "63 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-offshoot-multi-pack-lot": [["frame", "Fits Oakley Offshoot"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Non-Polarized lenses"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-cooper-multi-pack-lot": [["frame", "Fits Spy Optic Cooper"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-logan-multi-pack-lot": [["frame", "Fits Spy Optic Logan"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-fantail-multi-pack-lot": [["frame", "Fits Costa Del Mar Fantail"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-scalpel-multi-pack-lot": [["frame", "Fits Oakley Scalpel"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-radar-edge-multi-pack-lot": [["frame", "Fits Oakley Radar Edge"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 or 10 lenses per pack — every lens in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["uv", "100% UV protection"], ["width", "132 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-pulse-multi-pack-lot": [["frame", "Fits Oakley Pulse"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-feedback-multi-pack-lot": [["frame", "Fits Oakley Feedback"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-distress-multi-pack-lot": [["frame", "Fits Oakley Distress"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "130 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-clubmaster-rb3016-49mm-multi-pack-lot": [["frame", "Fits Ray-Ban Clubmaster RB3016 (49mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "49 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb4175-57mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB4175 (57mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-kahuna-multi-pack-lot": [["frame", "Fits Maui Jim Kahuna"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-makaha-multi-pack-lot": [["frame", "Fits Maui Jim Makaha"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["width", "64 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-kanaha-multi-pack-lot": [["frame", "Fits Maui Jim Kanaha"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-sliver-f-multi-pack-lot": [["frame", "Fits Oakley Sliver F"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-wayfarer-multi-pack-lot": [["frame", "Fits Spy Optic Wayfarer"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-serpico-multi-pack-lot": [["frame", "Fits Smith Serpico"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "66 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-lowdown-multi-pack-lot": [["frame", "Fits Smith Lowdown"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-vonzipper-elmore-multi-pack-lot": [["frame", "Fits VonZipper Elmore"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-latch-sq-multi-pack-lot": [["frame", "Fits Oakley Latch SQ"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "52 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-carbon-shift-multi-pack-lot": [["frame", "Fits Oakley Carbon Shift"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-flak-draft-multi-pack-lot": [["frame", "Fits Oakley Flak Draft"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "67 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-drop-in-multi-pack-lot": [["frame", "Fits Oakley Drop In"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-urgency-multi-pack-lot": [["frame", "Fits Oakley Urgency"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-unstoppable-multi-pack-lot": [["frame", "Fits Oakley Unstoppable"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "65 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-rpm-squared-multi-pack-lot": [["frame", "Fits Oakley RPM Squared"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-square-wire-ii-multi-pack-lot": [["frame", "Fits Oakley Square Wire II"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-moonlighter-multi-pack-lot": [["frame", "Fits Oakley Moonlighter"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "53 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-twoface-xl-multi-pack-lot": [["frame", "Fits Oakley TwoFace XL"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-proxy-multi-pack-lot": [["frame", "Fits Oakley Proxy"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-cohort-multi-pack-lot": [["frame", "Fits Oakley Cohort"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized and Non-Polarized packs — see the pack name"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-kickback-multi-pack-lot": [["frame", "Fits Oakley Kickback"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-crosslink-53-multi-pack-lot": [["frame", "Fits Oakley Crosslink 53"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "53 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-split-time-multi-pack-lot": [["frame", "Fits Oakley Split Time"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-straightlink-multi-pack-lot": [["frame", "Fits Oakley Straightlink"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-straightback-multi-pack-lot": [["frame", "Fits Oakley Straightback"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "133 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-conquest-multi-pack-lot": [["frame", "Fits Oakley Conquest"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-targetline-multi-pack-lot": [["frame", "Fits Oakley Targetline"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-elmont-l-multi-pack-lot": [["frame", "Fits Oakley Elmont L"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-elmont-m-multi-pack-lot": [["frame", "Fits Oakley Elmont M"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-tailpin-multi-pack-lot": [["frame", "Fits Oakley Tailpin"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-hold-out-multi-pack-lot": [["frame", "Fits Oakley Hold Out"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-hold-on-multi-pack-lot": [["frame", "Fits Oakley Hold On"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-conductor-8-multi-pack-lot": [["frame", "Fits Oakley Conductor 8"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-whistler-multi-pack-lot": [["frame", "Fits Spy Optic Whistler"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-colt-multi-pack-lot": [["frame", "Fits Spy Optic Colt"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "63 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-piper-multi-pack-lot": [["frame", "Fits Spy Optic Piper"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-konvoy-multi-pack-lot": [["frame", "Fits Spy Optic Konvoy"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "66 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-spy-optic-helm-multi-pack-lot": [["frame", "Fits Spy Optic Helm"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-parallel-d-max-multi-pack-lot": [["frame", "Fits Smith Optics Parallel D-Max"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Non-Polarized lenses"], ["uv", "100% UV protection"], ["width", "71 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-approach-max-multi-pack-lot": [["frame", "Fits Smith Optics Approach Max"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "67 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-nomad-multi-pack-lot": [["frame", "Fits Smith Optics Nomad"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-purist-multi-pack-lot": [["frame", "Fits Smith Optics Purist"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "59 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-outlier-xl-multi-pack-lot": [["frame", "Fits Smith Optics Outlier XL"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-parallel-multi-pack-lot": [["frame", "Fits Smith Optics Parallel"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "65 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-outlier-multi-pack-lot": [["frame", "Fits Smith Optics Outlier"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-cheetah-multi-pack-lot": [["frame", "Fits Smith Optics Cheetah"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-sidney-multi-pack-lot": [["frame", "Fits Smith Optics Sidney"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "52 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-prospect-multi-pack-lot": [["frame", "Fits Smith Optics Prospect"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-cloud-break-multi-pack-lot": [["frame", "Fits Maui Jim Cloud Break"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-nalani-multi-pack-lot": [["frame", "Fits Maui Jim Nalani"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-guardrails-multi-pack-lot": [["frame", "Fits Maui Jim Guardrails"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-kuiaha-bay-multi-pack-lot": [["frame", "Fits Maui Jim Kuiaha Bay"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-bamboo-forest-multi-pack-lot": [["frame", "Fits Maui Jim Bamboo Forest"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-kumu-multi-pack-lot": [["frame", "Fits Maui Jim Kumu"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "64 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-swinging-bridges-multi-pack-lot": [["frame", "Fits Maui Jim Swinging Bridges"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-starfish-multi-pack-lot": [["frame", "Fits Maui Jim Starfish"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "56 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-maui-jim-ocean-multi-pack-lot": [["frame", "Fits Maui Jim Ocean"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb4089-balorama-62mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB4089 Balorama (62mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb3029-outdoorsman-ii-multi-pack-lot": [["frame", "Fits Ray-Ban RB3029 Outdoorsman II"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb3136-caravan-55mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB3136 Caravan (55mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb4068-60mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB4068 (60mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb2180-51mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB2180 (51mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "51 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb2447-49mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB2447 (49mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "49 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb2447-52mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB2447 (52mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "52 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-donahugh-designer-multi-pack-lot": [["frame", "Fits Donahugh Designer"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-anaa-multi-pack-lot": [["frame", "Fits Costa Del Mar Anaa"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-cut-multi-pack-lot": [["frame", "Fits Costa Del Mar Cut"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb3548n-48mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB3548N (48mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "48 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb3548n-51mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB3548N (51mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "51 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb3548n-54mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB3548N (54mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-gucci-gg0010s-multi-pack-lot": [["frame", "Fits Gucci GG0010S"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 or 10 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb1971-square-54mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB1971 Square (54mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "54 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb4098-jackie-ohh-ii-multi-pack-lot": [["frame", "Fits Ray-Ban RB4098 Jackie Ohh II"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-ray-ban-rb4165-justin-51mm-multi-pack-lot": [["frame", "Fits Ray-Ban RB4165 Justin (51mm)"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "51 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-inlet-multi-pack-lot": [["frame", "Fits Costa Del Mar Inlet"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-gannet-multi-pack-lot": [["frame", "Fits Costa Del Mar Gannet"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "58 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-waterwoman-multi-pack-lot": [["frame", "Fits Costa Del Mar Waterwoman"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-blackfin-multi-pack-lot": [["frame", "Fits Costa Del Mar Blackfin"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-costa-del-mar-jose-multi-pack-lot": [["frame", "Fits Costa Del Mar Jose"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-holbrook-mix-multi-pack-lot": [["frame", "Fits Oakley Holbrook Mix"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "57 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-gibston-xl-multi-pack-lot": [["frame", "Fits Oakley Gibston XL"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "62 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-mainlink-xl-multi-pack-lot": [["frame", "Fits Oakley Mainlink XL"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "61 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-turbine-rotor-multi-pack-lot": [["frame", "Fits Oakley Turbine Rotor"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "132 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-oakley-sutro-s-multi-pack-lot": [["frame", "Fits Oakley Sutro S"], ["shieldlens", "One-piece shield lens"], ["box", "Package included: 5 lenses per pack — every lens in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "134 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-lowdown-2-multi-pack-lot": [["frame", "Fits Smith Optics Lowdown 2"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "55 mm lens width"], ["shatter", "Shatterproof"]], "walleva-replacement-lenses-for-smith-optics-lowdown-xl-2-multi-pack-lot": [["frame", "Fits Smith Optics Lowdown XL 2"], ["pair", "Each pair: 2 lenses (left + right)"], ["box", "Package included: 5 pairs per pack — every pair in its own small bag"], ["polar", "Polarized — blocks glare"], ["uv", "100% UV protection"], ["width", "60 mm lens width"], ["shatter", "Shatterproof"]]};
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  var IC={uv:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.2"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19"/></svg>',pair:'<svg viewBox="0 0 24 24"><ellipse cx="7" cy="12" rx="4.3" ry="5.5"/><ellipse cx="17" cy="12" rx="4.3" ry="5.5"/></svg>',shieldlens:'<svg viewBox="0 0 24 24"><path d="M3 9c4.5-3.2 13.5-3.2 18 0-1.2 5.2-4 8.2-9 9.4C7 17.2 4.2 14.2 3 9z"/></svg>',polar:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2"/><path d="M4 20 20 4"/></svg>',shatter:'<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M12 7l-1.7 4.2h3.4L12 16"/></svg>',
    shield:'<svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    skin:'<svg viewBox="0 0 24 24"><path d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 5.65-7 10-7 10z"/></svg>',
    box:'<svg viewBox="0 0 24 24"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
    frame:'<svg viewBox="0 0 24 24"><circle cx="6.5" cy="13" r="3.5"/><circle cx="17.5" cy="13" r="3.5"/><path d="M10 12.5c1-1 3-1 4 0M3 11l1.5-2.5M21 11l-1.5-2.5"/></svg>',
    water:'<svg viewBox="0 0 24 24"><path d="M12 3s6 6.5 6 10.5A6 6 0 0 1 6 13.5C6 9.5 12 3 12 3z"/></svg>',
    grip:'<svg viewBox="0 0 24 24"><path d="M7 11V6.5a1.5 1.5 0 0 1 3 0V10M10 10V4.5a1.5 1.5 0 0 1 3 0V10M13 10.5V6a1.5 1.5 0 0 1 3 0v8a6 6 0 0 1-6 6 6 6 0 0 1-5.2-3L4 14.5a1.6 1.6 0 0 1 3-1.3"/></svg>',
    palette:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><circle cx="8.5" cy="9" r="1.1"/><circle cx="15.5" cy="9" r="1.1"/><circle cx="9" cy="15" r="1.1"/><circle cx="15" cy="15" r="1.1"/></svg>',
    restore:'<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    width:'<svg viewBox="0 0 24 24"><path d="M3 8v8M21 8v8M5 12h14M5 12l2.5-2.5M5 12l2.5 2.5M19 12l-2.5-2.5M19 12l-2.5 2.5"/></svg>'
  };
  function init(c){
    var feats=KF[handle]||(window.__WL_RUBBER_KF&&window.__WL_RUBBER_KF[handle]);
    if(!feats||c.querySelector('.wl-kf')) return;
    var picker=c.querySelector('.variant-input-wrap[data-index="option1"]');
    var anchor=picker?(picker.closest('.product-block')||picker):null;
    if(!anchor){ var p=c.querySelector('.payment-buttons,.product__price,.price'); anchor=p?(p.closest('.product-block')||p):null; }
    if(!anchor) return;
    var box=document.createElement('div'); box.className='wl-kf';
    box.innerHTML='<div class="wl-kf__t">Key Features</div><ul class="wl-kf__list">'+
      feats.map(function(it){return '<li><span class="wl-kf__ic">'+(IC[it[0]]||'')+'</span><span>'+it[1]+'</span></li>';}).join('')+'</ul>';
    anchor.insertAdjacentElement('afterend', box);
  }
  function go(){ document.querySelectorAll('[data-section-type="product"]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();


// ██ WALLEVA CUSTOM — rubber KF registry ██
window.__WL_RUBBER_KF=window.__WL_RUBBER_KF||{};
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-fast-jacket"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-flak-jacket"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-flak-2-0"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-half-jacket"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-half-jacket-2-0"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-rubber-kit-for-oakley-x-metal-series"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-earsocks-for-oakley-jawbone-split-jacket"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-earsocks-for-oakley-m-frame"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-earsocks-for-oakley-m2"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-earsocks-for-oakley-radar"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-earsocks-for-oakley-radarlock"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["grip","Stays flexible in heat and cold"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-nose-pads-for-oakley-jawbreaker"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["width","Distributes pressure evenly on nose bridge"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-nose-pads-for-oakley-m2"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["width","Distributes pressure evenly on nose bridge"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-nose-pads-for-oakley-radar"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["width","Distributes pressure evenly on nose bridge"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-nose-pads-for-oakley-sutro"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["width","Distributes pressure evenly on nose bridge"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];
window.__WL_RUBBER_KF["walleva-nose-pads-for-oakley-targetline-crossrange"]=[["shield","Medical-grade silicone"],["skin","Hypoallergenic — skin-safe"],["water","Won't absorb sweat or oils"],["width","Distributes pressure evenly on nose bridge"],["box","Tool-free installation"],["restore","Restore your frame — no need to replace"]];


// ██ WALLEVA CUSTOM — rubber lens-offer registry ██
window.__WL_RUBBER_LENS=window.__WL_RUBBER_LENS||{};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-fast-jacket"]={"pct": 70, "fam": "Fast Jacket / Fast Jacket XL", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-nose-pads-for-oakley-targetline-crossrange"]={"pct": 70, "fam": "Targetline / Crossrange", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-nose-pads-for-oakley-m2"]={"pct": 70, "fam": "M2 / M2 XL", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-nose-pads-for-oakley-sutro"]={"pct":70,"fam":"Sutro family","coll":"lenses","lenses":[{"n":"Sutro","h":"walleva-replacement-lenses-for-oakley-sutro"},{"n":"Sutro S","h":"walleva-replacement-lenses-for-oakley-sutro-s"},{"n":"Sutro Low Bridge Fit","h":"walleva-replacement-lenses-for-oakley-sutro-low-bridge-fit"},{"n":"Sutro Lite","h":"walleva-replacement-lenses-for-oakley-sutro-lite"}]};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-flak-2-0"]={"pct": 70, "fam": "Flak 2.0 / Flak 2.0 XL", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-earsocks-for-oakley-m2"]={"pct": 70, "fam": "M2 / M2 XL", "coll": "lenses", "lenses": [{"n": "M2 XL", "h": "walleva-replacement-lenses-for-oakley-m2-xl"}]};
window.__WL_RUBBER_LENS["walleva-nose-pads-for-oakley-jawbreaker"]={"pct": 70, "fam": "Jawbreaker", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-earsocks-for-oakley-radarlock"]={"pct": 70, "fam": "RadarLock", "coll": "lenses", "lenses": [{"n": "RadarLock Pitch", "h": "walleva-replacement-lenses-for-oakley-radarlock-pitch"}, {"n": "RadarLock Path", "h": "walleva-replacement-lenses-for-oakley-radarlock-path"}]};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-half-jacket-2-0"]={"pct": 70, "fam": "Half Jacket 2.0 / Half Jacket 2.0 XL", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-nose-pads-for-oakley-radar"]={"pct": 70, "fam": "Radar / RadarLock / Radar EV", "coll": "lenses", "lenses": [{"n": "Radar Path (vented)", "h": "walleva-replacement-vented-lenses-for-oakley-radar-path"}, {"n": "Radar Path", "h": "walleva-replacement-lenses-for-oakley-radar-path"}, {"n": "RadarLock Pitch", "h": "walleva-replacement-lenses-for-oakley-radarlock-pitch"}, {"n": "Radar Range", "h": "walleva-replacement-lenses-for-oakley-radar-range"}, {"n": "Radar Pitch", "h": "walleva-replacement-lenses-for-oakley-radar-pitch"}, {"n": "RadarLock Path", "h": "walleva-replacement-lenses-for-oakley-radarlock-path"}, {"n": "Radar Edge", "h": "walleva-replacement-lenses-for-oakley-radar-edge"}, {"n": "Radar EV Path", "h": "walleva-replacement-lenses-for-oakley-radar-ev-path"}]};
window.__WL_RUBBER_LENS["walleva-earsocks-for-oakley-radar"]={"pct": 70, "fam": "Radar", "coll": "lenses", "lenses": [{"n": "Radar Range", "h": "walleva-replacement-lenses-for-oakley-radar-range"}, {"n": "Radar Pitch", "h": "walleva-replacement-lenses-for-oakley-radar-pitch"}, {"n": "Radar Edge", "h": "walleva-replacement-lenses-for-oakley-radar-edge"}]};
window.__WL_RUBBER_LENS["walleva-earsocks-for-oakley-m-frame"]={"pct": 70, "fam": "M Frame", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-half-jacket"]={"pct": 70, "fam": "Half Jacket / Half Jacket XLJ", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-flak-jacket"]={"pct": 70, "fam": "Flak Jacket / Flak Jacket XLJ", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-earsocks-for-oakley-jawbone-split-jacket"]={"pct": 70, "fam": "Jawbone / Split Jacket / Straight Jacket II / Minute 2.0", "coll": "lenses", "lenses": []};
window.__WL_RUBBER_LENS["walleva-rubber-kit-for-oakley-x-metal-series"]={"pct": 70, "fam": "X-Metal Series", "coll": "lenses", "lenses": []};


// ██ WALLEVA CUSTOM — rubber-kit lens cross-sell (70% offer) ██
(function(){'use strict';try{
  var REG=window.__WL_RUBBER_LENS||{};
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  var cfg=REG[handle]; if(!cfg) return;
  if(!document.getElementById('wl-lo-css')){
    var st=document.createElement('style'); st.id='wl-lo-css';
    st.textContent='.wl-lo{margin:14px 0;padding:12px 14px;border:1px solid #f0c200;background:#fffaf0;border-radius:8px;font-size:14px;line-height:1.55}.wl-lo__t{font-weight:700;margin-bottom:4px}.wl-lo a{color:#8a4b00;text-decoration:underline}';
    document.head.appendChild(st);
  }
  var body;
  if(cfg.lenses&&cfg.lenses.length){
    var links=cfg.lenses.map(function(o){return '<a href="/products/'+o.h+'">'+o.n+'</a>';}).join(' &middot; ');
    body='Add a matching pair of Walleva lenses for your '+cfg.fam+' and this rubber kit is <strong>'+cfg.pct+'% off</strong> at checkout.<br>Shop matching lenses: '+links;
  } else {
    body='Add any pair of <a href="/collections/'+cfg.coll+'">Walleva Replacement Lenses</a> to your order and this rubber kit is <strong>'+cfg.pct+'% off</strong> at checkout.';
  }
  function init(c){ if(c.querySelector('.wl-lo')) return;
    var anchor=c.querySelector('.wl-kf');
    if(!anchor){ var picker=c.querySelector('.variant-input-wrap[data-index="option1"]'); anchor=picker?(picker.closest('.product-block')||picker):null; }
    if(!anchor){ var p=c.querySelector('.payment-buttons,.product__price,.price'); anchor=p?(p.closest('.product-block')||p):null; }
    if(!anchor) return;
    var box=document.createElement('div'); box.className='wl-lo';
    box.innerHTML='<div class="wl-lo__t">💡 Save '+cfg.pct+'% on this rubber kit</div><div>'+body+'</div>';
    anchor.insertAdjacentElement('afterend', box);
  }
  function go(){ document.querySelectorAll('[data-section-type="product"]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();







// ██ WALLEVA CUSTOM — color-driven variant availability — 2026-05-23 ██
// Colors (option1) are ALWAYS selectable; Materials (option2) show availability for the chosen color
// (struck when that color isn't made in that material). Overrides the theme's bidirectional disabling,
// so there are no dead-ends (e.g. from Yellow/NP you can still click Brown -> then Polarized = WL019-BR).
(function(){'use strict';try{
  function initSection(c){
    var colorWrap=c.querySelector('.variant-input-wrap[data-index="option1"]');
    var matWrap=c.querySelector('.variant-input-wrap[data-index="option2"]');
    if(!colorWrap||!matWrap) return; if(c.__wlColorDriven) return; c.__wlColorDriven=true;
    var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      var ok={}; p.variants.forEach(function(v){ ok[v.option1+'|||'+v.option2]=true; });
      function curColor(){ var i=colorWrap.querySelector('input[data-variant-input]:checked'); return i?i.value:null; }
      function setDisabled(wrap, isDis){
        wrap.querySelectorAll('input[data-variant-input]').forEach(function(i){
          var vi=i.closest('.variant-input'); var lbl=wrap.querySelector('label[for="'+i.id+'"]');
          var d=isDis(i.value);
          [vi,lbl].forEach(function(el){ if(!el) return; if(d) el.classList.add('disabled'); else el.classList.remove('disabled'); });
        });
      }
      var obs=null, target=colorWrap.parentNode||c;
      function apply(){
        if(obs) obs.disconnect();
        setDisabled(colorWrap, function(){ return false; });           // colors: always enabled
        var col=curColor();
        setDisabled(matWrap, function(mat){ return col ? !ok[col+'|||'+mat] : false; }); // materials: per color
        if(obs) obs.observe(target, {subtree:true, attributes:true, attributeFilter:['class']});
      }
      obs=new MutationObserver(function(){ apply(); });
      c.querySelectorAll('.variant-input-wrap input[data-variant-input]').forEach(function(i){ i.addEventListener('change', function(){ setTimeout(apply,0); }); });
      apply();
    }).catch(function(){});
  }
  function go(){ document.querySelectorAll('[data-section-type="product"]').forEach(initSection); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();


// ██ WALLEVA CUSTOM — rubber-kit add-on registry ██
window.__WL_RK_ADDON=window.__WL_RK_ADDON||{};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-sutro-lite"]={"pctOff":70,"kitHandle":"walleva-nose-pads-for-oakley-sutro","colors":[{"n":"Black","h":"#1c1c1c","v":52093391765806}],"vmap":{"Black|":52093391765806},"kind":"Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-sutro-low-bridge-fit"]={"pctOff":70,"kitHandle":"walleva-nose-pads-for-oakley-sutro","colors":[{"n":"Black","h":"#1c1c1c","v":52093391765806}],"vmap":{"Black|":52093391765806},"kind":"Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-sutro-s"]={"pctOff":70,"kitHandle":"walleva-nose-pads-for-oakley-sutro","colors":[{"n":"Black","h":"#1c1c1c","v":52093391765806}],"vmap":{"Black|":52093391765806},"kind":"Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-targetline"]={"pctOff": 70, "kitHandle": "walleva-nose-pads-for-oakley-targetline-crossrange", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391831342}], "vmap": {"Black|": 52093391831342}, "kind": "Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-crossrange"]={"pctOff": 70, "kitHandle": "walleva-nose-pads-for-oakley-targetline-crossrange", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391831342}], "vmap": {"Black|": 52093391831342}, "kind": "Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-sutro"]={"pctOff":70,"kitHandle":"walleva-nose-pads-for-oakley-sutro","colors":[{"n":"Black","h":"#1c1c1c","v":52093391765806}],"vmap":{"Black|":52093391765806},"kind":"Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radar-ev-path"]={"pctOff": 70, "kitHandle": "walleva-nose-pads-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52099362488622}, {"n": "Grey", "h": "#8b8e91", "v": 52099362521390}], "vmap": {"Black|": 52099362488622, "Grey|": 52099362521390}, "kind": "Nose Pad"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radarlock-pitch"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radarlock", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093396123950}, {"n": "Blue", "h": "#1f47d6", "v": 52093396222254}, {"n": "Brown", "h": "#6b4a2b", "v": 52093396320558}, {"n": "Red", "h": "#d11f1f", "v": 52093396418862}, {"n": "Green", "h": "#1f8a3b", "v": 52093396517166}, {"n": "Grey", "h": "#8b8e91", "v": 52093396615470}, {"n": "Purple", "h": "#6a2cc0", "v": 52093396713774}, {"n": "White", "h": "#f3f3f3", "v": 52093396812078}, {"n": "Yellow", "h": "#f0c200", "v": 52093396910382}, {"n": "None", "h": "none", "v": 52098541650222}], "vmap": {"Black|None": 52093396123950, "Black|Black": 52093396156718, "Black|Grey": 52093396189486, "Blue|None": 52093396222254, "Blue|Black": 52093396255022, "Blue|Grey": 52093396287790, "Brown|None": 52093396320558, "Brown|Black": 52093396353326, "Brown|Grey": 52093396386094, "Red|None": 52093396418862, "Red|Black": 52093396451630, "Red|Grey": 52093396484398, "Green|None": 52093396517166, "Green|Black": 52093396549934, "Green|Grey": 52093396582702, "Grey|None": 52093396615470, "Grey|Black": 52093396648238, "Grey|Grey": 52093396681006, "Purple|None": 52093396713774, "Purple|Black": 52093396746542, "Purple|Grey": 52093396779310, "White|None": 52093396812078, "White|Black": 52093396844846, "White|Grey": 52093396877614, "Yellow|None": 52093396910382, "Yellow|Black": 52093396943150, "Yellow|Grey": 52093396975918, "None|Black": 52098541650222, "None|Grey": 52098541682990}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radarlock-path"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radarlock", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093396123950}, {"n": "Blue", "h": "#1f47d6", "v": 52093396222254}, {"n": "Brown", "h": "#6b4a2b", "v": 52093396320558}, {"n": "Red", "h": "#d11f1f", "v": 52093396418862}, {"n": "Green", "h": "#1f8a3b", "v": 52093396517166}, {"n": "Grey", "h": "#8b8e91", "v": 52093396615470}, {"n": "Purple", "h": "#6a2cc0", "v": 52093396713774}, {"n": "White", "h": "#f3f3f3", "v": 52093396812078}, {"n": "Yellow", "h": "#f0c200", "v": 52093396910382}, {"n": "None", "h": "none", "v": 52098541650222}], "vmap": {"Black|None": 52093396123950, "Black|Black": 52093396156718, "Black|Grey": 52093396189486, "Blue|None": 52093396222254, "Blue|Black": 52093396255022, "Blue|Grey": 52093396287790, "Brown|None": 52093396320558, "Brown|Black": 52093396353326, "Brown|Grey": 52093396386094, "Red|None": 52093396418862, "Red|Black": 52093396451630, "Red|Grey": 52093396484398, "Green|None": 52093396517166, "Green|Black": 52093396549934, "Green|Grey": 52093396582702, "Grey|None": 52093396615470, "Grey|Black": 52093396648238, "Grey|Grey": 52093396681006, "Purple|None": 52093396713774, "Purple|Black": 52093396746542, "Purple|Grey": 52093396779310, "White|None": 52093396812078, "White|Black": 52093396844846, "White|Grey": 52093396877614, "Yellow|None": 52093396910382, "Yellow|Black": 52093396943150, "Yellow|Grey": 52093396975918, "None|Black": 52098541650222, "None|Grey": 52098541682990}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radar-edge"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093393338670}, {"n": "Blue", "h": "#1f47d6", "v": 52093393436974}, {"n": "Brown", "h": "#6b4a2b", "v": 52093393535278}, {"n": "Red", "h": "#d11f1f", "v": 52093393633582}, {"n": "Green", "h": "#1f8a3b", "v": 52093393731886}, {"n": "Grey", "h": "#8b8e91", "v": 52093393830190}, {"n": "Purple", "h": "#6a2cc0", "v": 52093393928494}, {"n": "White", "h": "#f3f3f3", "v": 52093394026798}, {"n": "Yellow", "h": "#f0c200", "v": 52093394125102}, {"n": "None", "h": "none", "v": 52096873201966}], "vmap": {"Black|None": 52093393338670, "Black|Black": 52093393371438, "Black|Grey": 52093393404206, "Blue|None": 52093393436974, "Blue|Black": 52093393469742, "Blue|Grey": 52093393502510, "Brown|None": 52093393535278, "Brown|Black": 52093393568046, "Brown|Grey": 52093393600814, "Red|None": 52093393633582, "Red|Black": 52093393666350, "Red|Grey": 52093393699118, "Green|None": 52093393731886, "Green|Black": 52093393764654, "Green|Grey": 52093393797422, "Grey|None": 52093393830190, "Grey|Black": 52093393862958, "Grey|Grey": 52093393895726, "Purple|None": 52093393928494, "Purple|Black": 52093393961262, "Purple|Grey": 52093393994030, "White|None": 52093394026798, "White|Black": 52093394059566, "White|Grey": 52093394092334, "Yellow|None": 52093394125102, "Yellow|Black": 52093394157870, "Yellow|Grey": 52093394190638, "None|Black": 52096873201966, "None|Grey": 52096873234734}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radar-pitch"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093393338670}, {"n": "Blue", "h": "#1f47d6", "v": 52093393436974}, {"n": "Brown", "h": "#6b4a2b", "v": 52093393535278}, {"n": "Red", "h": "#d11f1f", "v": 52093393633582}, {"n": "Green", "h": "#1f8a3b", "v": 52093393731886}, {"n": "Grey", "h": "#8b8e91", "v": 52093393830190}, {"n": "Purple", "h": "#6a2cc0", "v": 52093393928494}, {"n": "White", "h": "#f3f3f3", "v": 52093394026798}, {"n": "Yellow", "h": "#f0c200", "v": 52093394125102}, {"n": "None", "h": "none", "v": 52096873201966}], "vmap": {"Black|None": 52093393338670, "Black|Black": 52093393371438, "Black|Grey": 52093393404206, "Blue|None": 52093393436974, "Blue|Black": 52093393469742, "Blue|Grey": 52093393502510, "Brown|None": 52093393535278, "Brown|Black": 52093393568046, "Brown|Grey": 52093393600814, "Red|None": 52093393633582, "Red|Black": 52093393666350, "Red|Grey": 52093393699118, "Green|None": 52093393731886, "Green|Black": 52093393764654, "Green|Grey": 52093393797422, "Grey|None": 52093393830190, "Grey|Black": 52093393862958, "Grey|Grey": 52093393895726, "Purple|None": 52093393928494, "Purple|Black": 52093393961262, "Purple|Grey": 52093393994030, "White|None": 52093394026798, "White|Black": 52093394059566, "White|Grey": 52093394092334, "Yellow|None": 52093394125102, "Yellow|Black": 52093394157870, "Yellow|Grey": 52093394190638, "None|Black": 52096873201966, "None|Grey": 52096873234734}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radar-range"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093393338670}, {"n": "Blue", "h": "#1f47d6", "v": 52093393436974}, {"n": "Brown", "h": "#6b4a2b", "v": 52093393535278}, {"n": "Red", "h": "#d11f1f", "v": 52093393633582}, {"n": "Green", "h": "#1f8a3b", "v": 52093393731886}, {"n": "Grey", "h": "#8b8e91", "v": 52093393830190}, {"n": "Purple", "h": "#6a2cc0", "v": 52093393928494}, {"n": "White", "h": "#f3f3f3", "v": 52093394026798}, {"n": "Yellow", "h": "#f0c200", "v": 52093394125102}, {"n": "None", "h": "none", "v": 52096873201966}], "vmap": {"Black|None": 52093393338670, "Black|Black": 52093393371438, "Black|Grey": 52093393404206, "Blue|None": 52093393436974, "Blue|Black": 52093393469742, "Blue|Grey": 52093393502510, "Brown|None": 52093393535278, "Brown|Black": 52093393568046, "Brown|Grey": 52093393600814, "Red|None": 52093393633582, "Red|Black": 52093393666350, "Red|Grey": 52093393699118, "Green|None": 52093393731886, "Green|Black": 52093393764654, "Green|Grey": 52093393797422, "Grey|None": 52093393830190, "Grey|Black": 52093393862958, "Grey|Grey": 52093393895726, "Purple|None": 52093393928494, "Purple|Black": 52093393961262, "Purple|Grey": 52093393994030, "White|None": 52093394026798, "White|Black": 52093394059566, "White|Grey": 52093394092334, "Yellow|None": 52093394125102, "Yellow|Black": 52093394157870, "Yellow|Grey": 52093394190638, "None|Black": 52096873201966, "None|Grey": 52096873234734}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-flak-2-0-xl"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-flak-2-0", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389209902}, {"n": "Blue", "h": "#1f47d6", "v": 52093389242670}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389275438}, {"n": "Red", "h": "#d11f1f", "v": 52093389308206}, {"n": "Green", "h": "#1f8a3b", "v": 52093389340974}, {"n": "Grey", "h": "#8b8e91", "v": 52093389373742}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389406510}, {"n": "White", "h": "#f3f3f3", "v": 52093389439278}, {"n": "Yellow", "h": "#f0c200", "v": 52093389472046}, {"n": "Fluorescent Green", "h": "#00c850", "v": 52093389504814}], "vmap": {"Black|": 52093389209902, "Blue|": 52093389242670, "Brown|": 52093389275438, "Red|": 52093389308206, "Green|": 52093389340974, "Grey|": 52093389373742, "Purple|": 52093389406510, "White|": 52093389439278, "Yellow|": 52093389472046, "Fluorescent Green|": 52093389504814}, "contents": "earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-flak-2-0"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-flak-2-0", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389209902}, {"n": "Blue", "h": "#1f47d6", "v": 52093389242670}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389275438}, {"n": "Red", "h": "#d11f1f", "v": 52093389308206}, {"n": "Green", "h": "#1f8a3b", "v": 52093389340974}, {"n": "Grey", "h": "#8b8e91", "v": 52093389373742}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389406510}, {"n": "White", "h": "#f3f3f3", "v": 52093389439278}, {"n": "Yellow", "h": "#f0c200", "v": 52093389472046}, {"n": "Fluorescent Green", "h": "#00c850", "v": 52093389504814}], "vmap": {"Black|": 52093389209902, "Blue|": 52093389242670, "Brown|": 52093389275438, "Red|": 52093389308206, "Green|": 52093389340974, "Grey|": 52093389373742, "Purple|": 52093389406510, "White|": 52093389439278, "Yellow|": 52093389472046, "Fluorescent Green|": 52093389504814}, "contents": "earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m2"]=[{"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m2", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389832494}, {"n": "Blue", "h": "#1f47d6", "v": 52093389865262}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389898030}, {"n": "Red", "h": "#d11f1f", "v": 52093389930798}, {"n": "Green", "h": "#1f8a3b", "v": 52093389963566}, {"n": "Grey", "h": "#8b8e91", "v": 52093389996334}, {"n": "Purple", "h": "#6a2cc0", "v": 52093390029102}, {"n": "White", "h": "#f3f3f3", "v": 52093390061870}, {"n": "Yellow", "h": "#f0c200", "v": 52093390094638}, {"n": "Fluorescent Green", "h": "#00c850", "v": 52093390127406}], "vmap": {"Black|": 52093389832494, "Blue|": 52093389865262, "Brown|": 52093389898030, "Red|": 52093389930798, "Green|": 52093389963566, "Grey|": 52093389996334, "Purple|": 52093390029102, "White|": 52093390061870, "Yellow|": 52093390094638, "Fluorescent Green|": 52093390127406}, "kind": "Earsocks"}, {"pctOff": 70, "kitHandle": "walleva-nose-pads-for-oakley-m2", "kind": "Nose Pad", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391798574}], "vmap": {"Black|": 52093391798574}}];
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m2-xl"]=[{"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m2", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389832494}, {"n": "Blue", "h": "#1f47d6", "v": 52093389865262}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389898030}, {"n": "Red", "h": "#d11f1f", "v": 52093389930798}, {"n": "Green", "h": "#1f8a3b", "v": 52093389963566}, {"n": "Grey", "h": "#8b8e91", "v": 52093389996334}, {"n": "Purple", "h": "#6a2cc0", "v": 52093390029102}, {"n": "White", "h": "#f3f3f3", "v": 52093390061870}, {"n": "Yellow", "h": "#f0c200", "v": 52093390094638}, {"n": "Fluorescent Green", "h": "#00c850", "v": 52093390127406}], "vmap": {"Black|": 52093389832494, "Blue|": 52093389865262, "Brown|": 52093389898030, "Red|": 52093389930798, "Green|": 52093389963566, "Grey|": 52093389996334, "Purple|": 52093390029102, "White|": 52093390061870, "Yellow|": 52093390094638, "Fluorescent Green|": 52093390127406}, "kind": "Earsocks"}, {"pctOff": 70, "kitHandle": "walleva-nose-pads-for-oakley-m2", "kind": "Nose Pad", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391798574}], "vmap": {"Black|": 52093391798574}}];
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-half-jacket-2-0"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-half-jacket-2-0", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093382656302}, {"n": "Blue", "h": "#1f47d6", "v": 52093382689070}, {"n": "Brown", "h": "#6b4a2b", "v": 52093382721838}, {"n": "Red", "h": "#d11f1f", "v": 52093382754606}, {"n": "Green", "h": "#1f8a3b", "v": 52093382787374}, {"n": "Grey", "h": "#8b8e91", "v": 52093382820142}, {"n": "Purple", "h": "#6a2cc0", "v": 52093382852910}, {"n": "White", "h": "#f3f3f3", "v": 52093382885678}, {"n": "Yellow", "h": "#f0c200", "v": 52093382918446}], "vmap": {"Black|": 52093382656302, "Blue|": 52093382689070, "Brown|": 52093382721838, "Red|": 52093382754606, "Green|": 52093382787374, "Grey|": 52093382820142, "Purple|": 52093382852910, "White|": 52093382885678, "Yellow|": 52093382918446}, "contents": "earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-half-jacket-2-0-xl"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-half-jacket-2-0", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093382656302}, {"n": "Blue", "h": "#1f47d6", "v": 52093382689070}, {"n": "Brown", "h": "#6b4a2b", "v": 52093382721838}, {"n": "Red", "h": "#d11f1f", "v": 52093382754606}, {"n": "Green", "h": "#1f8a3b", "v": 52093382787374}, {"n": "Grey", "h": "#8b8e91", "v": 52093382820142}, {"n": "Purple", "h": "#6a2cc0", "v": 52093382852910}, {"n": "White", "h": "#f3f3f3", "v": 52093382885678}, {"n": "Yellow", "h": "#f0c200", "v": 52093382918446}], "vmap": {"Black|": 52093382656302, "Blue|": 52093382689070, "Brown|": 52093382721838, "Red|": 52093382754606, "Green|": 52093382787374, "Grey|": 52093382820142, "Purple|": 52093382852910, "White|": 52093382885678, "Yellow|": 52093382918446}, "contents": "earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-sweep"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-sweep-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-heater"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-strike-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-hybrid"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-heater-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-strike"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-m-frame-hybrid-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-m-frame", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093391995182}, {"n": "Blue", "h": "#1f47d6", "v": 52093392093486}, {"n": "Brown", "h": "#6b4a2b", "v": 52093392191790}, {"n": "Red", "h": "#d11f1f", "v": 52093392290094}, {"n": "Green", "h": "#1f8a3b", "v": 52093392388398}, {"n": "Grey", "h": "#8b8e91", "v": 52093392486702}, {"n": "Purple", "h": "#6a2cc0", "v": 52093392585006}, {"n": "White", "h": "#f3f3f3", "v": 52093392683310}, {"n": "Yellow", "h": "#f0c200", "v": 52093392781614}, {"n": "None", "h": "none", "v": 52096873136430}], "vmap": {"Black|None": 52093391995182, "Black|Black": 52093392027950, "Black|Grey": 52093392060718, "Blue|None": 52093392093486, "Blue|Black": 52093392126254, "Blue|Grey": 52093392159022, "Brown|None": 52093392191790, "Brown|Black": 52093392224558, "Brown|Grey": 52093392257326, "Red|None": 52093392290094, "Red|Black": 52093392322862, "Red|Grey": 52093392355630, "Green|None": 52093392388398, "Green|Black": 52093392421166, "Green|Grey": 52093392453934, "Grey|None": 52093392486702, "Grey|Black": 52093392519470, "Grey|Grey": 52093392552238, "Purple|None": 52093392585006, "Purple|Black": 52093392617774, "Purple|Grey": 52093392650542, "White|None": 52093392683310, "White|Black": 52093392716078, "White|Grey": 52093392748846, "Yellow|None": 52093392781614, "Yellow|Black": 52093392814382, "Yellow|Grey": 52093392847150, "None|Black": 52096873136430, "None|Grey": 52096873169198}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-radar-path"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093393338670}, {"n": "Blue", "h": "#1f47d6", "v": 52093393436974}, {"n": "Brown", "h": "#6b4a2b", "v": 52093393535278}, {"n": "Red", "h": "#d11f1f", "v": 52093393633582}, {"n": "Green", "h": "#1f8a3b", "v": 52093393731886}, {"n": "Grey", "h": "#8b8e91", "v": 52093393830190}, {"n": "Purple", "h": "#6a2cc0", "v": 52093393928494}, {"n": "White", "h": "#f3f3f3", "v": 52093394026798}, {"n": "Yellow", "h": "#f0c200", "v": 52093394125102}, {"n": "None", "h": "none", "v": 52096873201966}], "vmap": {"Black|None": 52093393338670, "Black|Black": 52093393371438, "Black|Grey": 52093393404206, "Blue|None": 52093393436974, "Blue|Black": 52093393469742, "Blue|Grey": 52093393502510, "Brown|None": 52093393535278, "Brown|Black": 52093393568046, "Brown|Grey": 52093393600814, "Red|None": 52093393633582, "Red|Black": 52093393666350, "Red|Grey": 52093393699118, "Green|None": 52093393731886, "Green|Black": 52093393764654, "Green|Grey": 52093393797422, "Grey|None": 52093393830190, "Grey|Black": 52093393862958, "Grey|Grey": 52093393895726, "Purple|None": 52093393928494, "Purple|Black": 52093393961262, "Purple|Grey": 52093393994030, "White|None": 52093394026798, "White|Black": 52093394059566, "White|Grey": 52093394092334, "Yellow|None": 52093394125102, "Yellow|Black": 52093394157870, "Yellow|Grey": 52093394190638, "None|Black": 52096873201966, "None|Grey": 52096873234734}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-vented-lenses-for-oakley-radar-path"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-radar", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093393338670}, {"n": "Blue", "h": "#1f47d6", "v": 52093393436974}, {"n": "Brown", "h": "#6b4a2b", "v": 52093393535278}, {"n": "Red", "h": "#d11f1f", "v": 52093393633582}, {"n": "Green", "h": "#1f8a3b", "v": 52093393731886}, {"n": "Grey", "h": "#8b8e91", "v": 52093393830190}, {"n": "Purple", "h": "#6a2cc0", "v": 52093393928494}, {"n": "White", "h": "#f3f3f3", "v": 52093394026798}, {"n": "Yellow", "h": "#f0c200", "v": 52093394125102}, {"n": "None", "h": "none", "v": 52096873201966}], "vmap": {"Black|None": 52093393338670, "Black|Black": 52093393371438, "Black|Grey": 52093393404206, "Blue|None": 52093393436974, "Blue|Black": 52093393469742, "Blue|Grey": 52093393502510, "Brown|None": 52093393535278, "Brown|Black": 52093393568046, "Brown|Grey": 52093393600814, "Red|None": 52093393633582, "Red|Black": 52093393666350, "Red|Grey": 52093393699118, "Green|None": 52093393731886, "Green|Black": 52093393764654, "Green|Grey": 52093393797422, "Grey|None": 52093393830190, "Grey|Black": 52093393862958, "Grey|Grey": 52093393895726, "Purple|None": 52093393928494, "Purple|Black": 52093393961262, "Purple|Grey": 52093393994030, "White|None": 52093394026798, "White|Black": 52093394059566, "White|Grey": 52093394092334, "Yellow|None": 52093394125102, "Yellow|Black": 52093394157870, "Yellow|Grey": 52093394190638, "None|Black": 52096873201966, "None|Grey": 52096873234734}, "opt2": {"name": "Nose Pad", "values": [{"n": "None", "h": "none"}, {"n": "Black", "h": "#1c1c1c"}, {"n": "Grey", "h": "#8b8e91"}]}};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-juliet-vented"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-juliet"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-x-metal-xx"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-x-squared"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-mars"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-penny"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-x-metal-series", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381706030}, {"n": "Blue", "h": "#1f47d6", "v": 52093381738798}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381771566}, {"n": "Red", "h": "#d11f1f", "v": 52093381804334}, {"n": "Green", "h": "#1f8a3b", "v": 52093381837102}, {"n": "Grey", "h": "#8b8e91", "v": 52093381869870}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381902638}, {"n": "White", "h": "#f3f3f3", "v": 52093381935406}, {"n": "Yellow", "h": "#f0c200", "v": 52093381968174}], "vmap": {"Black|": 52093381706030, "Blue|": 52093381738798, "Brown|": 52093381771566, "Red|": 52093381804334, "Green|": 52093381837102, "Grey|": 52093381869870, "Purple|": 52093381902638, "White|": 52093381935406, "Yellow|": 52093381968174}, "contents": "earsocks + temple socks, 2 sizes"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-racing-jacket"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-jawbone"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-split-jacket"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-racing-jacket-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-jawbone-vented"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-vented-lenses-for-oakley-split-jacket"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-minute-2-0"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-straight-jacket"]={"pctOff": 70, "kitHandle": "walleva-earsocks-for-oakley-jawbone-split-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093389537582}, {"n": "Blue", "h": "#1f47d6", "v": 52093389570350}, {"n": "Brown", "h": "#6b4a2b", "v": 52093389603118}, {"n": "Red", "h": "#d11f1f", "v": 52093389635886}, {"n": "Green", "h": "#1f8a3b", "v": 52093389668654}, {"n": "Grey", "h": "#8b8e91", "v": 52093389701422}, {"n": "Purple", "h": "#6a2cc0", "v": 52093389734190}, {"n": "White", "h": "#f3f3f3", "v": 52093389766958}, {"n": "Yellow", "h": "#f0c200", "v": 52093389799726}], "vmap": {"Black|": 52093389537582, "Blue|": 52093389570350, "Brown|": 52093389603118, "Red|": 52093389635886, "Green|": 52093389668654, "Grey|": 52093389701422, "Purple|": 52093389734190, "White|": 52093389766958, "Yellow|": 52093389799726}, "kind": "Earsocks"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-half-jacket-xlj-vented"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-half-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093382263086}, {"n": "Blue", "h": "#1f47d6", "v": 52093382295854}, {"n": "Brown", "h": "#6b4a2b", "v": 52093382328622}, {"n": "Red", "h": "#d11f1f", "v": 52093382361390}, {"n": "Green", "h": "#1f8a3b", "v": 52093382394158}, {"n": "Grey", "h": "#8b8e91", "v": 52093382426926}, {"n": "Purple", "h": "#6a2cc0", "v": 52093382459694}, {"n": "White", "h": "#f3f3f3", "v": 52093382492462}, {"n": "Yellow", "h": "#f0c200", "v": 52093382525230}], "vmap": {"Black|": 52093382263086, "Blue|": 52093382295854, "Brown|": 52093382328622, "Red|": 52093382361390, "Green|": 52093382394158, "Grey|": 52093382426926, "Purple|": 52093382459694, "White|": 52093382492462, "Yellow|": 52093382525230}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-half-jacket"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-half-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093382263086}, {"n": "Blue", "h": "#1f47d6", "v": 52093382295854}, {"n": "Brown", "h": "#6b4a2b", "v": 52093382328622}, {"n": "Red", "h": "#d11f1f", "v": 52093382361390}, {"n": "Green", "h": "#1f8a3b", "v": 52093382394158}, {"n": "Grey", "h": "#8b8e91", "v": 52093382426926}, {"n": "Purple", "h": "#6a2cc0", "v": 52093382459694}, {"n": "White", "h": "#f3f3f3", "v": 52093382492462}, {"n": "Yellow", "h": "#f0c200", "v": 52093382525230}], "vmap": {"Black|": 52093382263086, "Blue|": 52093382295854, "Brown|": 52093382328622, "Red|": 52093382361390, "Green|": 52093382394158, "Grey|": 52093382426926, "Purple|": 52093382459694, "White|": 52093382492462, "Yellow|": 52093382525230}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-half-jacket-xlj"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-half-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093382263086}, {"n": "Blue", "h": "#1f47d6", "v": 52093382295854}, {"n": "Brown", "h": "#6b4a2b", "v": 52093382328622}, {"n": "Red", "h": "#d11f1f", "v": 52093382361390}, {"n": "Green", "h": "#1f8a3b", "v": 52093382394158}, {"n": "Grey", "h": "#8b8e91", "v": 52093382426926}, {"n": "Purple", "h": "#6a2cc0", "v": 52093382459694}, {"n": "White", "h": "#f3f3f3", "v": 52093382492462}, {"n": "Yellow", "h": "#f0c200", "v": 52093382525230}], "vmap": {"Black|": 52093382263086, "Blue|": 52093382295854, "Brown|": 52093382328622, "Red|": 52093382361390, "Green|": 52093382394158, "Grey|": 52093382426926, "Purple|": 52093382459694, "White|": 52093382492462, "Yellow|": 52093382525230}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-flak-jacket-xlj-vented"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-flak-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381050670}, {"n": "Blue", "h": "#1f47d6", "v": 52093381083438}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381116206}, {"n": "Red", "h": "#d11f1f", "v": 52093381148974}, {"n": "Green", "h": "#1f8a3b", "v": 52093381181742}, {"n": "Grey", "h": "#8b8e91", "v": 52093381214510}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381247278}, {"n": "White", "h": "#f3f3f3", "v": 52093381280046}, {"n": "Yellow", "h": "#f0c200", "v": 52093381312814}], "vmap": {"Black|": 52093381050670, "Blue|": 52093381083438, "Brown|": 52093381116206, "Red|": 52093381148974, "Green|": 52093381181742, "Grey|": 52093381214510, "Purple|": 52093381247278, "White|": 52093381280046, "Yellow|": 52093381312814}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-flak-jacket-xlj"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-flak-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381050670}, {"n": "Blue", "h": "#1f47d6", "v": 52093381083438}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381116206}, {"n": "Red", "h": "#d11f1f", "v": 52093381148974}, {"n": "Green", "h": "#1f8a3b", "v": 52093381181742}, {"n": "Grey", "h": "#8b8e91", "v": 52093381214510}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381247278}, {"n": "White", "h": "#f3f3f3", "v": 52093381280046}, {"n": "Yellow", "h": "#f0c200", "v": 52093381312814}], "vmap": {"Black|": 52093381050670, "Blue|": 52093381083438, "Brown|": 52093381116206, "Red|": 52093381148974, "Green|": 52093381181742, "Grey|": 52093381214510, "Purple|": 52093381247278, "White|": 52093381280046, "Yellow|": 52093381312814}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-flak-jacket"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-flak-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52093381050670}, {"n": "Blue", "h": "#1f47d6", "v": 52093381083438}, {"n": "Brown", "h": "#6b4a2b", "v": 52093381116206}, {"n": "Red", "h": "#d11f1f", "v": 52093381148974}, {"n": "Green", "h": "#1f8a3b", "v": 52093381181742}, {"n": "Grey", "h": "#8b8e91", "v": 52093381214510}, {"n": "Purple", "h": "#6a2cc0", "v": 52093381247278}, {"n": "White", "h": "#f3f3f3", "v": 52093381280046}, {"n": "Yellow", "h": "#f0c200", "v": 52093381312814}], "vmap": {"Black|": 52093381050670, "Blue|": 52093381083438, "Brown|": 52093381116206, "Red|": 52093381148974, "Green|": 52093381181742, "Grey|": 52093381214510, "Purple|": 52093381247278, "White|": 52093381280046, "Yellow|": 52093381312814}, "contents": "upper & lower earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-fast-jacket"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-fast-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52092218999086}, {"n": "Blue", "h": "#1f47d6", "v": 52092219031854}, {"n": "Brown", "h": "#6b4a2b", "v": 52092219064622}, {"n": "Red", "h": "#d11f1f", "v": 52092219097390}, {"n": "Green", "h": "#1f8a3b", "v": 52092219130158}, {"n": "Grey", "h": "#8b8e91", "v": 52092219162926}, {"n": "Purple", "h": "#6a2cc0", "v": 52092219195694}, {"n": "White", "h": "#f3f3f3", "v": 52092219228462}, {"n": "Yellow", "h": "#f0c200", "v": 52092219261230}], "vmap": {"Black|": 52092218999086, "Blue|": 52092219031854, "Brown|": 52092219064622, "Red|": 52092219097390, "Green|": 52092219130158, "Grey|": 52092219162926, "Purple|": 52092219195694, "White|": 52092219228462, "Yellow|": 52092219261230}, "contents": "earsocks + nose pads"};
window.__WL_RK_ADDON["walleva-replacement-lenses-for-oakley-fast-jacket-xl"]={"pctOff": 70, "kitHandle": "walleva-rubber-kit-for-oakley-fast-jacket", "colors": [{"n": "Black", "h": "#1c1c1c", "v": 52092218999086}, {"n": "Blue", "h": "#1f47d6", "v": 52092219031854}, {"n": "Brown", "h": "#6b4a2b", "v": 52092219064622}, {"n": "Red", "h": "#d11f1f", "v": 52092219097390}, {"n": "Green", "h": "#1f8a3b", "v": 52092219130158}, {"n": "Grey", "h": "#8b8e91", "v": 52092219162926}, {"n": "Purple", "h": "#6a2cc0", "v": 52092219195694}, {"n": "White", "h": "#f3f3f3", "v": 52092219228462}, {"n": "Yellow", "h": "#f0c200", "v": 52092219261230}], "vmap": {"Black|": 52092218999086, "Blue|": 52092219031854, "Brown|": 52092219064622, "Red|": 52092219097390, "Green|": 52092219130158, "Grey|": 52092219162926, "Purple|": 52092219195694, "White|": 52092219228462, "Yellow|": 52092219261230}, "contents": "earsocks + nose pads"};
























































































































































































































































// ██ WALLEVA — variant media sync (2-option kits) ██
(function(){"use strict";try{
  var handle=(location.pathname.split("/products/")[1]||"").split("/")[0].split("?")[0];
  if(!/(earsocks|rubber-kit|nose-pad)/.test(handle)) return;
  var data=null;
  function fl(){ try{ return Flickity.data(document.querySelector(".product-slideshow")); }catch(e){ return null; } }
  function curVariant(){
    if(!data) return null;
    var opts=[];
    document.querySelectorAll('[data-section-type="product"] .variant-input-wrap,[data-section-type="product"] .product-form__input').forEach(function(fs){
      var c=fs.querySelector("input:checked")||fs.querySelector("select");
      if(c) opts.push(c.value);
    });
    if(!opts.length) return null;
    return (data.variants||[]).find(function(v){ return v.options.join("~~")===opts.join("~~"); });
  }
  function sync(){
    var v=curVariant(); if(!v||!v.featured_media) return;
    var f=fl(); if(!f||!f.cells) return;
    var mid=String(v.featured_media.id);
    for(var i=0;i<f.cells.length;i++){
      if(f.cells[i].element.getAttribute("data-media-id")===mid){ if(f.selectedIndex!==i) f.select(i,false,true); return; }
    }
  }
  function hook(){
    document.addEventListener("change",function(e){ if(e.target&&(e.target.type==="radio"||e.target.tagName==="SELECT")) setTimeout(sync,80); },true);
    document.addEventListener("click",function(e){ if(e.target&&e.target.closest&&e.target.closest(".variant-input-wrap,.product-form__input")) setTimeout(sync,140); },true);
    setTimeout(sync,500);
  }
  fetch("/products/"+handle+".js").then(function(r){return r.json();}).then(function(p){ data=p; hook(); }).catch(function(){});
}catch(e){}})();


// ██ WALLEVA CUSTOM — fit warning near buy button ██
(function(){'use strict';try{
  if(!document.getElementById('wl-fw-css')){
    var st=document.createElement('style'); st.id='wl-fw-css';
    st.textContent='.wl-fw{margin:14px 0;padding:11px 14px;border:1px solid #e0a800;background:#fff8e6;'+
      'border-radius:8px;font-size:14px;line-height:1.55;color:#5a4500}.wl-fw a{color:#0000EE;text-decoration:underline}'+
      '.wl-fw__src{display:none!important}';
    document.head.appendChild(st);
  }
  function findWarn(c){
    var ps=c.querySelectorAll('p');
    for(var i=0;i<ps.length;i++){
      if(ps[i].closest('.wl-fw')) continue;
      var t=ps[i].textContent||'';
      if(t.indexOf('⚠')>=0 && /Fits[\s\S]*only/.test(t)) return ps[i];
    }
    return null;
  }
  function init(c){ if(c.querySelector('.wl-fw')) return;
    var warn=findWarn(c); if(!warn) return;
    var buy=c.querySelector('.payment-buttons,.product-form__buttons,[data-buy-buttons]');
    var anchor=buy?(buy.closest('.product-block')||buy):null;
    if(!anchor){ var pk=c.querySelector('.variant-input-wrap[data-index="option1"]'); anchor=pk?(pk.closest('.product-block')||pk):null; }
    if(!anchor) return;
    var box=document.createElement('div'); box.className='wl-fw'; box.innerHTML=warn.innerHTML;
    anchor.insertAdjacentElement('beforebegin', box);
    warn.classList.add('wl-fw__src');
  }
  function go(){ document.querySelectorAll('[data-section-type="product"]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();











// ██ WALLEVA — nose-pad option: None swatch last (consistency w/ earsocks) ██
(function(){'use strict';try{
  function fix(){
    document.querySelectorAll('.variant-input-wrap[data-handle="nose-pads"]').forEach(function(fs){
      var lbl=fs.querySelector('.color-swatch--none'); if(!lbl) return;
      var vi=lbl.closest('.variant-input'); if(!vi) return;
      if(fs.lastElementChild!==vi){ fs.appendChild(vi); }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
  // also after any dynamic re-render
  document.addEventListener('shopify:section:load',fix);
}catch(e){}})();


// ██ WALLEVA — Fit Guide anchor link: scroll to + open the Fit Guide tab ██
(function(){'use strict';try{
  function bindFgLinks(){
    document.querySelectorAll('a.wl-fg-link:not([data-fg-bound])').forEach(function(a){
      a.setAttribute('data-fg-bound','1');
      a.addEventListener('click',function(e){
        e.preventDefault();
        // Impulse collapsible: aria-controls identifies panel, aria-expanded tracks state
        var btn=Array.from(document.querySelectorAll('button.collapsible-trigger')).find(function(b){
          return b.textContent.trim()==='Fit Guide';
        });
        if(!btn) return;
        function doScroll(){
          // Scroll to the top edge of the collapsible wrapper (the whole Fit Guide box)
          var target=btn.closest('.collapsibles-wrapper')||btn;
          var absTop=target.getBoundingClientRect().top+window.scrollY;
          // Sum height of ALL fixed/sticky elements stacked at the top of the viewport
          // (Impulse: announcement-bar fixed 38px + site-header--stuck fixed 131px = 169px when scrolled)
          var topH=0;
          ['header','.site-header','.site-header--stuck','.announcement-bar--sticky'].forEach(function(sel){
            var el=document.querySelector(sel); if(!el) return;
            var s=getComputedStyle(el);
            if(s.position!=='fixed'&&s.position!=='sticky') return;
            var r=el.getBoundingClientRect();
            if(r.top>=-5&&r.bottom>0) topH=Math.max(topH,r.bottom);
          });
          window.scrollTo({top:Math.max(0,absTop-topH-8),behavior:'smooth'});
        }
        if(btn.getAttribute('aria-expanded')==='false'){
          btn.click();
          // Fire after height transition (0.35s). transitionend fires on real clicks;
          // setTimeout(450) is the fallback if transitionend never fires.
          var _done=false;
          function _once(){ if(_done) return; _done=true; doScroll(); }
          var _panel=document.getElementById(btn.getAttribute('aria-controls'));
          if(_panel) _panel.addEventListener('transitionend',function _h(ev){
            if(ev.propertyName!=='height') return;
            _panel.removeEventListener('transitionend',_h); _once();
          });
          setTimeout(_once,450);
        } else {
          doScroll();
        }
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bindFgLinks); else bindFgLinks();
  document.addEventListener('shopify:section:load',bindFgLinks);
}catch(e){}})();


// ██ WALLEVA CUSTOM — bolt-set add-on registry ██
window.__WL_BT_ADDON=window.__WL_BT_ADDON||{};
window.__WL_BT_ADDON["walleva-replacement-lenses-for-oakley-split-jacket"]={"pctOff": 70, "boltHandle": "walleva-thru-bolt-set-for-oakley-jawbone-racing-jacket-split-jacket", "colors": [{"n": "Black", "h": "#898989"}, {"n": "Brown", "h": "#635157"}, {"n": "Chocolate", "h": "#4a2c17"}, {"n": "Fire Red", "h": "#980531"}, {"n": "Ice Blue", "h": "#142aae"}, {"n": "Titanium", "h": "#a6a5a5"}, {"n": "Green", "h": "#318671"}, {"n": "Purple", "h": "#422871"}, {"n": "Orange", "h": "#bd4d00"}, {"n": "Ruby", "h": "#9b123c"}, {"n": "Pink", "h": "#b0417d"}, {"n": "Yellow", "h": "#c0b400"}, {"n": "White", "h": "#f5f5f5"}], "vmap": {"Black|": 52102549045550, "Brown|": 52102549078318, "Chocolate|": 52102549111086, "Fire Red|": 52102549143854, "Ice Blue|": 52102549176622, "Titanium|": 52102549209390, "Green|": 52102549242158, "Purple|": 52102549274926, "Orange|": 52102549307694, "Ruby|": 52102549340462, "Pink|": 52102549373230, "Yellow|": 52102549405998, "White|": 52102549438766}};
window.__WL_BT_ADDON["walleva-replacement-lenses-for-oakley-racing-jacket-vented"]={"pctOff": 70, "boltHandle": "walleva-thru-bolt-set-for-oakley-jawbone-racing-jacket-split-jacket", "colors": [{"n": "Black", "h": "#898989"}, {"n": "Brown", "h": "#635157"}, {"n": "Chocolate", "h": "#4a2c17"}, {"n": "Fire Red", "h": "#980531"}, {"n": "Ice Blue", "h": "#142aae"}, {"n": "Titanium", "h": "#a6a5a5"}, {"n": "Green", "h": "#318671"}, {"n": "Purple", "h": "#422871"}, {"n": "Orange", "h": "#bd4d00"}, {"n": "Ruby", "h": "#9b123c"}, {"n": "Pink", "h": "#b0417d"}, {"n": "Yellow", "h": "#c0b400"}, {"n": "White", "h": "#f5f5f5"}], "vmap": {"Black|": 52102549045550, "Brown|": 52102549078318, "Chocolate|": 52102549111086, "Fire Red|": 52102549143854, "Ice Blue|": 52102549176622, "Titanium|": 52102549209390, "Green|": 52102549242158, "Purple|": 52102549274926, "Orange|": 52102549307694, "Ruby|": 52102549340462, "Pink|": 52102549373230, "Yellow|": 52102549405998, "White|": 52102549438766}};
window.__WL_BT_ADDON["walleva-replacement-lenses-for-oakley-racing-jacket"]={"pctOff": 70, "boltHandle": "walleva-thru-bolt-set-for-oakley-jawbone-racing-jacket-split-jacket", "colors": [{"n": "Black", "h": "#898989"}, {"n": "Brown", "h": "#635157"}, {"n": "Chocolate", "h": "#4a2c17"}, {"n": "Fire Red", "h": "#980531"}, {"n": "Ice Blue", "h": "#142aae"}, {"n": "Titanium", "h": "#a6a5a5"}, {"n": "Green", "h": "#318671"}, {"n": "Purple", "h": "#422871"}, {"n": "Orange", "h": "#bd4d00"}, {"n": "Ruby", "h": "#9b123c"}, {"n": "Pink", "h": "#b0417d"}, {"n": "Yellow", "h": "#c0b400"}, {"n": "White", "h": "#f5f5f5"}], "vmap": {"Black|": 52102549045550, "Brown|": 52102549078318, "Chocolate|": 52102549111086, "Fire Red|": 52102549143854, "Ice Blue|": 52102549176622, "Titanium|": 52102549209390, "Green|": 52102549242158, "Purple|": 52102549274926, "Orange|": 52102549307694, "Ruby|": 52102549340462, "Pink|": 52102549373230, "Yellow|": 52102549405998, "White|": 52102549438766}};
window.__WL_BT_ADDON["walleva-replacement-lenses-for-oakley-jawbone-vented"]={"pctOff": 70, "boltHandle": "walleva-thru-bolt-set-for-oakley-jawbone-racing-jacket-split-jacket", "colors": [{"n": "Black", "h": "#898989"}, {"n": "Brown", "h": "#635157"}, {"n": "Chocolate", "h": "#4a2c17"}, {"n": "Fire Red", "h": "#980531"}, {"n": "Ice Blue", "h": "#142aae"}, {"n": "Titanium", "h": "#a6a5a5"}, {"n": "Green", "h": "#318671"}, {"n": "Purple", "h": "#422871"}, {"n": "Orange", "h": "#bd4d00"}, {"n": "Ruby", "h": "#9b123c"}, {"n": "Pink", "h": "#b0417d"}, {"n": "Yellow", "h": "#c0b400"}, {"n": "White", "h": "#f5f5f5"}], "vmap": {"Black|": 52102549045550, "Brown|": 52102549078318, "Chocolate|": 52102549111086, "Fire Red|": 52102549143854, "Ice Blue|": 52102549176622, "Titanium|": 52102549209390, "Green|": 52102549242158, "Purple|": 52102549274926, "Orange|": 52102549307694, "Ruby|": 52102549340462, "Pink|": 52102549373230, "Yellow|": 52102549405998, "White|": 52102549438766}};
window.__WL_BT_ADDON["walleva-replacement-lenses-for-oakley-jawbone"]={"pctOff": 70, "boltHandle": "walleva-thru-bolt-set-for-oakley-jawbone-racing-jacket-split-jacket", "colors": [{"n": "Black", "h": "#898989"}, {"n": "Brown", "h": "#635157"}, {"n": "Chocolate", "h": "#4a2c17"}, {"n": "Fire Red", "h": "#980531"}, {"n": "Ice Blue", "h": "#142aae"}, {"n": "Titanium", "h": "#a6a5a5"}, {"n": "Green", "h": "#318671"}, {"n": "Purple", "h": "#422871"}, {"n": "Orange", "h": "#bd4d00"}, {"n": "Ruby", "h": "#9b123c"}, {"n": "Pink", "h": "#b0417d"}, {"n": "Yellow", "h": "#c0b400"}, {"n": "White", "h": "#f5f5f5"}], "vmap": {"Black|": 52102549045550, "Brown|": 52102549078318, "Chocolate|": 52102549111086, "Fire Red|": 52102549143854, "Ice Blue|": 52102549176622, "Titanium|": 52102549209390, "Green|": 52102549242158, "Purple|": 52102549274926, "Orange|": 52102549307694, "Ruby|": 52102549340462, "Pink|": 52102549373230, "Yellow|": 52102549405998, "White|": 52102549438766}};














// ██ WALLEVA CUSTOM — bolt-set add-on (lens pages) ██
// Offers the WT001 Thru Bolt Set at 70% off as a one-click add-on on Jawbone/Racing Jacket/Split Jacket lens pages.
// 70% off applied by the automatic BXGY "Bolt Set 70% off with Lenses" discount at checkout.
// Per-lens config lives in window.__WL_BT_ADDON (set by add_lens_bolt_addon.py).
(function(){'use strict';try{
  var ADDON=window.__WL_BT_ADDON||{};
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  var cfg=ADDON[handle]; if(!cfg) return;
  var pct=cfg.pctOff||0, boltUrl='/products/'+cfg.boltHandle;
  var sel=cfg.colors[0].n;
  var priceMap={};
  function money(n){ return '$'+(Math.round(n*100)/100).toFixed(2); }
  function vid(){ return cfg.vmap[sel+'|']; }
  function link(){ return '<a href="'+boltUrl+'" target="_blank" class="wl-bt__lnk">See all colors &rarr;</a>'; }
  function swHtml(o){
    return '<button type="button" class="wl-bt__sw" data-n="'+o.n+'" title="'+o.n+'" aria-label="'+o.n+'" style="background:'+o.h+'"></button>';
  }
  function go(){
    document.querySelectorAll('[data-section-type="product"]').forEach(function(c){
      if(c.querySelector('.wl-bt')) return;
      var pay=c.querySelector('.payment-buttons,.product-form__buttons,[data-buy-buttons]');
      var anchor=pay?(pay.closest('.product-block')||pay):null;
      if(!anchor){ var price=c.querySelector('.product__price,[data-product-price],.price__regular,.price'); anchor=price?(price.closest('.product-block')||price):null; }
      if(!anchor) return;
      var sw=cfg.colors.map(function(o){return swHtml(o);}).join('');
      var box=document.createElement('div'); box.className='wl-bt';
      box.innerHTML='<div class="wl-bt__top"><span class="wl-bt__tag">&minus;'+pct+'%</span><div><div class="wl-bt__t">Add a matching Thru Bolt Set</div>'
        +'<div class="wl-bt__s">Get '+pct+'% off when ordered with your lenses. '+link()+'</div></div></div>'
        +'<div class="wl-bt__row"><span class="wl-bt__lab">Color: <b class="wl-bt__cn">'+sel+'</b></span>'
        +'<span class="wl-bt__sws">'+sw+'</span></div>'
        +'<div class="wl-bt__row"><button type="button" class="wl-bt__add">Add Thru Bolt Set</button></div>'
        +'<div class="wl-bt__msg" hidden></div>';
      anchor.insertAdjacentElement('afterend', box);
      var cn=box.querySelector('.wl-bt__cn'), msg=box.querySelector('.wl-bt__msg'), subEl=box.querySelector('.wl-bt__s'), addBtn=box.querySelector('.wl-bt__add');
      var sws=box.querySelector('.wl-bt__sws');
      sws.querySelectorAll('.wl-bt__sw').forEach(function(b){ if(b.getAttribute('data-n')===sel) b.classList.add('is-sel'); });
      function refresh(){
        if(cn) cn.textContent=sel;
        var v=vid(), valid=!!v, p=valid?priceMap[v]:null;
        addBtn.disabled=!valid;
        if(p!=null){
          var fin=Math.max(0,p*(1-pct/100));
          subEl.innerHTML='Normally '+money(p)+' &mdash; just <strong>'+money(fin)+'</strong> with your lenses ('+pct+'% off). '+link();
          addBtn.textContent='Add for '+money(fin);
        } else { addBtn.textContent='Add Thru Bolt Set'; }
      }
      fetch(boltUrl+'.js').then(function(r){return r.json();}).then(function(p){
        (p.variants||[]).forEach(function(v){ priceMap[v.id]=(v.price||0)/100; }); refresh();
      }).catch(function(){});
      sws.querySelectorAll('.wl-bt__sw').forEach(function(b){ b.addEventListener('click',function(){
        sws.querySelectorAll('.wl-bt__sw').forEach(function(x){x.classList.remove('is-sel');});
        b.classList.add('is-sel'); sel=b.getAttribute('data-n'); refresh();
      });});
      addBtn.addEventListener('click',function(){
        var v=vid(); if(!v) return;
        var btn=this; btn.disabled=true; var old=btn.textContent; btn.textContent='Adding…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v,quantity:1}]})})
        .then(function(r){return r.json();}).then(function(){
          btn.textContent='Added ✓'; msg.hidden=false;
          msg.textContent='Thru Bolt Set added — '+pct+'% off applies with your lenses in the cart.';
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(function(){btn.disabled=false; btn.textContent=old;},2600);
        }).catch(function(){ btn.disabled=false; btn.textContent=old; msg.hidden=false; msg.textContent='Could not add — please try again.'; });
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();


// ██ WALLEVA — Lens Guide article links in Materials & Care ██
(function(){'use strict';try{
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  if(!(handle.indexOf('replacement')>-1 && handle.indexOf('lenses')>-1)) return;
var LINKS=[
    ['What are polarized lenses?','/blogs/lens-guide/what-are-polarized-lenses'],
    ['What are photochromic lenses?','/blogs/lens-guide/what-are-photochromic-lenses'],
    ['UV protection (UVA, UVB & UVC)','/blogs/lens-guide/uv-protection'],
    ['Taper-corrected, distortion-free vision','/blogs/lens-guide/taper-corrected-lenses'],
    ['Mirror & color coatings','/blogs/lens-guide/mirror-color-coatings'],
    ['Walleva Repel coating','/blogs/lens-guide/walleva-repel-coating'],
    ['How to store your lenses','/blogs/lens-guide/how-to-store-lenses-sunglasses'],
    ['Walleva Eyewear Cleaning Kit','/blogs/lens-guide/walleva-eyewear-cleaning-kit']
  ];
  function inject(){
    var btns=document.querySelectorAll('.collapsible-trigger');
    for(var i=0;i<btns.length;i++){
      if((btns[i].textContent||'').trim().toLowerCase().indexOf('materials')===0){
        var c=btns[i].nextElementSibling; if(!c) return;
        if(c.querySelector('.wl-lg-links')) return;
        var box=document.createElement('div'); box.className='wl-lg-links';
        box.style.cssText='margin-top:14px;padding-top:12px;border-top:1px solid #e0dfdf;font-size:14px;line-height:1.6;';
        var lis=LINKS.map(function(o){return '<li style="margin:3px 0;"><a href="'+o[1]+'">'+o[0]+'</a></li>';}).join('');
        box.innerHTML='<div style="font-weight:700;margin-bottom:6px;">📚 Learn more about your lenses</div><ul style="margin:0;padding-left:18px;">'+lis+'</ul>';
        c.appendChild(box); return;
      }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',inject); else inject();
  document.addEventListener('shopify:section:load',inject);
}catch(e){}})();


// ██ WALLEVA CUSTOM — collection: hide out-of-stock by default ██
(function(){
  try {
    if (!window.location.pathname.startsWith('/collections/')) return;
    var sp = new URLSearchParams(window.location.search);
    // If availability filter already set, leave it alone
    if (sp.has('filter.v.availability')) return;
    // Apply availability=1 (in stock only), preserve sort_by if present
    sp.set('filter.v.availability', '1');
    var newUrl = window.location.pathname + '?' + sp.toString();
    window.location.replace(newUrl);
  } catch(e) {}
})();


// ██ WALLEVA CUSTOM — collection: hide out-of-stock by default ██
(function(){
  try {
    if (!window.location.pathname.startsWith('/collections/')) return;
    var sp = new URLSearchParams(window.location.search);
    if (sp.has('filter.v.availability')) return;
    sp.set('filter.v.availability', '1');
    window.location.replace(window.location.pathname + '?' + sp.toString());
  } catch(e) {}
})();











// ██ WALLEVA CUSTOM — rubber-kit add-on (lens pages) ██
// Offer = % OFF the kit, matching the Shopify automatic BXGY "Rubber Kit 70% off with any Lenses".
// Final price is computed from the LIVE kit price, so nothing here changes when prices change.
// Per-lens config (pctOff/kitHandle/colors) lives in window.__WL_RK_ADDON (set by add_lens_rubber_addon.py).
// A handle's value can be a single config object (legacy, most handles) OR an array of configs
// (multiple independent kits on one lens page, e.g. earsocks + nose pads sold separately).
(function(){'use strict';try{
  var ADDON=window.__WL_RK_ADDON||{};
  var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
  var raw=ADDON[handle]; if(!raw) return;
  var cfgs=Array.isArray(raw)?raw:[raw]; if(!cfgs.length) return;
  function money(n){ return '$'+(Math.round(n*100)/100).toFixed(2); }
  function swHtml(o,noneTitle){
    if((o.h||'')==='none'||(o.n||'').toLowerCase()==='none') return '<button type="button" class="wl-rk__sw wl-rk__sw--none" data-n="'+o.n+'" title="'+(noneTitle||'None')+'">none</button>';
    return '<button type="button" class="wl-rk__sw" data-n="'+o.n+'" title="'+o.n+'" aria-label="'+o.n+'" style="background:'+o.h+'"></button>';
  }
  function noneLast(arr){ return arr.slice().sort(function(a,b){return ((a.n||'').toLowerCase()==='none'?1:0)-((b.n||'').toLowerCase()==='none'?1:0);}); }
  function buildBox(cfg, afterEl){
    var pct=cfg.pctOff, kitUrl='/products/'+cfg.kitHandle, hasNP=!!cfg.opt2;
    var kindLabel=cfg.kind||'';
    var firstReal=(cfg.colors.filter(function(c){return (c.n||'').toLowerCase()!=='none';})[0]||cfg.colors[0]);
    var sel1=firstReal.n, sel2=hasNP?'None':'';
    var priceMap={};
    function link(){ return '<a href="'+kitUrl+'" target="_blank" style="color:#8a4b00;text-decoration:underline;">See the kit &rarr;</a>'; }
    function vid(){ return cfg.vmap[sel1+'|'+sel2]; }
    var lab1=hasNP?'Earsocks':'Color';
    var sw=noneLast(cfg.colors).map(function(o){return swHtml(o,'No earsocks (nose pad only)');}).join('');
    var np='';
    if(hasNP){
      np='<div class="wl-rk__row"><span class="wl-rk__lab">'+cfg.opt2.name+': <b class="wl-rk__nn">'+sel2+'</b></span><span class="wl-rk__sws" data-opt="2">'+
         noneLast(cfg.opt2.values).map(function(o){return swHtml(o,'No nose pad (earsocks only)');}).join('')+'</span></div>';
    }
    var titleText = kindLabel ? ('Add matching '+kindLabel) : (cfg.contents ? ('Add a matching rubber kit ('+cfg.contents+')') : 'Add a matching rubber kit');
    var addLabel = kindLabel ? ('Add '+kindLabel.toLowerCase()) : 'Add rubber kit';
    var imgMap={};
    var box=document.createElement('div'); box.className='wl-rk'; box.setAttribute('data-kit', cfg.kitHandle); box.style.position='relative';
    box.innerHTML='<div class="wl-rk__top"><span class="wl-rk__tag">&minus;'+pct+'%</span><div><div class="wl-rk__t">'+titleText+'</div><div class="wl-rk__s">Get '+pct+'% off a rubber kit with your lenses — one kit per pair (extra kits stay full price). '+link()+'</div></div></div>'+
      '<div class="wl-rk__row"><span class="wl-rk__lab">'+lab1+': <b class="wl-rk__cn">'+sel1+'</b></span><span class="wl-rk__sws" data-opt="1">'+sw+'</span></div>'+
      np+
      '<div class="wl-rk__row"><button type="button" class="wl-rk__add">'+addLabel+'</button></div>'+
      '<div class="wl-rk__msg" hidden></div>'+
      '<img class="wl-rk__preview" alt="" style="display:none;position:absolute;z-index:5;width:64px;height:64px;object-fit:cover;border-radius:8px;border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.25);pointer-events:none;">';
    afterEl.insertAdjacentElement('afterend', box);
    var cn=box.querySelector('.wl-rk__cn'), nn=box.querySelector('.wl-rk__nn'), msg=box.querySelector('.wl-rk__msg'), subEl=box.querySelector('.wl-rk__s'), addBtn=box.querySelector('.wl-rk__add');
    var preview=box.querySelector('.wl-rk__preview');
    function showPreview(btn, vId){
      var src=imgMap[vId]; if(!src||!preview) return;
      var r=btn.getBoundingClientRect(), br=box.getBoundingClientRect();
      preview.src=src;
      preview.style.left=Math.max(0,r.left-br.left)+'px';
      preview.style.top=(r.top-br.top-72)+'px';
      preview.style.display='block';
    }
    function hidePreview(){ if(preview) preview.style.display='none'; }
    var sws1=box.querySelector('.wl-rk__sws[data-opt="1"]'), sws2=box.querySelector('.wl-rk__sws[data-opt="2"]');
    sws1.querySelectorAll('.wl-rk__sw').forEach(function(b){ if(b.getAttribute('data-n')===sel1) b.classList.add('is-sel'); });
    if(sws2) sws2.querySelectorAll('.wl-rk__sw').forEach(function(b){ if(b.getAttribute('data-n')===sel2) b.classList.add('is-sel'); });
    function refresh(){
      if(cn) cn.textContent=sel1; if(nn) nn.textContent=sel2;
      var v=vid(), valid=!!v, p=valid?priceMap[v]:null;
      addBtn.disabled=!valid;
      if(p!=null){ var fin=Math.max(0,p*(1-pct/100));
        subEl.innerHTML='Normally '+money(p)+' &mdash; just <strong>'+money(fin)+'</strong> with your lenses ('+pct+'% off). One kit per pair; extras full price. '+link();
        addBtn.textContent='Add for '+money(fin);
      } else { addBtn.textContent= valid?addLabel:'Pick earsocks or nose pad'; }
    }
    fetch(kitUrl+'.js').then(function(r){return r.json();}).then(function(p){
      (p.variants||[]).forEach(function(v){ priceMap[v.id]=(v.price||0)/100; if(v.featured_image&&v.featured_image.src) imgMap[v.id]=v.featured_image.src; }); refresh();
    }).catch(function(){});
    sws1.querySelectorAll('.wl-rk__sw').forEach(function(b){ b.addEventListener('click',function(){
      sws1.querySelectorAll('.wl-rk__sw').forEach(function(x){x.classList.remove('is-sel');});
      b.classList.add('is-sel'); sel1=b.getAttribute('data-n'); refresh();
    }); b.addEventListener('mouseenter',function(){ showPreview(b, cfg.vmap[b.getAttribute('data-n')+'|'+sel2]); }); b.addEventListener('mouseleave',hidePreview); });
    if(sws2){ sws2.querySelectorAll('.wl-rk__sw').forEach(function(b){ b.addEventListener('click',function(){
      sws2.querySelectorAll('.wl-rk__sw').forEach(function(x){x.classList.remove('is-sel');});
      b.classList.add('is-sel'); sel2=b.getAttribute('data-n'); refresh();
    }); b.addEventListener('mouseenter',function(){ showPreview(b, cfg.vmap['None|'+b.getAttribute('data-n')]); }); b.addEventListener('mouseleave',hidePreview); }); }
    addBtn.addEventListener('click',function(){
      var v=vid(); if(!v) return;
      var btn=this; btn.disabled=true; var old=btn.textContent; btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v,quantity:1}]})})
      .then(function(r){return r.json();}).then(function(){
        btn.textContent='Added ✓'; msg.hidden=false;
        msg.textContent=(kindLabel||'Rubber kit')+' added — '+pct+'% off applies with your lenses in the cart.';
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(function(){btn.disabled=false; btn.textContent=old;},2600);
      }).catch(function(){ btn.disabled=false; btn.textContent=old; msg.hidden=false; msg.textContent='Sorry, could not add — please try again.'; });
    });
    return box;
  }
  function go(){
    document.querySelectorAll('[data-section-type="product"]').forEach(function(c){
      var existingKits={}; c.querySelectorAll('.wl-rk[data-kit]').forEach(function(b){existingKits[b.getAttribute('data-kit')]=true;});
      var pay=c.querySelector('.payment-buttons,.product-form__buttons,[data-buy-buttons]');
      var anchor=pay?(pay.closest('.product-block')||pay):null;
      if(!anchor){ var price=c.querySelector('.product__price,[data-product-price],.price__regular,.price'); anchor=price?(price.closest('.product-block')||price):null; }
      if(!anchor) return;
      var lastEl=anchor;
      cfgs.forEach(function(cfg){
        if(existingKits[cfg.kitHandle]) return;
        lastEl=buildBox(cfg, lastEl);
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
}catch(e){}})();

/* >>> walleva-transition-note */
/* walleva-transition-note (商品部 2026-10-22): when a shopper picks the Transition (photochromic) colour, explain what the
   lens really does. 3 of 10 low reviews and repeat "not transition" returns came from expecting a clear-to-dark lens. */
(function () {
  var TEXT = '<strong>How our Transition lenses work</strong>' +
    '<ul style="margin:.4em 0 0 1.1em;padding:0;">' +
    '<li>These are polarized sunglass lenses: light grey indoors (about 40% light through), dark grey in direct sun (about 12%). They never turn fully clear.</li>' +
    '<li>They react to UV light, so they change little behind a car windshield, on cloudy days or in the shade, and darken less in hot weather.</li>' +
    '<li>To see the change, step into direct sun for a minute and compare with a lens kept indoors.</li>' +
    '</ul>';
  function picked() {
    var r = document.querySelector('input[type=radio][name="Color"]:checked');
    return r && /transition/i.test(r.value);
  }
  function box() {
    var b = document.getElementById('wl-transition-note');
    if (b) return b;
    var anchor = document.querySelector('input[type=radio][name="Color"]');
    var wrap = anchor && (anchor.closest('.variant-wrapper') || anchor.closest('fieldset') || anchor.parentElement.parentElement);
    if (!wrap) return null;
    b = document.createElement('div');
    b.id = 'wl-transition-note';
    b.style.cssText = 'display:none;margin:10px 0 4px;padding:10px 12px;border:1px solid #d8d8d8;border-radius:6px;background:#f7f7f7;font-size:14px;line-height:1.45;color:#333;';
    b.innerHTML = TEXT;
    wrap.parentNode.insertBefore(b, wrap.nextSibling);
    return b;
  }
  function update() {
    var b = box();
    if (b) b.style.display = picked() ? 'block' : 'none';
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'Color') update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();
/* <<< walleva-transition-note */
/*WL-RX-START*/
(function(){
  var RX={"walleva-replacement-lenses-for-oakley-badman": "Oakley Badman", "walleva-replacement-lenses-for-oakley-carbon-blade": "Oakley Carbon Blade", "walleva-replacement-lenses-for-oakley-catalyst": "Oakley Catalyst", "walleva-replacement-lenses-for-oakley-fast-jacket-xl": "Oakley Fast Jacket XL", "walleva-replacement-lenses-for-oakley-fives-squared": "Oakley Fives Squared", "walleva-replacement-lenses-for-oakley-flak-2-0-xl": "Oakley Flak 2.0 XL", "walleva-replacement-lenses-for-oakley-flak-draft": "Oakley Flak Draft", "walleva-replacement-lenses-for-oakley-flak-jacket": "Oakley Flak Jacket", "walleva-replacement-lenses-for-oakley-fuel-cell": "Oakley Fuel Cell", "walleva-replacement-lenses-for-oakley-gascan": "Oakley Gascan", "walleva-replacement-lenses-for-oakley-half-jacket-2-0-xl": "Oakley Half Jacket 2.0 XL", "walleva-replacement-lenses-for-oakley-half-jacket-xlj": "Oakley Half Jacket XLJ", "walleva-replacement-lenses-for-oakley-hijinx": "Oakley Hijinx", "walleva-replacement-lenses-for-oakley-holbrook": "Oakley Holbrook", "walleva-replacement-lenses-for-oakley-holbrook-xl": "Oakley Holbrook XL", "walleva-replacement-lenses-for-oakley-jawbone": "Oakley Jawbone", "walleva-replacement-lenses-for-oakley-jupiter-squared": "Oakley Jupiter Squared", "walleva-replacement-lenses-for-oakley-straight-jacket": "Oakley New Straight Jacket II", "walleva-replacement-lenses-for-oakley-quarter-jacket": "Oakley Quarter Jacket", "walleva-replacement-lenses-for-oakley-racing-jacket": "Oakley Racing Jacket", "walleva-replacement-lenses-for-oakley-radar-ev-path": "Oakley Radar EV Path", "walleva-replacement-lenses-for-oakley-shocktube": "Oakley SI Shocktube", "walleva-replacement-lenses-for-oakley-sliver-r": "Oakley Sliver R", "walleva-replacement-lenses-for-oakley-split-shot": "Oakley Split Shot", "walleva-replacement-lenses-for-oakley-turbine": "Oakley Turbine", "walleva-replacement-lenses-for-oakley-new-valve": "Oakley Valve", "walleva-replacement-lenses-for-ray-ban-aviator-rb3025-62mm": "Ray-Ban Aviator RB3025 62mm"}, N=27, PAGE='/pages/prescription-lenses';
  var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
  var h=m[1]; if(h.indexOf('walleva-replacement-lenses-for-')!==0 || /multi-pack-lot/.test(h)) return;
  var css='.wl-rx{margin:12px 0;padding:12px 14px;border:1px solid #d8dee4;border-radius:8px;background:#f7f9fb;font-size:14px;line-height:1.45}'+
          '.wl-rx b{display:block;margin-bottom:3px}.wl-rx a{display:inline-block;margin-top:6px;font-weight:600;text-decoration:underline}'+
          '.wl-rx-q{display:block;margin-top:6px;font-size:13px;color:#5b6770}.wl-rx-q a{margin-top:0}';
  // Shelly 10-27: a line under both texts - ask us before ordering
  var Q='<span class="wl-rx-q">Questions? <a href="mailto:cs@walleva.com">Contact us</a> before you order prescription lenses</span>';
  function put(){
    if(document.querySelector('.wl-rx')) return true;
    var anchor=document.querySelector('.wl-kf')||document.querySelector('.payment-buttons');
    if(!anchor) return false;
    anchor=anchor.classList&&anchor.classList.contains('wl-kf')?anchor:(anchor.closest('.product-block')||anchor);
    var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
    var d=document.createElement('div'); d.className='wl-rx'; var f=RX[h];
    d.innerHTML=f?'<b>Prescription lenses for this frame</b>We also make custom prescription (nearsighted) lenses for the '+f+
      ' &mdash; SPH + CYL combined up to &minus;6.00.<br><a href="'+PAGE+'?frame='+encodeURIComponent(f)+'">Order prescription lenses &rsaquo;</a>'+Q
      :'<b>Need prescription lenses?</b>We make custom prescription (nearsighted) lenses for '+N+' popular frames.<br><a href="'+PAGE+'">See if your frame is on the list &rsaquo;</a>'+Q;
    anchor.insertAdjacentElement('afterend', d); return true;
  }
  var n=0, t=setInterval(function(){ if(put()||++n>40) clearInterval(t); }, 250);
})();
/*WL-RX-END*/
/*WL-FIND-START*/
(function(){
  var LIVE=true; if(!LIVE && location.search.indexOf('wlprev=1')<0) return;
  var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m || m[1].indexOf('walleva-replacement-lenses-for-')!==0) return;
  // 凤楼 10-27 (rejected v2): no extra box - the page already has its fit warning; make it clickable and do not say "model"
  // (a name like Flak Jacket or a code like 12-278? and not every frame has it printed): one line linking to the finder,
  // which takes a name, a code or a photo. Pages without a fit warning get the same line above Key Features.
  var css='.wl-find{display:block;margin:8px 0 0;font-size:14px;font-weight:600}.wl-find a{text-decoration:underline}'+
          '.wl-find--alone{margin:10px 0}.rte .wl-activity{display:none!important}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  function put(){
    if(document.querySelector('.wl-find')) return true;
    var fw=document.querySelector('.product-block .wl-fw, .wl-fw:not(.wl-fw__src)');
    var kf=document.querySelector('.wl-kf');
    if(!fw && !kf) return false;
    var d=document.createElement(fw?'span':'div'); d.className='wl-find'+(fw?'':' wl-find--alone');
    d.innerHTML='Not sure which frame you have? <a href="/pages/find-your-model">Find it by name, code or photo &rsaquo;</a>';
    if(fw) fw.appendChild(d); else kf.insertAdjacentElement('beforebegin', d);
    return true;
  }
  var n=0, t=setInterval(function(){ if(put()||++n>40) clearInterval(t); }, 250);
})();
/*WL-FIND-END*/

/*WL-CART-UP-START*/
/* Cart suggestions (凤楼 10-30): shows the offers the shop already has, in the cart. No new discount: the kit's 70% is the
   existing "rubber kit with any lenses" discount, the 2-pair line is the existing volume discount. */
(function(){
  var ID='wl-cu';
  var st=document.createElement('style');
  st.textContent='.wl-cu{margin:12px 0 4px;padding:11px 12px;border:1px solid #f0c98a;border-radius:10px;background:#fff8ee;font-size:13px;line-height:1.35;color:#5a3000}'+
    '.wl-cu__t{font-weight:700;margin-bottom:6px}.wl-cu__r{display:flex;gap:8px;align-items:center;flex-wrap:wrap}'+
    '.wl-cu select{flex:1 1 120px;min-width:0;padding:5px 6px;font-size:13px;border:1px solid #e0c9a4;border-radius:6px;background:#fff;color:#333}'+
    '.wl-cu button{padding:6px 12px;font-size:13px;font-weight:700;border:0;border-radius:6px;background:#8a4b00;color:#fff;cursor:pointer}'+
    '.wl-cu button[disabled]{opacity:.6;cursor:default}.wl-cu__pr s{opacity:.6;margin-right:4px}'+
    '.wl-cu__two{margin-top:8px;padding-top:8px;border-top:1px dashed #e8d3ae}.wl-cu__two:first-child{margin-top:0;padding-top:0;border-top:0}.wl-cu a{color:#8a4b00;text-decoration:underline}';
  document.head.appendChild(st);
  var isLens=function(i){return /replacement.*lenses/.test(i.handle||'')};
  var money=function(c){return '$'+(c/100).toFixed(2)};
  var esc=function(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;')};
  function targets(){return [].slice.call(document.querySelectorAll('#CartDrawer [data-products], form.cart [data-products], #CartPageForm [data-products]'))}
  function clear(){[].forEach.call(document.querySelectorAll('.'+ID),function(e){e.remove()})}
  function kitFor(handle){var c=(window.__WL_RK_ADDON||{})[handle];if(Array.isArray(c))c=c[0];return c&&c.kitHandle?c:null}
  var busy=false,again=false;
  function refresh(){
    if(busy){again=true;return}
    if(!targets().length)return;
    busy=true;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var lenses=cart.items.filter(isLens),qty=lenses.reduce(function(s,i){return s+i.quantity},0);
      if(!qty){clear();return null}
      var first=lenses[0],cfg=null;
      lenses.some(function(i){cfg=kitFor(i.handle);return !!cfg});
      if(cfg&&cart.items.some(function(i){return i.handle===cfg.kitHandle}))cfg=null;
      var two=qty===1?{url:first.url.split('?')[0],title:first.product_title}:null;
      if(!cfg)return {two:two};
      return fetch('/products/'+cfg.kitHandle+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
        var vs=p?p.variants.filter(function(v){return v.available}):[];
        return {two:two,kit:vs.length?{p:p,vs:vs,pct:cfg.pctOff||70,kind:cfg.kind||'Rubber Kit'}:null};
      });
    }).then(function(d){
      clear();
      if(!d||(!d.kit&&!d.two))return;
      targets().forEach(function(t){
        var b=document.createElement('div');b.className=ID;var h='';
        if(d.kit){
          var v0=d.kit.vs[0],opts=d.kit.vs.length>1?'<select aria-label="Color">'+d.kit.vs.map(function(v){return '<option value="'+v.id+'" data-p="'+v.price+'">'+esc(v.title)+'</option>'}).join('')+'</select>':'<input type="hidden" value="'+v0.id+'">';
          h+='<div class="wl-cu__t">Add a matching '+esc(d.kit.kind.toLowerCase())+' &mdash; '+d.kit.pct+'% off with your lenses</div>'+
             '<div class="wl-cu__r">'+opts+'<span class="wl-cu__pr"><s>'+money(v0.price)+'</s><b>'+money(Math.round(v0.price*(100-d.kit.pct)/100))+'</b></span><button type="button">Add</button></div>';
        }
        if(d.two)h+='<div class="wl-cu__two"><b>2 pairs 20% off</b> (mix any colors). <a href="'+esc(d.two.url)+'">Add another color</a></div>';
        b.innerHTML=h;t.insertAdjacentElement('afterend',b);
        var btn=b.querySelector('button');if(!btn)return;
        var sel=b.querySelector('select');
        if(sel)sel.addEventListener('change',function(){var p=+sel.options[sel.selectedIndex].getAttribute('data-p');b.querySelector('.wl-cu__pr').innerHTML='<s>'+money(p)+'</s><b>'+money(Math.round(p*(100-d.kit.pct)/100))+'</b>'});
        btn.addEventListener('click',function(){
          var id=(sel||b.querySelector('input')).value;btn.disabled=true;
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})}).then(function(r){
            if(!r.ok)throw 0;
            if(/^\/cart/.test(location.pathname)){location.reload();return}
            document.dispatchEvent(new CustomEvent('cart:build'));
          }).catch(function(){btn.disabled=false});
        });
      });
    }).catch(function(){}).then(function(){busy=false;if(again){again=false;refresh()}});
  }
  var timer;
  function soon(){clearTimeout(timer);timer=setTimeout(refresh,250)}
  function watch(){
    targets().forEach(function(t){if(t.__wlcu)return;t.__wlcu=1;new MutationObserver(soon).observe(t,{childList:true})});
    soon();
  }
  document.addEventListener('cart:updated',soon);document.addEventListener('cart:open',soon);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
})();
/*WL-CART-UP-END*/
